export enum LanguageCode {
	En = 'En',
	Da = 'Da',
}

export const defaultLanguageCode = LanguageCode.Da;

export const languageCodes = Object.values(LanguageCode) as LanguageCode[];

export const isLanguageCode = (code: string): code is LanguageCode => code in LanguageCode;

export const langMap = {Da: {ActivateBiometricLogin_1: (arg0: number | string) => `Aktivér ${arg0.toString()}` as const,
AddComment_1: (arg0: number | string) => `Tilføj kommentar: ${arg0.toString()}` as const,
AddForgottenClockingFor_1: (arg0: number | string) => `Tilføj manglende stempling for ${arg0.toString()}` as const,
AddToXCalendar_1: (arg0: number | string) => `Tilføj til din ${arg0.toString()} kalender` as const,
AndXOtherShifts_1: (arg0: number | string) => `+ ${arg0.toString()} andre vagter.` as const,
BalanceAsOf_1: (arg0: number | string) => `Opgjort pr. ${arg0.toString()}` as const,
BalanceStart_1: (arg0: number | string) => `For at se dine saldi skal du gå frem til din ansættelsesstart ${arg0.toString()}` as const,
BiometricDataNotRecognized_1: (arg0: number | string) => `${arg0.toString()} blev ikke genkendt.` as const,
BiometricLoginCouldNotBeActivated_1: (arg0: number | string) => `${arg0.toString()} kunne ikke aktiveres` as const,
BiometricLoginDisabledGoToSettingsToEnable_1: (arg0: number | string) => `${arg0.toString()} er blevet slået fra i telefonens indstillinger. Gå ind i telefonens indstillinger for at slå det til igen, eller log ind som normalt.` as const,
BiometricLoginExpiredLoginToRenew_1: (arg0: number | string) => `Dit ${arg0.toString()} er udløbet. Log ind som normalt for at forny det.` as const,
BiometricLoginFailedAndWasDeactivated_1: (arg0: number | string) => `${arg0.toString()} fejlede og er blevet deaktiveret.` as const,
BiometricLoginWillBeDisabled_1: (arg0: number | string) => `Bemærk også, at ${arg0.toString()} deaktiveres og skal aktiveres igen.` as const,
CameraConstraintError_1: (arg0: number | string) => `Kamera-krav kan ikke opfyldes (${arg0.toString()}). Prøv uden specifikke begrænsninger.` as const,
CameraStartError_1: (arg0: number | string) => `Kunne ikke starte kamera: ${arg0.toString()}.` as const,
CannotWishThisType_1: (arg0: number | string) => `"${arg0.toString()}" kan ikke ønskes i denne periode` as const,
ChangedToXHasBeenSaved_1: (arg0: number | string) => `Ændringerne for ${arg0.toString()} er blevet gemt.` as const,
ChatWith_1: (arg0: number | string) => `Chat med ${arg0.toString()}` as const,
CheckInAfter_1: (arg0: number | string) => `Du kan først stemple ind efter den ${arg0.toString()}` as const,
ChooseBetweenApplicants_1: (arg0: number | string) => `Vælg mellem ${arg0.toString()} ansøgere` as const,
ClockInTimeEarlierThanLatest_1: (arg0: number | string) => `Din starttid overlapper med en anden stempling, der sluttede kl. ${arg0.toString()}.` as const,
ClockOutTimeEarlierThanLatest_1: (arg0: number | string) => `Din sluttid overlapper med starttidspunktet, som var kl. ${arg0.toString()}.` as const,
ClosedClickToViewOtherDays_1: (arg0: number | string) => `${arg0.toString()} er lukket pga. planlægning. Klik ind for at se andre data` as const,
ColleageStart_1: (arg0: number | string) => `For at se dine kolleger skal du gå frem til din ansættelsesstart ${arg0.toString()}` as const,
ColleagueNothingPlanned_1: (arg0: number | string) => `${arg0.toString()} har ingen planlagte begivenheder i denne uge.` as const,
ColorRoll_1: (arg0: number | string) => `Farv rul ${arg0.toString()}.` as const,
ConfirmCancel_1: (arg0: number | string) => `Vil du afbryde ${arg0.toString()}?` as const,
ConfirmOfferOnShiftExchangeAllAvailable_1: (arg0: number | string) => `Er du sikker på du vil udbyde vagten til alt ledigt personale i de ${arg0.toString()} valgte personalegrupper?` as const,
ConfirmOfferOnShiftExchangeCandidateFilter_1: (arg0: number | string) => `Er du sikker på, du vil udbyde vagten i de ${arg0.toString()} valgte personalegrupper?` as const,
ConfirmReject_1: (arg0: number | string) => `Vil du afvise ${arg0.toString()}?` as const,
ConfirmTake_1: (arg0: number | string) => `Vil du tage ${arg0.toString()}?` as const,
CouldNotRecognizeYourBiometricData_1: (arg0: number | string) => `Vi kunne desværre ikke genkende dit ${arg0.toString()}.` as const,
DeviatingPayerNotificationBody_1: (arg0: number | string) => `Vær opmærksom på at denne vagt er registreret på "${arg0.toString()}".` as const,
DeviatingWorkplacePleaseNote_1: (arg0: number | string) => `Vær opmærksom på, at denne vagt er registreret på "${arg0.toString()}".` as const,
DoYouWantToLoginWithBiometricInTheFuture_1: (arg0: number | string) => `Vil du fremover logge ind med ${arg0.toString()}?` as const,
DownloadingTemplateTotalsFor_1: (arg0: number | string) => `Henter grundplanstotaler for ${arg0.toString()}...` as const,
EnableBiometricLogin_1: (arg0: number | string) => `Slå ${arg0.toString()} til` as const,
EnablingBiometricFailedTryAgain_1: (arg0: number | string) => `Aktivering af ${arg0.toString()} har fejlet for mange gange. Du kan prøve at aktivere det igen senere.` as const,
ErrorCouldNotActivateBiometric_1: (arg0: number | string) => `Der opstod en fejl og vi kunne desværre ikke aktivere ${arg0.toString()}.` as const,
ErrorDoubleColumnOfUniqueKind_1: (arg0: number | string) => `Man kan ikke have 2 kolonner af type '${arg0.toString()}'.` as const,
ErrorNoBrowserSupport_1: (arg0: number | string) => `Browseren understøtter ikke ${arg0.toString()}.` as const,
ExchangeAccepted_1: (arg0: number | string) => `Du har accepteret ${arg0.toString()}` as const,
ExchangeApproved_1: (arg0: number | string) => `Du har godkendt ${arg0.toString()}` as const,
ExchangeCancelled_1: (arg0: number | string) => `Du har fortrudt ${arg0.toString()}` as const,
ExchangeCancelledAlt_1: (arg0: number | string) => `Du har afbrudt ${arg0.toString()}` as const,
ExchangeCreated_1: (arg0: number | string) => `Du har oprettet ${arg0.toString()}` as const,
ExchangeGiveAway_1: (arg0: number | string) => `Du har afgivet ${arg0.toString()}` as const,
ExchangeHandoverErrorToast_1: (arg0: number | string) => `Din vagtafgivelse blev ikke oprettet ${arg0.toString()}.` as const,
ExchangeOffer_1: (arg0: number | string) => `Du har udbudt ${arg0.toString()}` as const,
ExchangeRejected_1: (arg0: number | string) => `Du har afvist ${arg0.toString()}` as const,
ExchangeSwapErrorToast_1: (arg0: number | string) => `Dit bytte blev ikke oprettet ${arg0.toString()}.` as const,
ExchangeSwapSuccessToast_1: (arg0: number | string) => `Din bytteforespørgsel ${arg0.toString()} er nu oprettet.` as const,
ExchangeTaken_1: (arg0: number | string) => `Du har taget ${arg0.toString()}` as const,
ExchangeWhoeverErrorToast_1: (arg0: number | string) => `Dit bytte med 'hvem som helst' er ikke muligt ${arg0.toString()}.` as const,
GamsErrorDuplicatePerson_1: (arg0: number | string) => `${arg0.toString()} optræder mere end én gang` as const,
GroupFunctionMismatch_1: (arg0: number | string) => `Personens personalegruppe (${arg0.toString()}) er ikke tilknyttet funktionen.` as const,
HandoverApproveRejectText_1: (arg0: number | string) => `Vælg den ansøger der skal have ${arg0.toString()}s vagt.` as const,
HandoverOfDefiniteArticle_1: (arg0: number | string) => `afgivelsen af ${arg0.toString()}` as const,
IsNowCreated_1: (arg0: number | string) => `${arg0.toString()} er nu oprettet.` as const,
LoginAsUsualAndEnableItAgain_1: (arg0: number | string) => `Log ind som normalt, og prøv at slå det til igen under menupunktet ${arg0.toString()}.` as const,
LoginWith_1: (arg0: number | string) => `Log ind med ${arg0.toString()}` as const,
MemberOfGroup_1: (arg0: number | string) => `Medlem af gruppen ${arg0.toString()}` as const,
MessageModal_1: (arg0: number | string) => `Som udgangspunkt henter TeamPlan ulæste beskeder for de kommende ${arg0.toString()} dage. Dette inkluderer både chat og interne beskeder.

Har du på siden ‘Overblik’ indlæst vagter der ligger udenfor dette tidsrum, vil denne periodes ulæste beskeder også vises her.` as const,
MessageModalRead_1: (arg0: number | string) => `Som udgangspunkt henter TeamPlan læste beskeder for de kommende ${arg0.toString()} dage. Dette inkluderer både chat og interne beskeder.

Har du på siden ‘Overblik’ indlæst vagter der ligger udenfor dette tidsrum, vil denne periodes læste beskeder også vises her.` as const,
MessageModalUnread_1: (arg0: number | string) => `Som udgangspunkt henter TeamPlan ulæste beskeder for de kommende ${arg0.toString()} dage. Dette inkluderer både chat og interne beskeder.

Har du på siden ‘Overblik’ indlæst vagter der ligger udenfor dette tidsrum, vil denne periodes ulæste beskeder også vises her.` as const,
MessageOutsideEmploymentPeriod_1: (arg0: number | string) => `Du kan skrive en ny besked når din ansættelse starter den ${arg0.toString()}` as const,
MessagesEmptyStateDescription_1: (arg0: number | string) => `Der er ikke modtaget eller sendt nogen beskeder i personalegruppen, der vedrører de kommende ${arg0.toString()} dage.` as const,
MissingSwapGroup_1: (arg0: number | string) => `${arg0.toString()} mangler en byttegruppe` as const,
NothingPlannedBefore_1: (arg0: number | string) => `Der er ikke planlagt noget før din ansættelsesstart den ${arg0.toString()}` as const,
NumApplicantsFromShiftExchange_1: (arg0: number | string) => `${arg0.toString()} ansøgere på vagtbørs` as const,
OfferShiftTo_1: (arg0: number | string) => `Udbyd vagt til ${arg0.toString()}` as const,
OfferShiftToGroups_1: (arg0: number | string) => `Udbyd vagt til ${arg0.toString()} grupper` as const,
PeriodsDialogTitle_1: (arg0: number | string) => `Start- og slutdato for ${arg0.toString()}` as const,
PreferencePatternBodyPart2Future_1: (arg0: number | string) => `Når du angiver nye præferencer i dit præferencemønster - eller laver om i de allerede eksisterende præferencer - gælder ændringerne fra og med den første dag i din ønskeperiode som aktuelt starter den ${arg0.toString()}.
Det er altså fra denne dato at ændringerne kan ses på ønskesiden.` as const,
PreferencePatternChangesFromThisDayApplies_1: (arg0: number | string) => `Ændringer til denne dag gælder fra ${arg0.toString()}` as const,
PreferencePatternDeleteBody_1: (arg0: number | string) => `Er du sikker på at du vil slette dit præferencemønster?

Denne handling vil fjerne mønster-præferencerne på ønskesiden fra og med starten af den nuværende ønskeperiode: ${arg0.toString()}` as const,
ProblemServer_1: (arg0: number | string) => `Beklager, der er et serverproblem (${arg0.toString()}).` as const,
ReceptionOfDefiniteArticle_1: (arg0: number | string) => `modtagelsen af ${arg0.toString()}` as const,
RelationCloseChanged_1: (arg0: number | string) => `${arg0.toString()} er nu angivet som din nære pårørende. Du kan kun have én nær pårørende.` as const,
SelectPeriodSlowWarn_1: (arg0: number | string) => `Du har valgt at vise mere end ${arg0.toString()} uger, det kan være langsomt at arbejde med.` as const,
SelectPeriodTooLong_1: (arg0: number | string) => `Du kan højst vælge ${arg0.toString()} uger.` as const,
SelectTheShift_1: (arg0: number | string) => `Vælg vagten: ${arg0.toString()}` as const,
SetDemandTo_1: (arg0: number | string) => `Sæt behov til ${arg0.toString()}.` as const,
ShiftTypeNotAvailablePleaseNote_1: (arg0: number | string) => `Vær opmærksom på, at du ikke kan skifte tilbage til vagttypen "${arg0.toString()}", da den ikke er tilgængelig for denne personalegruppe.` as const,
SinceTime_1: (arg0: number | string) => `Siden kl. ${arg0.toString()}` as const,
StartingFp_1: (arg0: number | string) => `Starter funktionsplan ${arg0.toString()}...` as const,
SynchronizingNItems_1: (arg0: number | string) => `Overfører ${arg0.toString()} registreringer.` as const,
TemplatePeriodOutOfViewport_1: (arg0: number | string) => `Grundplanens periode (${arg0.toString()}) er udenfor den åbnede periode.` as const,
TemplateValidOnly_1: (arg0: number | string) => `Grundplanen er kun gyldig ${arg0.toString()}.` as const,
TimeWillApplyWeekParityEven_1: (arg0: number | string) => `Tiderne vil gælde for hver ${arg0.toString()} i lige uger.` as const,
TimeWillApplyWeekParityNone_1: (arg0: number | string) => `Tiderne vil gælde for hver ${arg0.toString()}.` as const,
TimeWillApplyWeekParityOdd_1: (arg0: number | string) => `Tiderne vil gælde for hver ${arg0.toString()} i ulige uger.` as const,
ToEnableBiometricLoginEnableItInSettings_1: (arg0: number | string) => `For at bruge ${arg0.toString()} til login i MinPlan, skal du slå det til i telefonens indstillinger.` as const,
UnfollowDialogBody_1: (arg0: number | string) => `Er du sikker på, at du ikke længere vil følge gruppen "${arg0.toString()}"?` as const,
UpdatingInXSeconds_1: (arg0: number | string) => `Opdaterer om ${arg0.toString()} sekunder...` as const,
UpdatingMissingAssignment_1: (arg0: number | string) => `Opdaterer manglende registrering: ${arg0.toString()}` as const,
UseBiometricLogin_1: (arg0: number | string) => `Brug ${arg0.toString()}` as const,
VerifyingNItems_1: (arg0: number | string) => `Behandler ${arg0.toString()} registreringer.` as const,
ViewportLacksDate_1: (arg0: number | string) => `Planen mangler dato: ${arg0.toString()}` as const,
XInsertsTheLink_1: (arg0: number | string) => `${arg0.toString()} indsætter selv linket i kalenderen.` as const,
YesConfirmTake_1: (arg0: number | string) => `Ja, tag ${arg0.toString()}` as const,
YouCanEnableItLaterUnderTheMenu_1: (arg0: number | string) => `Du kan også aktivere det senere inde i menupunktet ${arg0.toString()}.` as const,
YouCannotClockOut_1: (arg0: number | string) => `Du kan tidligst stemple ud, når der er gået 1 minut. Vent venligst til kl. ${arg0.toString()}.` as const,
YouCannotStartBefore_1: (arg0: number | string) => `Du kan først starte kl ${arg0.toString()}.` as const,
YourEmploymentEnded_1: (arg0: number | string) => `Din ansættelse sluttede den ${arg0.toString()}.` as const,
missingRequiredFieldX_1: (arg0: number | string) => `${arg0.toString()} skal udfyldes` as const,
newPasswordNotEnoughCharacterClasses_1: (arg0: number | string) => `Lav en adgangskode som indeholder mindst ${arg0.toString()} ud af 4 typer tegn (små bogstaver, store bogstaver, tal, specialtegn).` as const,
newPasswordTooShort_1: (arg0: number | string) => `Adgangskoden skal være mindst ${arg0.toString()} tegn` as const,
BiometricLoginFailedTooManyTimesAtLogin_2: (arg0: number | string, arg1: number | string) => `${arg0.toString()} har fejlet for mange gange. Log ind som normalt og prøv ${arg1.toString()} igen senere.` as const,
CheckRuleViolationsForNPersonsForPeriod_2: (arg0: number | string, arg1: number | string) => `Tjek arbejdstids- og miljøregler for ${arg0.toString()} personer for ${arg1.toString()}` as const,
ConfirmDeletion_2: (arg0: number | string, arg1: number | string) => `Er du sikker på at du vil slette ${arg0.toString()} "${arg1.toString()}"?` as const,
ConfirmEndAbsence_2: (arg0: number | string, arg1: number | string) => `Er du sikker på at du vil afslutte ${arg0.toString()}s fravær fra og med den ${arg1.toString()}?` as const,
ConfirmRemoveShiftBody_2: (arg0: number | string, arg1: number | string) => `Er du sikker på, at du vil slette "${arg0.toString()}" ${arg1.toString()}` as const,
ConfirmShiftExchangeContent_2: (arg0: number | string, arg1: number | string) => `Er du sikker på, at du vil godkende vagtbytte mellem ${arg0.toString()} og ${arg1.toString()}?` as const,
CopyToXAndKeepY_2: (arg0: number | string, arg1: number | string) => `Kopier til '${arg0.toString()}' og behold ${arg1.toString()}` as const,
DescriptionOperationPlace_2: (arg0: number | string, arg1: number | string) => `Gemmer behov på ${arg0.toString()} d. ${arg1.toString()}.` as const,
EnablingBiometricFailedTryAgainUnderMenuItem_2: (arg0: number | string, arg1: number | string) => `Aktivering af ${arg0.toString()} har fejlet for mange gange. Du kan prøve at aktivere det igen senere inde under menupunktet ${arg1.toString()}.` as const,
EndAbsenceMultiPleaseNote_2: (arg0: number | string, arg1: number | string) => `Vær opmærksom på at du også har afsluttet ${arg0.toString()}s fravær: ${arg1.toString()}` as const,
ErrorInternal_2: (arg0: number | string, arg1: number | string) => `Intern fejl #${arg0.toString()}. ${arg1.toString()}` as const,
FieldLengthExceeded_2: (arg0: number | string, arg1: number | string) => `Feltet '${arg0.toString()}' må højst indeholde ${arg1.toString()} tegn.` as const,
FieldXIsMaxChars_2: (arg0: number | string, arg1: number | string) => `${arg0.toString()} er for lang (maksimum ${arg1.toString()} tegn)` as const,
ImportingKOfN_2: (arg0: number | string, arg1: number | string) => `Importerer ${arg0.toString()} af ${arg1.toString()}` as const,
IsNowAssigned_2: (arg0: number | string, arg1: number | string) => `${arg0.toString()} er nu tildelt ${arg1.toString()}.` as const,
MessagesEmptyStateDescription_2: (arg0: number | string, arg1: number | string) => `Du har ikke modtaget eller sendt nogen ${arg0.toString()}- eller ${arg1.toString()}beskeder` as const,
MoveFromTo_2: (arg0: number | string, arg1: number | string) => `Flyt fra '${arg0.toString()}' til '${arg1.toString()}'` as const,
NoChangesHaveBeenMade_2: (arg0: number | string, arg1: number | string) => `Der er ikke ændret nogen vagter i perioden
${arg0.toString()} - ${arg1.toString()}` as const,
NothingPlannedForGroup_2: (arg0: number | string, arg1: number | string) => `Der er ingen planlagte vagter i perioden
${arg0.toString()} - ${arg1.toString()}` as const,
NothingToTakeActionOn_2: (arg0: number | string, arg1: number | string) => `Der er ingen udeståender i perioden
${arg0.toString()} - ${arg1.toString()}` as const,
OverwritingExistingAssignment_2: (arg0: number | string, arg1: number | string) => `Overskriver eksisterende registrering: ${arg0.toString()} med: ${arg1.toString()}.` as const,
PartialGroupMembership_2: (arg0: number | string, arg1: number | string) => `${arg0.toString()} er ikke medlem af ${arg1.toString()} i hele perioden` as const,
PersonAlreadyAssigned_2: (arg0: number | string, arg1: number | string) => `OBS: ${arg0.toString()} er allerede tilknyttet ${arg1.toString()}` as const,
PersonIsLockedOn_2: (arg0: number | string, arg1: number | string) => `OBS: ${arg0.toString()} er låst på ${arg1.toString()}` as const,
PreferencePatternDate_2: (arg0: number | string, arg1: number | string) => `${arg0.toString()} d. ${arg1.toString()}` as const,
ProcessingDataIOfN_2: (arg0: number | string, arg1: number | string) => `Behandler data (${arg0.toString()}/${arg1.toString()}).` as const,
ReadByXOnY_2: (arg0: number | string, arg1: number | string) => `Læst af ${arg0.toString()} (${arg1.toString()}).` as const,
ReadMessagesEmptyStateDescription_2: (arg0: number | string, arg1: number | string) => `Der er ingen læste beskeder der vedrører perioden ${arg0.toString()} - ${arg1.toString()}` as const,
RegisteredAbsent_2: (arg0: number | string, arg1: number | string) => `Vær opmærksom på at du også har registreret ${arg0.toString()} fraværende: ${arg1.toString()}` as const,
RollLabel_2: (arg0: number | string, arg1: number | string) => `Rul ${arg0.toString()} af ${arg1.toString()}.` as const,
RuleViolationsForNPersonsForPeriod_2: (arg0: number | string, arg1: number | string) => `Brud på arbejdstids- og miljøregler for ${arg0.toString()} personer for ${arg1.toString()}` as const,
SelectPhysicianPlanFor_2: (arg0: number | string, arg1: number | string) => `Vælg funktionsplan for afdeling ${arg0.toString()}, bruger ${arg1.toString()}:` as const,
SinceDateAndTime_2: (arg0: number | string, arg1: number | string) => `Siden ${arg0.toString()} kl. ${arg1.toString()}` as const,
SwapApproveRejectText_2: (arg0: number | string, arg1: number | string) => `${arg0.toString()} og ${arg1.toString()} vil gerne bytte vagt.` as const,
TileCaption_2: (arg0: number | string, arg1: number | string) => `Funktionen ${arg0.toString()} den ${arg1.toString()}` as const,
TileCaptionClosed_2: (arg0: number | string, arg1: number | string) => `Funktionen ${arg0.toString()} den ${arg1.toString()} er lukket` as const,
TileCaptionInvalid_2: (arg0: number | string, arg1: number | string) => `Funktionen ${arg0.toString()} den ${arg1.toString()} er ugyldig` as const,
TileColumnClosed_2: (arg0: number | string, arg1: number | string) => `Funktionen ${arg0.toString()} den ${arg1.toString()} er udenfor kolonnens start- og slutdato` as const,
TransferPlanFromTo_2: (arg0: number | string, arg1: number | string) => `Overfør plan fra ${arg0.toString()} til ${arg1.toString()}` as const,
TryAgainOrEnableUnderMenuItem_2: (arg0: number | string, arg1: number | string) => `Prøv igen eller slå ${arg0.toString()} til under menupunktet ${arg1.toString()}.` as const,
TryToEnableBiometricUnderMenuItem_2: (arg0: number | string, arg1: number | string) => `Prøv at slå ${arg0.toString()} til under menupunktet ${arg1.toString()}.` as const,
UnreadMessagesEmptyStateDescription_2: (arg0: number | string, arg1: number | string) => `Der er ingen ulæste beskeder der vedrører perioden ${arg0.toString()} - ${arg1.toString()}` as const,
ConfirmRemoveShiftBody_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `Er du sikker på, at du vil slette ${arg0.toString()}s vagt "${arg1.toString()}" ${arg2.toString()}` as const,
DescriptionOperationAvatarDelete_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `Slet ${arg0.toString()} fra ${arg1.toString()} d. ${arg2.toString()}.` as const,
DescriptionOperationAvatarRemark_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `Gemmer note for ${arg0.toString()} på ${arg1.toString()} d. ${arg2.toString()}.` as const,
DescriptionOperationKangarooCopyCreate_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `Tilføj rul ${arg0.toString()} til ${arg1.toString()} d. ${arg2.toString()}.` as const,
DescriptionOperationKangarooCopyDelete_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `Slet rul ${arg0.toString()} fra ${arg1.toString()} d. ${arg2.toString()}.` as const,
MessagesEmptyStateDescription_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `Du har ikke modtaget eller sendt nogen ${arg0.toString()}-, ${arg1.toString()}- eller ${arg2.toString()}beskeder` as const,
PersonAlreadyInSomeTemplate_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `Personen er tilknyttet grundplanen ${arg0.toString()}, rul ${arg1.toString()}, i perioden ${arg2.toString()}.` as const,
RangeViolation_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `${arg0.toString()} skal ligge mellem ${arg1.toString()} og ${arg2.toString()}.` as const,
RemoveShiftToast_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `${arg0.toString()}s vagt "${arg1.toString()}" ${arg2.toString()} er nu slettet.` as const,
AboutMeButtonTitleCancel: "Afbryd",
AboutMeButtonTitleSave: "Gem",
AboutMeClearFields: "Ryd felter",
Absence: "Fravær",
AbsenceTooltip: "Opret fraværskolonne",
AbsenceTypeRestOfDayWillBe: "Fraværstype for resten af dagen vil blive",
AbsentColleagues: "Fraværende kolleger",
Accept: "Godkend",
Accepted: "Godkendt",
AccessDenied: "Adgang nægtet. Tjek tilladelser i browseren/Indstillinger.",
Accrued: "Optjent",
ActionsAreRegisteredBody: "Bemærk, at alle handlinger du foretager dig, bliver udført rigtigt i systemet og gemt under dit navn.",
ActionsAreRegisteredTitle: "Du handler nu på vegne af en medarbejder",
Activate: "Aktivér",
Activities: "Aktiviteter",
ActivitiesMightBeDeleted: "Aktiviteter slettes muligvis",
ActivitiesMightBeDeletedPleaseNote: "Vær opmærksom på, at følgende aktiviteter muligvis slettes, hvis de ikke længere dækkes af en vagt:",
ActivitiesWillBeDeleted: "Aktiviteter slettes",
ActivitiesWillBeDeletedPleaseNote: "Vær opmærksom på, at følgende aktiviteter slettes:",
Activity: "Aktivitet",
Add: "Tilføj",
AddCategory: "+ Tilføj kategori",
AddCounter: "+ Tilføj tæller",
AddEndDate: "Tilføj slutdato",
AddForgottenPunching: "Tilføj glemt stempling",
AddFromGroup: "Tilføj fra gruppe",
AddInfo: "Tilføj Information",
AddMissingTime: "Tilføj manglende tid",
AddNewPeriod: "Tilføj ny start- og slutdato",
AddNewTimeRegistration: "Tilføj ny tidsregistrering",
AddNote: "Interne beskeder",
AddPeriod: "Tilføj periode",
AddRule: "Tilføj regl",
AddTemplate: "+ Tilføj grundplan",
AddTotalCounter: "+ Tilføj total-tæller",
Adding: "Tilføjer",
Address: "Adresse",
AdjustDemandDown: "Juster behov ned",
AdjustDemandUp: "Juster behov op",
Alert: "Alert",
All: "Alle",
AllowAccess: "Tillad adgang",
AllowNotifications: "Tillad notifikationer",
And1OtherShift: "+ 1 anden vagt.",
AppSettings: "Appindstillinger",
Applicants: "Ansøgere",
Approve: "Godkend",
ApproveRejectHandover: "Godkend/Afvis overdragelse",
ApproveRejectSwap: "Godkend/Afvis vagtbytte",
ApproveToToday: "Godkend til og med i dag",
ApprovedByPlanner: "Godkendt af planlægger",
ApprovedPeriod: "Godkendt til løn",
AreYouSureYouWantToChangeOrganisation: "Er du sikker på, at du vil skifte organisation?",
AssignFromGroup: "Besæt fra",
AttachSpecialWorkingHoursRemunerations: "Vælg arbejdstider",
AttendanceEmptyDayText: "Du har ingen planlagte vagter at stemple ind på i dag",
AttendanceLeaveEarly: "Vælg en årsag til hvorfor du stempler ud tidligere end det planlagte arbejde.",
AttendanceLeaveLate: "Vælg en årsag til hvorfor du stempler ud senere end det planlagte arbejde.",
AttendanceStartEarly: "Vælg en årsag til hvorfor du stempler ind tidligere end det planlagte arbejde.",
AttendanceStartLate: "Vælg en årsag til hvorfor du stempler ind senere end det planlagte arbejde.",
AttendanceUnplanned: "Vælg en årsag til hvorfor du stempler ind udenfor dine planlagte vagter.",
AutoPlanJobAdding: "Tilføjer autoplanlægningsjob...",
AutoPlanJobStatusValue: "Starter...|Beregner...|Færdig",
AvailableFictivePerson: "Ledig fiktiv person",
AwaitingAnswer: "Afventer svar",
AwaitingAnswerFromOthers: "Afventer svar fra andre",
AwaitingAnswerFromYou: "Afventer svar fra dig",
AwaitingApproveHandover: "Afventer godkendelse af overdragelse",
AwaitingApproveSwap: "Afventer godkendelse af vagtbytte",
AwaitingPlanner: "Afventer planlæggeren",
AwaitingYou: "Afventer dig",
AwaitsRuleCheck: "Afventer regeltjek",
Back: "Tilbage",
Balance: "Balance",
Banked: "Saldo",
BiometricData: "Biometrisk data",
BiometricLogin: "Biometrisk login",
BirthDate: "Fødselsdato",
BirthdateInvalid: "Fødselsdato er ugyldig.",
BlissState: "Pusletilstand",
ButtonLogout: "Log ud",
CalcBalance: "Opg. Bal.",
Calendar: "Kalender",
CalendarLinkCopied: "Kalenderlinket blev kopieret til udklipsholderen",
CalendarLinkNotWorking: "Tidligere kopieret kalenderlink virker ikke længere. Kopier et nyt link, hvis du vil eksportere igen.",
CameraAccessInstructions: "For at scanne din QR-kode skal du give appen tilladelse til kameraet i Indstillinger.",
CameraAccessMissingText: "For at scanne din QR-kode skal du give appen tilladelse til kameraet i Indstillinger.",
CameraAccessMissingTitle: "ClockPoint mangler kameraadgang",
CameraBusyText: "Luk andre apps og prøv igen.",
CameraBusyTitle: "Kameraet kunne ikke startes",
CameraNotWorkingText: "Du kan registrere arbejdstid ved at indtaste dit tjenestenummer.",
CameraNotWorkingTitle: "Kameraet er kunne ikke startes",
Cancel: "Fortryd",
CancelAlt: "Afbryd",
CancelCopyImperative: "Afbryd kopiering",
CancelCutImperative: "Afbryd klipning",
CancelDeputy: "Fortryd tag udbud",
CancelHandover: "Fortryd afgivelse",
CancelOffer: "Afbryd udbud",
CancelRegistration: "Fortryd registrering",
CancelRegistrations: "Fortryd registreringer",
CancelRequest: "Fortryd ønsker",
CancelTakeShift: "Fortryd tag vagt",
Cancelled: "Afbrudt",
CannotBeAnswered: "Kan ikke besvares",
CannotDelete: "Sletning kan ikke foretages.",
CannotPasteHeaderKind: "Du kan kun indsætte i funktioner og fravær.",
CannotPasteHeaderMultifunction: "Du kan kun indsætte i kolonner med én funktion",
CannotScanQRCode: "Kan du ikke scanne din QR kode?",
CantAnswer: "Kan ikke besvares",
CareDays: "Omsorgsdage",
Category: "Kategori",
Cause: "Årsag",
CauseGrainedPlanning: "Grovplanlægning",
ChangeCamera: "Skift kamera",
ChangeLanguage: "Skift sprog",
ChangeOldPassword: "Skift adgangskode",
ChangeOrganization: "Skift organisation",
ChangePasswordForApp: "Skift adgangskode til denne app",
ChangePasswordLabelActivationCode: "Engangskoden",
ChangePasswordLabelNew: "Vælg ny kode",
ChangePasswordLabelRepeat: "Gentag ny kode",
ChangePasswordTitle: "Ny kode",
ChangePersonelGroup: "Skift personalegruppe",
ChangeTeam: "Skift gruppe",
Changes: "Ændringer",
Chat: "Chat",
ChatAndInternalMessages: "Chat og interne beskeder",
ChatEmptyDayMessages: "Ingen beskeder på denne dag",
ChatSendMessage: "Send",
ChatWithEmployee: "Chat med medarbejder",
CheckChangeGroup: "Er du tilmeldt flere personalegrupper, kan du prøve at skifte gruppe og søge igen.",
CheckSpellingForName: "Tjek om du har stavet navnet rigtigt.",
Choose: "Vælg",
ChooseAbsenceForRestOfDay: "Vælg fraværs type for resten af dagen",
ChooseAnOption: "Vælg en af nedenstående muligheder:",
ChooseApplicant: "Vælg ansøger",
ChooseApplicants: "Vælg ansøgere",
ChooseContactFields: "Vælg kontaktoplysninger",
ChooseGroups: "Vælg den eller de personalegrupper du vil udbyde vagten til.",
ChooseMessageOnTheLeft: "Du kan vælge imellem beskederne i venstre side.",
ChooseMessagePeriod: "Vælg perioden hvor noten skal vises",
ChooseMessageToRead: "Vælg den besked du vil læse",
ChooseMultipleTemplates: "Vælg grundplaner der skal udrulles samtidigt",
ChoosePersonGroup: "Vælg personalegruppe",
ChoosePredefined: "Vælg en prædefineret vagt",
ChooseReasonUnplanned: "Vælg en årsag til hvorfor du har stemplet uden en planlagt vagt.",
ChooseRecipients: "Vælg modtagere",
ChooseRolloutPeriod: "Vælg udrulningsperiode",
ChooseRosterTemplatePeriod: "Vælg den periode grundplanen skal gælde for personen",
ChooseSwapShift: "Vælg en af modtagers vagter.",
ChooseTake: "Vælg den vagt du ønsker at modtage i bytte for",
ChooseType: "Vælg type",
ChooseUnitAndUser: "Vælg afdeling og bruger:",
ChooseViewAndDate: "Vælg visning og dato",
ChooseYourShift: "Vælg en af dine vagter.",
Chosen: "Valgt",
ClickHereToUpdate: "Klik her for at opdatere",
ClickWishExplanation: "Tiden på dette ønske/præference er blevet redigeret.",
ClockIn: "Stemple ind",
ClockInAndOutDeviationInfo: "Hvis den afviger væsentligt fra det planlagte, skal du også angive en årsag.",
ClockInError: "Der skete en fejl under indstempling.",
ClockInItem: "Indstempling",
ClockOut: "Stemple ud",
ClockOutError: "Der skete en fejl under udstempling.",
ClockOutItem: "Udstempling",
ClockOutNotPossible: "Udstempling ikke muligt endnu",
ClockPoint: "ClockPoint",
ClockedTime: "Stemplet tid",
ClockingPeriodOverlaps: "Din indtastede arbejdstid overlapper med en anden stempling.",
ClockingTimeEarlierThanAllowed: "Det angivne tidpunkt ligger for tidligt før planlagt start.",
ClockingTimeEarlierThanLatest: "Det angivne tidpunkt ligger tidligere end din seneste stempling.",
ClockingTimeInFuture: "Du må ikke indtaste et tidspunkt i fremtiden.",
ClockingTimeInPastApp: "Din mobiltelefons eller tablets ur er indstillet til før din seneste stempling er foretaget. Tjek dine indstillinger og prøv igen.",
ClockingTimeInPastBrowser: "Din computers ur er indstillet til før din seneste stempling er foretaget. Tjek dine indstillinger og prøv igen.",
ClockingTimeOverlaps: "Stemplingen overlapper med en forrig stempling.",
Close: "Luk",
CloseCalendar: "Luk kalender",
CloseMenu: "Luk menu",
ClosedForRegistration: "Lukket for registrering",
ColorDay: "Farv dagen",
ColourGroups: "Farv efter grupper",
ColourImperative: "Farv",
ColourPeopleInGroup: "Farv personer i gruppen",
ColumnName: "Kolonnenavn",
Comment: "Kommentar",
CompensatoryTimeOff: "Afspadsering",
ComputeTotals: "Beregn saldo",
ComputingTotals: "Beregner saldo...",
ConfigurePeriodForWorkHours: "Opsæt periode for arbejdstid...",
ConfigureTotalCategory: "Opsætning af total kategori",
Confirm: "Bekræft",
ConfirmBeforeCloseTasks: "Du har foretaget ændringer. Er du sikker på at du vil fortryde?",
ConfirmCancelOffer: "Vil du afbryde byttet?",
ConfirmCancellationOfOffer: "Bekræft afbrydelse af udbud",
ConfirmCancellationOfOfferContent: "Er du sikker på du vil afbryde udbudet af denne vagt til alt personale?",
ConfirmClockInWithoutShift: "Er du sikker på at du vil stemple ind uden valgt vagt?",
ConfirmClockOutWithoutShift: "Er du sikker på at du vil stemple ud uden valgt vagt?",
ConfirmColumnOpen: "Når du sletter alle perioder for kolonnen, bliver den synlig i hele planen.",
ConfirmDeletePreference: "Vil du slette din præference?",
ConfirmDeleteRelative: "Vil du fjerne din pårørende?",
ConfirmDeleteWish: "Vil du slette dit ønske?",
ConfirmKeepChanges: "Er du sikker på, at du vil beholde dine ændringer?",
ConfirmLeavePage: "Vil du forlade siden?",
ConfirmLeavePageContent: "Hvis du forlader siden nu, vil den vagt du var i gang med at oprette blive slettet.",
ConfirmLeavePageContentCreated: "Hvis du forlader siden nu, vil den vagt du var i gang med at oprette blive slettet.",
ConfirmLeavePageContentEdited: "Hvis du forlader siden nu uden at gemme, mister du alle ændringer.",
ConfirmLogout: "Vil du logge ud?",
ConfirmMarkAsHandled: "Bekræft accept uden afløser",
ConfirmMarkAsHandledContent: "Er du sikker på du vil acceptere fravær uden at finde en afløser?",
ConfirmMessageRead: "Jeg har læst beskeden",
ConfirmMoveToUnplanned: "Når du sletter en periode, vil personer der allerede var planlagt heri, blive flyttet til 'Ikke planlagte'.",
ConfirmOfferExchangeCandidatesHelperText: "Filtrér på hvilke medarbejdere der ikke får vagten tilbudt.",
ConfirmOfferOnShiftExchange: "Bekræft udbud af vagt",
ConfirmOfferOnShiftExchangeAllAvailable: "Er du sikker på du vil udbyde vagten til alt ledigt personale i den valgte personalegruppe?",
ConfirmOfferOnShiftExchangeCandidateFilter: "Er du sikker på, du vil udbyde vagten i den valgte personalegruppe?",
ConfirmOfferOnShiftExchangeContent: "Er du sikker på du vil udbyde vagten til alt ledigt personale?",
ConfirmRemoveShiftBodyHandover: "Udbuddet på vagtbørsen aflyses også som følge heraf.",
ConfirmRemoveShiftTitle: "Slet vagt",
ConfirmSaveChanges: "Er du sikker på, at du vil gemme dine ændringer?",
ConfirmShiftAssignment: "Bekræft tildeling af vagt",
ConfirmShiftAssignmentContent: "Er du sikker på du vil tildele vagten til",
ConfirmShiftExchange: "Bekræft godkendelse af bytte",
ConfirmSwap: "Godkend byttet",
ConfirmSwapConfirm: "Vil du godkende byttet?",
ConnectToInternalNet: "Forbind igen til virksomhedens interne netværk for at stoppe stempeluret.",
Contact: "Kontakt",
ContactInfo: "Kontaktoplysninger",
ContactUsTitle: "Ris & ros",
Contains: "Indeholder",
ContinueRollout: "Vil du fortsætte udrulningen?",
Copy: "Kopier",
CopyCalendarLink: "Kopier kalenderlink",
CopyCalendarLinkDescription: "Dette link kan du dele med dine nærmeste eller indsætte i andre kalendre, fx Outlook.",
CopyCalendarText: "Kopier linket ind i din personlige kalender, for at holde din arbejdskalender synkroniseret.",
CopyDetails: "Kopier detaljer",
CopyErrorTextAndContactSupport: "Hjælp med at løse problemet. Kopier detaljerne herunder og send dem til IT-support på din arbejdsplads.",
CopyImperative: "Kopier",
CouldNotAddFollowUpFlag: "Kunne ikke sætte opfølgningsflaget.",
CouldNotDeleteMessage: "Kunne ikke slette beskeden.",
CouldNotLogIn: "Kunne ikke logge ind. Kontroller brugernavn og adgangskode",
CouldNotMarkAsRead: "Kunne ikke markére som læst.",
CouldNotMarkAsUnread: "Kunne ikke markére som ulæst.",
CouldNotRemoveFollowUpFlag: "Kunne ikke fjerne opfølgningsflaget.",
CouldNotSavePlan: "Kunne ikke gemme planen.",
CouldNotSendMessage: "Kunne ikke sende beskeden.",
CouldNotSetInternalToOn: "Kunne ikke markere som intern.",
CouldNotSetPersonalToOn: "Kunne ikke markere som personlig.",
CouldNotSetPublicToOn: "Kunne ikke markere som offentlig.",
CouldNotUpdateTemplates: "Kunne ikke opdatere grundplaner.",
CountedAsOf: "Optalt pr.",
Counter: "Tæller",
CounterSetup: "Opsætning af kategorier og tællere",
Create: "Opret",
CreateFunctionColumn: "Opret funktionskolonne",
CreateNew: "Opret ny",
CreateNewRosterTemplate: "+ Opret ny grundplan.",
CreateNewShift: "Opret ny vagt",
CreatePreference: "Opret Præference",
CreateRosterTemplatePeriod: "Opret grundplansperiode",
CreateSwap: "Opret byt",
CreateWish: "Opret ønske",
CreateWorkingHoursHeadline: "Opret arbejdstider for funktioner og grupper",
Creating: "Opretter",
CreatingDemandTemplate: "Opretter behovsgrundplan",
CreatingRosterTemplatePeriod: "Opretter grundplansperiode",
Crit: "Krit",
CurrentBalance: "Nuværende saldo",
CustomFaqText: "Oplever du problemer, kontakt din lokale planlægger/indberetter for hjælp og vejledning. Jeres superbruger kan kontakte intern support. intern support er hurtigere, hvis du oplyser tjenestenummer, ansættelsessted og mobilnummer.",
CustomerNameLabel: "virksomhed",
CustomerNameLabel_genetive: "virksomhedens",
CutImperative: "Klip",
DailyShiftMarket: "Dagsvagtbørs",
Date: "Dato",
DateFormatInvalid: "Dato er ugyldig. Format: DD-MM-ÅÅÅÅ",
DateMissing: "Dato mangler",
Day: "Dag",
DayLockedForWishes: "Dagen er låst for ønsker.",
DayMessage: "Dagsbesked",
DayViewChatTitlePrefix: "Beskeder",
DayViewDisable: "Luk dagsvisning (skjul tider)",
DayViewEnable: "Dagsvisning (vis tider)",
DecimalSeparator: ",",
Decision_Array: ["Afventer Planlægger","Planlagt","Afvist","Kunne ikke behandles","Personlig Kalender"] as const,
Default: "Default",
DefaultCoverButtonText: "OK",
DefinePattern: "Opret mønster",
Delete: "Slet",
DeleteAll: "Ryd alle",
DeleteDay: "Ryd dagen",
DeleteImperative: "Slet",
DeletePattern: "Slet mønster",
DeletePreference: "Slet præference",
DeletePreferencePattern: "Slet præferencemønster",
DeleteRegistration: "Fjern registrering",
DeleteRelative: "Fjern pårørende",
DeleteRollBrick: "Slet rulbrikken",
DeleteRosterTemplate: "Slet grundplan",
DeleteRosterTemplateDescription: "Grundplanen bliver slettet. De uger, der allerede er udrullet bliver ikke slettet.",
DeleteThis: "Slet denne",
DeleteWish: "Slet ønske",
Deleted: "Slettet",
DeletedDueToShiftTypeChange: "Slettes pga. ændret vagttype:",
Deleting: "Sletter",
DeletingMissingAssignment: "Sletter manglende registrering",
DeletingPersonRollMembershipPeriod: "Sletter personensrulsmedlemskabsvaliditet",
Demand: "Behov",
DemandTemplate: "behovsgrundplan",
Department: "Afdeling",
DepartmentCantWish: "Denne afdeling kan ikke ønske",
DeputyStatus_Array: ["Ukendt","Igangværende","Tildelt","Afvist"] as const,
Description: "Beskrivelse",
DescriptionRestoreOriginal: "Fjern dine registreringer og gå tilbage til den oprindelige dag",
Designation: "Betegnelse",
Destination: "Destination",
Details: "Detaljer",
DeviatingDutylinesWillBeAffectedExplanation: "Din ændring i arbejdstiden vil påvirke følgende tjenester:",
DeviatingDutylinesWillBeDeleted: "Afvigende tjenester slettes",
DeviatingDutylinesWillBeDeletedExplanation: "Slettes pga. ændret vagttype:",
DeviatingPayerNotificationTitle: "Afvigende arbejdssted",
DeviatingShiftInfo: "Afvigende oplysninger",
DeviatingWorkplace: "Afvigende arbejdssted",
DidNotGetTemplateTotals: "Grundplantotaler kunne ikke hentes.",
DidNotGetTotals: "Totaler kunne ikke hentes.",
DidYouForgetToClockIn: "Har du glemt at stemple ind?",
DidYouForgetToClockOut: "Har du glemt at stemple ud?",
DismissMessage: "Luk beskeden",
DismissNotification: "Luk notifikation",
Distance: "Afstand",
DistributionOfFunctions: "Fordeling af funktioner",
DoNotSave: "Gem ikke",
DoOffer: "Udbyd",
DoOpen: "Åbn",
DoReload: "Genindlæs",
DoYouWishToCancel: "Vil du afbryde?",
DoYouWishToSaveAnyway: "Vil du gemme alligevel?",
Done: "Udført",
DownloadTheLatestVersionToUseAgain: "Hent den nyeste version for igen at kunne benytte App'en",
DownloadingData: "Henter data...",
DownloadingDemand: "Henter behov...",
DownloadingFunctionData: "Henter funktionsdata...",
DownloadingFunctions: "Henter funktioner...",
DownloadingGroupMemberships: "Henter gruppemedlemskaber...",
DownloadingGroupRoster: "Henter data...",
DownloadingGroups: "Henter grupper...",
DownloadingHistory: "Henter historik...",
DownloadingHolidays: "Henter helligdage...",
DownloadingMultifunctions: "Henter multifunktioner...",
DownloadingPersonInfo: "Henter persondata...",
DownloadingPersonRoster: "Henter data...",
DownloadingPhysicianPlan: "Henter funktionsplan...",
DownloadingPlans: "Henter planer...",
DownloadingPreferences: "Henter præferencer...",
DownloadingRosterTemplates: "Henter grundplaner",
DownloadingRuleViolations: "Henter brud på arbejdstids- og miljøregler...",
DownloadingShiftTypes: "Henter vagttyper...",
DownloadingShifts: "Henter vagter...",
DownloadingTotals: "Henter totaler...",
DownloadingUnits: "Henter afdelinger...",
DownloadingWorkingHours: "Henter arbejdstider...",
DropForbiddenReasonGroupMember: "Personen kan kun tilføjes til grundplansrul.",
DropForbiddenReasonHeaderNonplanned: "Kan ikke placeres i 'ikke planlagte' kolonnen.",
DropForbiddenReasonHeaderOther: "Kan ikke placeres i kolonne af denne type.",
DropForbiddenReasonHeaderPreference: "Kan ikke placeres i kolonne af denne type.",
DropForbiddenReasonIntoOrigin: "Kan ikke placeres i oprindelig rubrik.",
DropForbiddenReasonMultipleFunctionIds: "Kan ikke placeres i en kolonne der indeholder mere end 1 funktion.",
DropForbiddenReasonOnlyGroupMember: "Kun gruppemedlemer kan indsættes her.",
DropForbiddenReasonOther: "Ikke tilladt.",
DropForbiddenReasonOtherDay: "Kan ikke flyttes til en anden dag.",
DropForbiddenReasonOutsideTemplateValidity: "Dagen ligger udenfor grundplansgyldighed.",
DropForbiddenReasonPersonAlreadyHere: "Personen findes allerede i rubrikken.",
DropForbiddenReasonRollAlreadyHere: "Rul findes allerede i rubrikken.",
DropForbiddenReasonTileClosed: "Rubrikken er lukket.",
DueToPlanDecided: "Dette grundet at ønsket er godkendt af planlægger.",
DueToPlanRejected: "Dette grundet at ønsket er afvist af planlægger.",
Duties: "Tjenester",
Duty: "Tjeneste",
Edit: "Rediger",
EditAndFindSubstitute: "Rediger vagten og find afløser",
EditColumn: "Ret kolonne",
EditColumnName: "Ret kolonnenavn",
EditContactInfo: "Redigér kontaktoplysninger",
EditDay: "Ret dag",
EditPeriod: "Redigér",
EditPlanName: "Ret plannavn",
EditPreference: "Redigér præference",
EditShift: "Rediger vagt",
EditTask: "Rediger opgave",
EditTemplate: "Ret grundplan",
EditWish: "Redigér ønske",
Editable: "Redigerbar",
EditedWishExplanation: "Tiden på ønsket er blevet ændret",
Email: "Email",
EmailInvalid: "Indtast venligst en gyldig email",
Employed: "Ansat",
Employee: "Employee",
EmployeeNotFound: "Medarbejder ikke fundet. Medarbejderen kan være blevet slettet af en anden bruger.",
Employment: "Ansættelse",
Empremark: "Bemærkning fra dig",
Enable: "Slå til",
End: "Slut",
EndAbsence: "Afslut fravær",
EndBeforeMidnight: "Slut før midnat?",
EndDate: "Slutdato",
EndImperative: "Afslut",
EndTime: "Sluttid",
EnterColumnName: "Skriv kolonnenavn",
EnterColumnNameForFunction: "Skriv kolonnenavn for funktionen",
EnterPlanName: "Skriv plannavn",
EnterSalaryId: "Indtast tjenestenummer",
Error: "Fejl",
ErrorCannotUploadInBrowser: "Fil-upload virker ikke i denne browser",
ErrorCode: "Fejlkode",
ErrorCouldNotRollout: "Kunne ikke udrulle",
ErrorHasBeenReported: "Fejlen er rapporteret.",
ErrorInvalidColumn: "Ugyldig kolonne i planen. Kolonnen bliver slettet.",
ErrorList: "Fejlliste",
ErrorMoveToUnplannedFailed: "Kunne ikke flytte registreringer til 'Ikke planlagte'",
ErrorOutOfSync: "Der er uoverensstemmelse mellem VagtPlan og FunktionsPlan.",
ErrorRelativeExistsAlready: "Pårørende allerede registreret",
EvenWeek: "lige uge",
Exchange: "Byt",
ExchangeAlreadyAnswered: "Du har allerede foreslået følgende byt:",
ExchangeAlreadyAnsweredButRejected: "Du har allerede foreslået følgende byt men det blev afvist:",
ExchangeBeingProcessed: "Byt under behandling",
ExchangeEmptyListMessage: "Du har ingen bytteanmodninger eller tilbud",
ExchangeEmptyListMessageDone: "Du har ingen afsluttede bytteanmodninger eller tilbud",
ExchangeEmptyListMessageInbox: "Du har ingen bytteanmodninger eller tilbud",
ExchangeEmptyListMessageOngoing: "Du afventer ikke bytteanmodninger eller tilbud",
ExchangeEmptyListMessageTitle: "Ingen anmodninger",
ExchangeHandoverErrorBody: "Noget gik galt, og din vagtafgivelse blev desværre ikke oprettet.",
ExchangeHandoverErrorTitle: "Fejl ved afgivelse",
ExchangeLongDescription: "Denne side viser igangværende byt og tilbud til eller fra dig. Dine egne vagter kan du foreslå byttet væk ved at gå ind på den enkelte vagt og vælge 'Byt' eller 'Afgiv'.",
ExchangeNoShifts: "Ingen tilgængelige vagter",
ExchangeOfferYourShift: "Tilbyd din vagt",
ExchangeRelatedToShift: "Byt relateret til vagten",
ExchangeStillActiveBody: "MinPlan er i gang med at behandle din bytteforespørgsel. Det tager længere tid end forventet.",
ExchangeStillActiveTitle: "Byt er stadig igang",
ExchangeSuggested: "Du har foreslået byttet",
ExchangeSwapErrorBody: "Noget gik galt, og din bytteforespørgsel blev desværre ikke oprettet.",
ExchangeSwapErrorTitle: "Fejl ved byt",
ExchangeTabEnded: "Afsluttet",
ExchangeTabInbox: "Afventer dig",
ExchangeTabNew: "Ny",
ExchangeTabOngoing: "Afventer svar",
ExchangeTitle: "Vagtbørs",
ExchangeWhoeverErrorBody: "Dit bytte med 'hvem som helst' kunne ikke gennemføres på grund af manglende kandidater.",
ExchangeWhoeverErrorTitle: "Byt ikke muligt",
ExistingFunction: "Eksisterende funktion",
ExistingTemplate: "Eksisterende grundplan",
ExportCalendarTitle: "Eksport af arbejdskalender",
ExportForAutoPlanning: "Eksportér for automatisk planlægning.",
ExportWorkCalendar: "Her kan du slå eksport af din arbejdskalender til eller fra, så den kan deles med din personlige kalender eller dine nærmeste.",
Eye: "Øje",
Face: "Ansigt",
FaceId: "Face ID",
FacialRecognitionOrFingerprint: "ansigtsgenkendelse eller fingeraftryk",
FaqAboutMeBody: "I denne menu kan medarbejderen se udvalgte informationer om sig selv og indtaste/rette deres e-mail og telefonnummer (hvis det er tilladt i installationen).\n<br/>\nMedarbejderen også slå biometrisk login, Face ID eller Touch ID til og fra (hvis det er tilladt i installationen).",
FaqAboutMeTitle: "Om mig",
FaqAdditionalHelpTitle: "Brug for yderligere hjælp?",
FaqAdjustment: "Planlæggeren sammenholder planen med dine registreringer og færdigjusterer planen, så den kan godkendes til løn.",
FaqApproved: "Planen er færdig og klar til lønkørsel.",
FaqBalanceBody: "I denne menu kan medarbejderen se udvalgte saldi som eks. afspadserings-, ferie, overarbejdssaldo m.v.. Saldi vises for den valgte periode. Via piletasterrne kan man vælge at få vist saldi for andre perioder.\n<br/>\nHvilke saldi der vises afhænger af den valgte konfigurering af systemet.",
FaqBalanceTitle: "Saldo",
FaqChatBody: "I denne menu kan medarbejderen starte, læse eller besvare beskeder (chat) til/fra dine kolleger og/eller vagtplanlægger. Såfremt der er nye beskeder der afventer, vises en rød dot notifikation ud for menuen.\n<br/>\nVia knapperne øverst i menuen kan medarbejderen filtrere i beskederne ved at klikke felterne (Personlig, gruppe mm.) on/off.",
FaqChatTitle: "Beskeder",
FaqCheckIn: "Når arbejdet er udført, skal du tidsregistrere dit arbejde og fravær. Dette gøres ud fra en kopi af planen kaldet Registreringer.",
FaqContactBody: "For yderligere hjælp og vejledning - kontakt din vagtplanlægger/systemadministrator for VagtPlan.",
FaqContactTitle: "Kontakt",
FaqCoworkerPlanBody: "I denne menu kan medarbejderen se sine kollegers uge eller dagsplan (hvis det er tilladt i konfigurationen).\n<br/>\nMedarbejderen kan se planer for de kolleger denne er i en byttegruppe med. Hvilke registreringer man kan se afhænger også af den aktuelle konfiguration.\n<br/>\nEn grøn markering ud for en kollegaen indikerer at personen er på arbejde, mens en blå farve indikerer fravær.\n<br/>\nVed at klikke på den enkelte kollegas initialer eller registrering, bliver man ført til kollegaens ugeplan for den valgte uge. Hvis man i stedet klikker på en specfik dag i ugevisningen, vil man få vist dagsplanen for den valgte dag.",
FaqCoworkerPlanTitle: "Kollegaplan",
FaqDailyChatBody: "I Dagsplanen kan medarbejderen skrive en besked (chat) til planlæggeren vedr. den pågældende vagt eller opgave.",
FaqDailyChatTitle: "Chat",
FaqDailyDutiesBody: "Klik på vagten/fraværet for at udfolde flere detaljer og informationer.",
FaqDailyDutiesTitle: "Vagter/fravær",
FaqDailyPlanBody: "Dagsplanen vises når man fra uge eller månedsoversigten klikker på en specifik dag.\n<br/>\nHvis man anvender MinPlan på en større skærm (computerskærm, iPad eller lignende) vil dagsplanen ofte blive vist samtidigt med uge eller månedsplanen.\n<br/>\nI dagsplanen kan man finde detaljerede oplysninger om vagter, fravær og eventuelle opgaver. Medarbejderen har også mulighed for at sende en besked (chat) til planlæggeren om den aktuelle dags vagt og opgaver.\n<br/>\nI Tidsregistreringsperioden kan medarbejderen registrere sin arbejdstid, mens det i Driftsperioden er muligt at anmode om vagtbytte samt afgive og tage vagter.",
FaqDailyPlanTitle: "Dagsplan",
FaqDailyRegistrationsBody: "Hvis man skal registrere en ændring på en planlagt vagt eller opgave, kan det ske via menuen \"Arbejde\". (Forudsætter at det i konfigurationen er tilladt at lave ændringer).\n<br/>\nMan kan registrere ændringer i den periode af arbejdstidsplanen der har planstatus tidsregistrering.\n<br/>\nFølgende muligheder er tilgængelige:\nRet dag - Anvendes hvis man vil redigere den opgave/vagt der allerede ligger på dagen. Man kan ændre type og tidspunkt.\n<br/>\n+Ny - Anvendes hvis man vil tilføje en ny opgave/vagt/fravær. Der må IKKE være tidsoverlap med andre vagt/opgave/fravær.\n<br/>\nTidsregistrering - Hvis afdelingen bruger Tidsregistrering, kan man på siden Arbejde indtaste, hvornår ens arbejdsdag er startet og sluttet, så længe det er indenfor tidsregistreringsperioden.\nNår man gemmer sin tidsregistrering, vises den på siden Arbejde.\nTidsregistreringer kan ikke redigeres eller slettes.\n<br/>\nRyd dag - Anvendes hvis man skal registrere noget helt andet. Eks. hvis man arbejder helt anderledes end oprindeligt planlagt, da skal man først vælge Ryd dag og dernæst +Ny for at lave den nye registrering.\n<br/>\nOprindelig dag - Fortryd indtastede registreringer og få den oprindelige plan (fra vagtplanlægger) tilbage. \n<br/>\nBemærk at fravær kan registreres på følgende måder: \na) med tidspunkter eksempelvis 0900-1400 SYG, hvilket normalt anvendes hvis medarbejderen har været delvist fraværende på en vagt, eller\nb) som 00-24 SYG, hvilket normalt bruges hvis medarbejderen har været fraværende på hele dagen/vagten. Fraværet tæller kun syg svarende til den vagt længde medarbejderen oprindeligt var planlagt til at skulle arbejde.\n<br/>\nMedarbejderne kan også skrive en NOTE til vagtplanlægger i forbindelse med en ændring til registrering.",
FaqDailyRegistrationsTitle: "Registreringer",
FaqDailySwapBody: "Som medarbejder kan man via MinPlan bytte eller afgive en af de planlagte vagter og evt. tilhørende opgaver til andre medarbejdere i ens byttegruppe.\n<br/>\nEt bytte udføres altid på en hel vagt eller opgave. Bytte kan udføres på vagter der ligger i fremtiden og indenfor planstatus perioden Drift. \nMan kan dog som standard tidligst starte et bytte på en opgave der starter fra kl. 00.00 i morgen (dvs. midnat i aften), dog gælder det også som standard at byttet skal være oprettet inden kl. 1200 dags dato. Efter kl. 1200 kan der først byttes vagter/opgaver der starter i overmorgen.\n<br/>\nFor alle typer af byt gælder det at MinPlan automatisk sikrer at kun de medarbejdere der er kvalificerede til at udføre vagten/opgaven, er ledige og ikke bryder arbejdstidsregler (hvis den kontrol er aktiveret i installation), får tilbudt vagten med tilhørende opgaver. I det tilfælde at ingen medarbejdere opfylder ovenstående kriterier, vil systemet vise en meddelelse om at der ikke findes nogen byttemuligheder, og et bytte er derfor ikke muligt.\nEndvidere gælder det for alle medarbejder-aktiverede byt, at både medarbejderen der afgiver og tilbyder sig som kandidat, begge skal acceptere byttet inden byttet sendes til godkendelse hos en vagtplanlægger (Planlægger godkendelse kan evt. være deaktiveret så vagter godkendes automatisk når de er godkendt af begge medarbejdere). Den aktuelle status på et bytte, fremgår af menuen \"Vagtbørs\".\n<br/>\nDer findes tre former for bytte (i nogle installationer kan udvalgte typer af byt være deaktiveret). Nedenfor er en kort beskrivelse af de forskellige typer:",
FaqDailySwapDirectBody: "Ved et direkte byt vælger den afgivende medarbejder en vagt og vælger herefter den kollega (indenfor byttegruppen) denne ønsker at bytte med, samt udpeger den vagt der skal byttes med.",
FaqDailySwapDirectTitle: "Direkte byt",
FaqDailySwapGiveBody: "Ved afgiv udbyder medarbejderen sin vagt til de andre kollegaer i byttegruppen, som så kan byde ind på at overtage vagten. Medarbejderen modtager ingen opgave/vagt i bytte. Det er derefter op til planlæggeren at vælge den kollega der skal overtage den udbudte opgave/vagt. Planlæggeren kan også vælge at afvise medarbejderens ønske om at afgive vagten/opgaven.",
FaqDailySwapGiveTitle: "Afgiv",
FaqDailySwapOpenBody: "Ved et åbent bytte sender medarbejderem sin vagt i udbud i sin byttegruppe og modtager derefter tilbud fra andre kollegaer, med forslag om hvilken vagt de ønsker at bytte med. Når medarbejderen har valgt et forslag, sendes det automatisk til endelig godkendelse hos vagtplanlæggeren og de andre tilbud bliver afvist.",
FaqDailySwapOpenTitle: "Åbent byt",
FaqDailySwapTitle: "Bytte/Afgivelse",
FaqDailyTasksBody: "Hvis medarbejderen er tildelt en opgave, kan man ved at folde opgaven ud, se udvidede detaljer om opgaven. Alt efter  konfigurationen, kan medarbejderen også se hvilke kollegaer der arbejder på samme opgave eller produktion, som opgaven er planlagt på.",
FaqDailyTasksTitle: "Opgaver",
FaqDutySwapBody: "Medarbejdere kan via MinPlan vælge at bytte eller afgive vagter og tilhørende opgaver til andre medarbejdere i deres byttegruppe.\n<br/>\nEt bytte udføres altid på en hel vagt og alle tilhørende opgaver. Bytte kan udføres på opgaver/vagter der ligger i fremtiden og indenfor planstatus perioden drift.\nMan kan dog som standard tidligst starte et bytte fra kl. 00.00 i morgen (dvs. midnat i aften), dog gælder det som standard at byttet skal være oprettet inden kl. 1200 dags dato. Efter kl. 1200 kan der først byttes vagter/opgaver der starter i overmorgen.\n<br/>\nFor alle typer af byt gælder det at MinPlan automatisk sikrer at kun de medarbejdere der er kvalificerede til at udføre vagten/opgaven, er ledige og ikke bryder nogen arbejdstidsregler, får tilbudt vagten og tilhørende opgaver.\n<br/>\nI det tilfælde at ingen medarbejdere opfylder ovenstående kriterier, vil systemet vise en meddelelse om at der ikke findes nogen byttemuligheder, og byttet vil ikke kunne aktiveres. Endvidere gælder det for alle medarbejderaktiverede byt, at både medarbejderen der afgiver og tilbyder sig som kandidat, begge skal acceptere byttet. Til sidst skal byttet godkendes af en vagtplanlægger, inden det er endeligt godkendt og en realitet (Planlægger godkendelse kan evt. være deaktiveret så vagter godkendes automatisk når de er godkendt af begge medarbejdere).\n<br/>\nDen aktuelle status på et bytte, fremgår af menuen \"Byttestatus\". Der findes tre former for bytte (i nogle installationer kan udvalgte typer af byt dog være deaktiveret):",
FaqDutySwapTitle: "Vagtbytte",
FaqGuideBody: "MinPlan er VagtPlans medarbejderportal, hvor medarbejdere kan se og registrere informationer om vagter og opgaver, se saldi, ønske fri/arbejde, ferie m.v., sende beskeder til vagtplanlægger og andre medarbejdere, samt bytte, afgive og byde ind på udbudte opgaver/vagter.\n<br/>\nBemærk: Nogle funktioner kan være deaktiveret i den specifikke installation.\n<br/>\nI afsnittene nedenfor er en kort beskrivelse af funktionerne i MinPlan.",
FaqGuideTitle: "Quick guide",
FaqHelpBody: "Quick guide der beskriver de forskellige menuer og funktioner i systemet.",
FaqHelpTitle: "Hjælp",
FaqLinkText: "Gå til hjælp siden.",
FaqLogOutBody: "Brug denne kommando til at logge ud af MinPlan når man er færdig med at arbejde i systemet.",
FaqLogOutTitle: "Log ud",
FaqLoginBody: "Medarbejderen kan logge ind på tre måder, alt efter hvad der er valgt for installationen:\n1. Brugernavn og adgangskode\n2. Biometrisk login/Face ID/Touch ID\n3. OpenID\n<br/>\n1. Brugernavn og adgangskode:\nMedarbejderen får brugernavn og adgangskode fra sin planlægger. Adgangskoden kan ændres under menupunktet Om mig.\n<br/>\n2. Biometrisk login/Face ID/Touch ID:\nHvis biometrisk login er aktiveret på medarbejderens telefon, bliver man spurgt, om man vil bruge det første gang man logger ind i MinPlan app'en. Derefter vil login altid ske automatisk med biometrisk login, Face ID eller Touch ID, afhængig af telefonen, når man åbner app'en.\nDet kan også slås til eller fra senere under menupunktet Om mig.\n<br/>\n3. OpenID:\nNår medarbejderen logger ind, bliver de sendt til en ekstern login-side. Efter godkendelse af brugernavn og adgangskode, vender medarbejderen tilbage til MinPlan app'en som logget ind.",
FaqLoginTitle: "Login",
FaqMonthlyPlanBody: "Månedsplanen viser de vagter og fravær medarbejderen er planlagt med for den valgte måned. Man kan scrolle i månederne eller vælge en specifik måned via menuen.\n<br/>\nHvis en medarbejder er tildelt en vagt/opgave, vil den pågældende dag være markeret med en grøn cirkel. Fravær er markeret med en blå cirkel.\n<br/>\nVed at klikke på en specifik dag, åbnes skærmbilledet \"Dagsplan\" hvor medarbejderen får vist flere informationer om sin vagt, fravær/opgave, kan skrive en besked (chat) til planlæggeren vedr. dagens vagter og opgaver, og kan starte et bytte/afgivelse af en vagt eller opgave.",
FaqMonthlyPlanTitle: "Månedsplan",
FaqOperation: "Den færdige plan er publiceret, og de konkrete opgaver planlægges. Du kan bytte vagter med andre, eller ønske arbejde på flere tidspunkter.",
FaqOverviewBody: "Her findes information om medarbejderens vagter/fravær og opgaver.",
FaqOverviewTitle: "Vagtplan overblik",
FaqPhaseApprovedBody: "Vagtplanlæggeren har behandlet alle registreringer og de afventer at blive overført til løn.",
FaqPhaseApprovedTitle: "Godkendt til løn",
FaqPhaseConsolidationBody: "Vagtplanlæggeren sammenholder medarbejdernes tidsregistreringer med de planlagte vagter/fravær og godkender/afviser registreringerne.",
FaqPhaseConsolidationTitle: "Konsolidering",
FaqPhaseOperationBody: "Arbejdstidsplanen er publiceret. Medarbejder kan bytte opgaver/vagter, afgive og tage opgaver/vagter.",
FaqPhaseOperationTitle: "Drift",
FaqPhaseRealisedBody: "Registreringer er overført til løn.",
FaqPhaseRealisedTitle: "Realiseret",
FaqPhaseRequestBody: "Medarbejder kan indgive ønsker til opgaver, vagter eller fravær.",
FaqPhaseRequestTitle: "Ønske",
FaqPhaseSchedulingBody: "Vagtplanlæggeren er igang med at planlægge. Om den enkelte medarbejder kan se planlagte opgaver/vagter og/eller fravær i perioden afhænger af den aktuelle konfigurering af systemet.",
FaqPhaseSchedulingTitle: "Planlægning",
FaqPhaseTimeReportBody: "Der er åbent for at medarbejdere kan tidsregistrere arbejde og fravær.",
FaqPhaseTimeReportTitle: "Tidsregistrering",
FaqPhasesBody: "En vagtplan skifter status over tid, efterhånden som den gennemgår forskellige faser. I MinPlan afspejles disse faser via planstatus perioder. Hver planstatus periode har sit eget navn.\n<br/>\nUd fra den aktuelle planstatus periode vil MinPlan automatisk tillade/begrænse forskellige operationer. F.eks. kan medarbejdere kun indgive ønsker til vagtplanen i planstatus perioden ”Ønske”. For vagtbytte gælder det at dette kun udføres i planstatus perioden ”Drift” o.s.v.\n<br/>\nNedenfor fremgår de forskellige planstatus perioder og deres betydning. Den aktuelle planstatus periode for en plan fremgår ved farvemarkering. Farvekodeoversigten findes ved klik på informations symbolet øverst i højre side af programmet.",
FaqPhasesTitle: "Vagtplanens faser",
FaqPlanning: "Planlæggeren udarbejder færdige arbejdsplaner ud fra produktionsbehov og dine og dine kollegers ønsker. I denne fase er din plan skjult, men du kan stadig se dine ønsker.",
FaqPreferencesBody: "Man bruger præferencer til at fortælle vagtplanlæggeren, hvornår man gerne vil arbejde eller holde fri.\n<br/>\nFor at angive en præference klikker man på dagen ud for præferencen, hvorved der vises en bolchestribet prik. Vil man gerne slette sin præference igen, klikker man på prikken igen, og derved fjernes registreringen.\n<br/>\nVed præferencer uden tid bliver man bedt om selv at angive tiden. Klikker man på præference-prikken igen, kan man redigere tiden. Det er også muligt at slette præferencen her.\n<br/>\nDet er muligt at indsætte flere præferencer på den samme dag, på nær en negativ og en positiv af samme type.\n<br/><br/>\nPræferencemønster:\n<br/>\nMedarbejdere kan oprette et præferencemønster, hvori gentagne ønsker nemt kan angives. Man klikker på mønster-ikonet øverst i venstre side på Ønskesiden. Derved kan man slippe for at klikke enkeltstående præferencer ind, eksempelvis hver anden weekend, hvor man har sine delebørn.\n<br/>\nNår man opretter sit præferencemønster, skal man vælge, om præferencerne skal gentage sig hver uge eller henover to uger. Efter oprettelse kan man angive de præferencer, der skal gentage sig. Det er muligt både at redigere og slette præferencer i præferencemønsteret samt at slette hele mønsteret. Vær dog opmærksom på, hvornår ændringerne gælder fra. Dette står inde på præferencemønsteret.\n<br/>\nUde på ønskesiden vil en præference fra præferencemønsteret blive vist med mønster-ikonet (det ligner en blomst) i ønskeperioden. Når planlæggeren flytter ønskeperioden frem i tid, vil disse blive konverteret til bolchestribede prikker.\n<br/>\nPræferencer fra præferencemønsteret kan deaktiveres på enkelte dage. Når en præference er deaktiveret, bliver mønster-ikonet gråt og vises ikke længere for planlæggeren i VagtPlan. Klik på ikonet igen for at genaktivere præferencen.\n<br/>\nMan kan se alle de indtastede præferencer for en dag på den tilhørende Arbejdeside.",
FaqPreferencesTitle: "Præferencer",
FaqProductionBody: "På en booked opgave kan man ved at udfolde denne, se udvidede information om opgaven/produktionen. Afhængig af konfigurationen vises \"Opgavehold\" og/eller \"Produktionshold\".\n<br/>\nVia opgavehold kan medarbejderen se hvilke kollegaer der også arbejder på den valgte opgave.\nVia Produktionshold kan medarbejderen se samtlige kollegaer der også er planlagt til at skulle udføre en opgave på den samme produktion, som den valgte opgave, er en del af.",
FaqProductionTitle: "Produktion/Opgaver",
FaqPunchClockBody: "Hvis afdelingen bruger Stempelur, er det den første side, man ser, når man åbner MinPlan. Her registreres, hvornår man har startet og sluttet sin arbejdsdag.\n<br/>\nNår man stempler ind, vises en animation og en kvittering med starttid. Når man stempler ud, opdateres kvitteringen med sluttid og samlet arbejdstid.\n<br/>\nPå siden Arbejde kan dagens registreringer altid ses.\n<br/>\nAfhængigt af afdelingens opsætning af MinPlan er det også muligt at:\n• Angive årsager til tidlige/sene stemplinger og uplanlagt arbejde.\n• Tilføje en stempling på bagkant, hvis man har glemt at stemple i arbejdstiden.\n• Stemple udenfor planlagt arbejdstid.\n<br/>\nStemplinger kan ikke redigeres eller slettes.",
FaqPunchClockTitle: "Stempelur",
FaqRealized: "Planen er lønkørt.",
FaqRegApprovedBody: "Registreringerne er godkendt af en planlægger, og danner nu løngrundlaget.",
FaqRegApprovedTitle: "Godkendt",
FaqRegPendingBody: "Konsolidering kunne ikke automatisk flette registreringen til planen, og planlæggeren har ikke set på dem endnu. Planen viser stadig oprindelig. Der vises en underoverskrift med registreringerne, og en knap Fortryd.",
FaqRegPendingTitle: "Afventer behandling",
FaqRegPreApprovedBody: "Registreringerne er automatisk forhåndsgodkendt af konsolideringen, planlæggeren har ikke taget stilling til dem endnu. Der vises en underoverskrift med oprindelig, og en knap Genskab.",
FaqRegPreApprovedTitle: "Forhåndsgodkendt",
FaqRegRejectedBody: "Registreringerne er afvist af planlæggeren. Der vises en underoverskrift med de afviste registreringer.",
FaqRegRejectedTitle: "Afvist",
FaqRegStatusBody: "Der findes følgende staus for registreringer:",
FaqRegStatusTitle: "Status på registreringer",
FaqRegUnchangedBody: "Registreringen er uændret ift. den af vagtplanlæggeren planlagte vagt/opgave/fravær.",
FaqRegUnchangedTitle: "Oprindelig",
FaqRegUnprocessedBody: "Medarbejderen har udført registreringer, men disse er endnu ikke behandlet af vagtplanlæggeren. Der vises en underoverskrift med oprindelig, og en knap Genskab.",
FaqRegUnprocessedTitle: "Ubehandlet",
FaqRequest: "Her kan du ønske hvornår du vil arbejde og have fri. Planen kan f.eks. indeholde ferie, som er godkendt af planlæggeren.",
FaqShiftMarketBody: "I denne menu kan medarbejdere se status på deres byt og kollegers/vagtplanlæggers udbudte vagter. Såfremt der er nye opdateringer der afventer, vises en rød dot notifikation ud for menuen. \n<br/>\nVed at udvide det enkelte byt/udbud kan medarbejderen se detaljerede oplysninger om det viste byt/udbud. Medarbejder kan acceptere/afvise eller fortryde udbudte og tilbudte vagter.",
FaqShiftMarketTitle: "Vagtbørs",
FaqSwapDirectBody: "Ved et direkte byt vælger mden afgivende medarbejder en vagt og vælger herefter den kollega (indenfor byttegruppen) denne ønsker at bytte med, samt udpeger den vagt der skal byttes med.",
FaqSwapDirectTitle: "Direkte byt",
FaqSwapGiveBody: "Ved afgiv udbyder medarbejderen sin vagt til de andre kollegaer i byttegruppen, som så kan byde ind på at overtage vagten. Medarbejderen modtager ingen opgave/vagt i bytte. Det er derefter op til planlæggeren at vælge den kollega der skal overtage den udbudte opgave/vagt. Planlæggeren kan også vælge at afvise medarbejderens ønske om at afgive vagten/opgaven.",
FaqSwapGiveTitle: "Afgiv",
FaqSwapOpenBody: "Ved et åbent bytte sender medarbejderem sin vagt i udbud i sin byttegruppe og modtager derefter tilbud fra andre kollegaer, med forslag om hvilken vagt de ønsker at bytte med. Når medarbejderen har valgt et forslag, sendes det automatisk til endelig godkendelse hos vagtplanlæggeren og de andre tilbud bliver afvist.",
FaqSwapOpenTitle: "Åbent byt",
FaqTitle: "Hjælp",
FaqUserApproved: "Når du er tilfreds med dine registreringer, trykker du 'Godkend hertil' for at godkende alle dine tidsregistreringer frem til denne dag. Dette er et signal til planlæggeren om at denne kan gå i gang med lønarbejdet.",
FaqWeekPlanBody: "Ugeplanen viser de vagter/opgaver og fravær medarbejderen er planlagt med for den valgte uge. Man kan scrolle i ugerne eller vælge en specifik uge via menuen.\n<br/>\nUgeplan er start vinduet når man logger ind på MinPlan.\n<br/>\nHvis en medarbejder er tildelt en vagt/opgave, vil den pågældende dag være markeret med en grøn cirkel. Fravær er markeret med en blå cirkel.\n<br/>\nFor alle registreringer vises start og slut tid, samt vagt eller opgave navn. Ved flere opgaver/vagter samme dag, vises \"Arbejde\" og den overordnede start/slut tid for arbejdsdagen.\n<br/>\nVed at klikke på en specifik dag, åbnes skærmbilledet \"Dagsplan\" hvor medarbejderen får vist flere informationer om sin vagt, fravær/opgave, kan skrive en besked (chat) til planlæggeren vedr. dagens vagter og opgaver, og kan starte et bytte/afgivelse af en vagt eller opgave.",
FaqWeekPlanTitle: "Ugeplan",
FaqWishListBody: "Medarbejderen bruger ønsker til at fortælle vagtplanlæggeren, hvilke specifikke vagter, fravær, opgaver m.m. man gerne vil have.\n<br/>\nØnskerne kan ses i saldoerne som fx medarbejderens normtimer, feriesaldo og afspadseringssaldo. Derved kan man se hvor meget der er tilbage, og se at man ikke overskrider saldoen.\n<br/>\nFor at ønske noget, eksempelvis et fravær, klikker man på dagen ud for fraværet, hvorved der vises en farvet prik. Vil man gerne slette sit ønske igen, klikker man på prikken igen, og derved fjernes registreringen (hvis dette er tilladt).\n<br/>\nNogle typer af ønsker har selvvalgte tider. Når man ønsker en af disse, bliver man bedt om at angive tiden. Klikker man senere på ønske-prikken igen, kan man redigere tiden. Det er også muligt at slette ønsket her.\n<br/>\nHvis et ønske er godkendt, vil ønske-prikken få en sort kant.\n<br/>\nI tilfælde af at et ønske er afvist, vil et rødt kryds være vist i stedet for ønske-prikken. Hvis vagtplanlæggeren har angivet en årsag ifm. afvisningen, vil denne stå inde på Arbejdesiden. En genvej hertil er at klikke på den tilhørende dato på ønskesiden.\n<br/>\nI nogle konfigurationer vises behovsangivelse ved opgaver. Man kan således se, hvor mange af en given type opgave der er udbudt, samt hvor mange der har ønsket denne opgave. For eksempel betyder 1/4, at der er udbudt 4 opgaver, og at kun én medarbejder har ønsket denne opgave på nuværende tidspunkt.\n<br/>\nNogle typer af ønsker (f.eks. fravær) kan kun ønskes i ønskeperioden, som er defineret af vagtplanlæggeren. Disse skal endvidere godkendes af vagtplanlæggeren, før ønsket er accepteret.\n<br/>\nMedarbejdere, der har lov til at arbejde dobbeltvagter, skal angive deres første ønske på Ønskesiden. Derefter skal de gå ind på Arbejdesiden for samme dag og oprette ønske nr. 2 herinde.",
FaqWishListTitle: "Ønsker",
FaqWishesBody: "I denne menu kan medarbejderen registrere sine ønsker vedr. vagter, fravær, opgaver m.m. Det er også muligt at angive generelle præferencer for, hvornår man gerne vil arbejde, og hvornår man gerne vil holde fri. Disse informationer hjælper vagtplanlæggeren med at tage hensyn til medarbejderens behov og ønsker, når arbejdsplanen bliver udarbejdet i VagtPlan. \n<br/>\nHvilke typer af ønsker og præferencer der kan registreres, afhænger af den valgte konfiguration af systemet.\n<br/>\nForskellen på ønsker og præferencer:\n<br/>\nØnsker er specifikke anmodninger om vagter, fravær, opgaver m.m. De har en højere prioritet end præferencer og de lægges direkte ind i arbejdsplanen.\n<br/>\nPræferencer er generelle angivelser af, hvornår medarbejderen gerne vil arbejde eller holde fri. Vagtplanlæggeren tager højde for disse, men det er ikke nødvendigt at imødekomme alle præferencer. Medarbejdere kan oprette et præferencemønster, hvori gentagne ønsker nemt kan angives.",
FaqWishesTitle: "Ønsker",
FetchData: "Hent data uden at åbne",
FetchingRegistrations: "Henter registreringer",
FetchingRolloutDate: "Henter udrulningsdato",
FetchingTotals: "Henter totaler",
FictiveEmployees: "Fiktive medarbejdere",
FictivePerson: "Fiktiv person",
FillFunctionExplanation: "Dem med ledig tid og størst normtimeunderskud står længst til venstre.",
FillFunctionExplanationNoEmployees: "Der er ingen ledige medarbejdere tilknyttet funktionen.",
FillHighlightedFieldToSave: "Udfyld det markerede felt for at gemme",
FillHighlightedFieldsToSave: "Udfyld de markerede felter for at gemme",
FilterMessages: "Filtrér beskeder",
FilterOutEmployeesWith: "Frasortér medarbejdere med..",
FindEmployee: "Find medarbejder",
FindShiftToSwap: "Find vagt for at bytte",
FindShifts: "Find vagter",
Fingerprint: "Fingeraftryk",
FirstWeek: "Første uge",
FollowGroup: "Følg gruppe",
ForSecurityReasonsTheMostSecureBiometricMustBeEnabled: "Af sikkerhedsmæssige årsager skal telefonens sikreste form for biometri være slået til for at det kan anvendes til login i MinPlan. På de fleste telefoner er dette fingeraftryk.",
ForgotToClockIn: "Glemt indstempling?",
ForgotToClockOut: "Glemt udstempling?",
FormerAssignee: "Tidligere tildelt",
Forward: "Videresend",
From: "Fra",
FromHours: "Fra timer",
FromMinutes: "Fra minutter",
FromOriginalShift: "Fra oprindelig vagt",
FromThisPhysicianPlan: "fra denne funktionsplan",
FullMonthOverview: "Fuld månedsoversigt",
Function: "Funktion",
FunctionColumn: "Funktionskolonne",
FunctionDefiniteArticle: "funktionen",
FunctionIsHiddenWarning: "Denne tæller indeholder en funktion, som ikke er vist i planen",
FunctionLabel: "Opret ny funktionskolonne",
FunctionPlan: "FunktionsPlan",
FunctionPlanDateNote: "Datonote",
FunctionPlanNote: "Plannote",
GamsErrorColumnHasMultipleFunctionIds: "Kan ikke importere til en kolonne der har flere funktioner",
GamsErrorColumnHasSubHeaders: "Kan ikke importere til en kolonne, der har underkolonner",
GamsErrorCouldNotFindDate: "Kan ikke finde dato",
GamsErrorCouldNotFindFunction: "Kan ikke finde funktion",
GamsErrorCouldNotFindPerson: "Kan ikke finde person",
GamsErrorEmptyFunctionName: "Tomt funktionsnavn",
GamsErrorInvalidDateIndex: "Ugyldigt datoindex",
GamsErrorNothingToImport: "Intet at importere",
GamsErrorPersonNotAvailableOnDate: "ikke tilgængelig d.",
GamsImportAvatarBusy: "Venter på at alle brikker bliver flyttet på serveren. Vent venligst.",
GamsImportDialogTitle: "GAMS-import",
GamsInstructionsPaste: "Indsæt (Ctrl-v) data kopieret fra GAMS-regneark",
GamsInstructionsUpload: "eller vælg en GAMS-fil:",
Gender: "Køn",
GenderFemale: "Kvinde",
GenderMale: "Mand",
GenderOther: "Ikke-binær/andet",
GetCallInErrorTitle: "TeamPlan har problemer med at hente mulige afløsere i øjeblikket",
GiveAway: "Afgiv",
GoBack: "Tilbage",
GoTo: "Gå til",
GoToEmployee: "Gå til medarbejder-ID",
GoToEmploymentStart: "Gå til ansættelsesstart",
GoToEndDay: "Gå til slutdagen",
GoToLogin: "Tryk på knappen for at komme til login",
GoToNextDay: "Gå til næste dag",
GoToNextMonth: "Gå til næste måned",
GoToNextWeek: "Gå til næste uge",
GoToOffer: "Gå til udbud",
GoToPreviousDay: "Gå til forrige dag",
GoToPreviousMonth: "Gå til forrige måned",
GoToPreviousWeek: "Gå til forrige uge",
GoToStartDay: "Gå til startdagen",
GoToSwap: "Gå til vagtbytte",
GoToToday: "Gå til i dag",
GoToWishPeriod: "Gå til ønskeperiode",
GoodAfternoon: "God eftermiddag",
GoodBeforenoon: "God formiddag",
GoodEvening: "God aften",
GoodMorning: "Godmorgen",
GoogleCalendarDescription: "Kalenderlinket kopieres til din udklipsholder, så du kan indsætte det i din Google kalender.",
GotPassword: "Har adgangskode ?",
Group: "Gruppe",
GroupPlanTitle: "Kolleger",
GroupingColumn: "Grupperingskolonne",
GroupingColumnTooltip: "Danner overskrift for underkolonner",
Groups: "Grupper",
GroupsFollowed: "Grupper du følger",
GroupsForEntirePlan: "Grupper for hele planen",
H: "t",
HandoverDefiniteArticle: "afgivelsen",
HaveAGreatDay: "Fortsat god dag",
Hello: "Hej",
HhMmSeparator: ".",
Hidden: "Skjult",
HiddenDueToPlanning: "Skjult pga. planlægning",
Hide: "Skjul",
HideAbsenceColumn: "Skjul fraværskolonnen",
HideAutoPlanning: "Skjul autoplanlægning",
HideColumnDescriptionWork: "Når funktionen skjules bliver personer, der allerede er planlagt, vist i 'Andet arbejde'. Vis en skjult funktion, ved at oprette den ud fra en 'eksisterende funktion'.",
HideDates: "Skjul datoer",
HideFairness: "Skjul fordeling af funktioner",
HideFunctionColumn: "Skjul funktionskolonnen",
HideGroups: "Skjul grupper",
HideImperative: "Skjul",
HideRosterTemplates: "Skjul grundplaner",
HideStaffingStatus: "Skjul bemandingsstatus",
HideSubsectioning: "Skjul underinddeling",
HideWhenPrinting: "Skjul i udskrift",
History: "Historik",
Holiday: "Helligdag",
Hour: "Time",
Hours: "Timer",
HowMany: "Hvor mange ulæste hentes?",
HowManyRead: "Hvor mange læste hentes?",
HowManyUnread: "Hvor mange ulæste hentes?",
HttpStatus: "HTTP status",
IfItDeviatesSignificantly: "Hvis det afviger væsentligt fra det planlagte arbejde, skal du også angive en årsag.",
IfYouStartThePunchClockNow: "Hvis du starter stempeluret, stempler du ind undenfor vagt.",
Import: "Importér",
ImportError: "Kunne ikke importere data",
ImportFromAutoPlanning: "Importér forslag fra automatisk planlægning.",
ImportPersonalCalendarBody: "Vælg en personlig kalender som skal synkroniseres til MinPlan arbejdskalenderen:",
ImportPersonalCalendars: "Importer dine Personlige Kalendere",
ImportantMessage: "Vigtig besked",
Imported: "Importeret",
Importing: "Importerer",
IncludedWeekdays: "Ugedage inkluderet i tællere:",
Info: "Information",
Initials: "Initialer",
InputWorkTimeOn: "Intast din arbejdstid på",
InputWorkTimeOnMultiple: "Intast din samlede arbejdstid på",
Inquiry: "Forespørgsel",
InsertMultipleTimes: "Indsæt flere gange på samme dag",
Institution: "Institution",
InstitutionAndSalaryIdInvalid: "Tilføj '/' mellem institution og tjenestenummer",
InstitutionAndSalaryIdRequired: "Institution og tjenestenummer skal udfyldes",
InstitutionSlashSalaryId: "Institution/tjenestenummer",
InternalError: "Der skete en uventet fejl. Fejlen er rapporteret til vores driftsafdeling.",
InternalMessage: "Intern besked",
InternalMessages: "Interne beskeder",
InvalidDate: "Ugyldig dato",
InvalidDemand: "Ugyldig behov.",
ItemType_Array: ["Ukendt","Arbejde","Fravær","Andet","Rolle","Præference","Opgave","OnCall","Personlig Kalender"] as const,
ItemTypeWish_Array: ["Ukendt","Arbejdsønske","Fraværsønske","Andet","Rolle","Rådighedsønske","Opgave","Personlig Kalender"] as const,
JumpToNext: "Hop til næste",
Keep: "Behold",
KeepChanges: "Behold ændringer",
KeepExchange: "Behold byt",
KeepOffer: "Behold udbud",
KilometresShort: "km",
Kind_Array: ["Fravær","Aktivitet","Rådighed","Behov","Vikar","Kan arbejde","Vagt","Byt","Forespørgsel","Planstatus","Opgave","Bytbar","Funktion","Diæt","Kørselspenge","Præference: Vil gerne holde fri","Præference: Vil gerne arbejde"] as const,
LabelNegativePreference: "Vil gerne holde fri",
LabelPositivePreference: "Vil gerne arbejde",
Language: "Sprog",
LanguageLabel: "Dansk",
LeaveClockPoint: "Forlad ClockPoint",
LeaveEarly: "Gå tidligt",
LeftArrow: "Venstre pil",
LeftEarly: "Gik for tidligt",
LeftLate: "Gik for sent",
LegendCalendarEvent: "Personlig kalender",
LegendPlannedAbsence: "Planlagt fravær",
LegendPlannedAvailability: "Planlagt rådighed",
LegendPlannedOnCall: "Planlagt on call",
LegendPlannedOther: "Andet planlagt",
LegendPlannedRole: "Planlagt rolle",
LegendPlannedTask: "Planlagt opgave",
LegendPlannedWork: "Planlagt arbejde",
LegendRejectedAbsence: "Afvist fraværsønske",
LegendRejectedAvailable: "Afvist Rådighedsønske",
LegendRejectedOnCall: "Afvist on call",
LegendRejectedOther: "Afvist andet",
LegendRejectedRole: "Afvist rolle",
LegendRejectedTask: "Afvist opgave",
LegendRejectedWork: "Afvist arbejdsønske",
LegendUndecidedAbsence: "Fraværsønske (afventer planlægger)",
LegendUndecidedAvailable: "Rådighedsønske (afventer planlægger)",
LegendUndecidedOnCall: "On call ønske (afventer planlægger)",
LegendUndecidedOther: "Andet ønske (afventer planlægger)",
LegendUndecidedRole: "Rolle ønske (afventer planlægger)",
LegendUndecidedTask: "Opgave ønske (afventer planlægger)",
LegendUndecidedWork: "Arbejdsønske (afventer planlægger)",
LegendUnmergeableAbsence: "Kan ikke behandle fraværsønske",
LegendUnmergeableAvailable: "Kan ikke behandle rådighedsønske",
LegendUnmergeableOnCall: "Kan ikke behandle on call ønske",
LegendUnmergeableOther: "Kan ikke behandle andet ønske",
LegendUnmergeableRole: "Kan ikke behandle rolle ønske",
LegendUnmergeableTask: "Kan ikke behandle opgave ønske",
LegendUnmergeableWork: "Kan ikke behandle arbejdsønske",
List: "Liste",
LoadEmployeeDataError: "Der opstod en fejl under indlæsning af medarbejderdata.",
Loading: "Indlæser",
LoadingColors: "Indlæser farver...",
LoadingColumns: "Indlæser kolonner...",
LoadingContacts: "Indlæser kontaktoplysninger...",
LoadingData: "Øjeblik, vi henter dine data",
LoadingDays: "Indlæser dage...",
LoadingGroups: "Indlæser grupper...",
LoadingShifts: "Henter vagter",
Location: "Sted",
Lock: "Lås",
LockPlan: "Lås periode",
LockPlanHelpText: "Den valgte dag bliver første dag i ønskeperioden",
LockPlanUntil: "Lås periode frem til",
Locking: "Låser",
LogInWithYourStaffPlanUser: "Log ind med din VagtPlan-bruger.",
LogOut: "Log af",
LoggedOn: "Logget på",
LoggingIn: "Logger på...",
LoggingInAsSupportInfo: "Du er ved at logge ind som support.",
LoggingOff: "Logger ud",
Login: "Log ind",
LoginButtonSendNewCode: "Send ny kode",
LoginButtonTitleRequestCode: "Anmod om adgangskode",
LoginButtonTitleSetPassword: "Skift adgangskode",
LoginButtonTitleSignin: "Log ind",
LoginCodeRequired: "Kodefeltet skal udfyldes",
LoginLabelPassword: "Adgangskode",
LoginLabelUsername: "Brugernavn",
LoginLoadingData: "Lige et øjeblik,\ndin app henter data",
LoginPasswordExpired: "Din kode er udløbet. Lav venligst en ny kode.",
LoginPasswordNoBlackSpacesAtStartOrEnd: "Dit brugernavn må ikke starte eller slutte med mellemrum",
LoginPasswordRequired: "Adgangskoden skal udfyldes",
LoginRepeatPasswordHint: "Begge adgangkoder skal være ens",
LoginRepeatPasswordMismatch: "Den indtastede adgangskode matcher ikke den nye adgangskode",
LoginTitle: "Log på",
LoginTitleWelcome: "Velkommen til",
LoginUsernamePasswordError: "Kunne ikke logge ind. Kontroller brugernavn og adgangskode",
LoginUsernameRequired: "Brugernavn feltet skal udfyldes",
Logoff: "Log ud",
LogoffConfirmation: "Er du sikker på, at du vil logge ud af FunktionsPlan?",
LogonADFSPortal: "Log på",
LogonAgain: "Log venligst på igen",
Logout: "Log ud",
M: "m",
MakeOffer: "Foreslå byt",
ManyPersonGroupsContent: "Da du har adgang til mere end 10 personalegrupper, henter appen først data fra en personalegruppe når denne tilgåes.",
ManyPersonGroupsTitle: "Mange personalegrupper",
Margin: "Margin",
MarkAsRead: "Markér som læst",
MarkAsUnread: "Markér som ulæst",
MaxLengthError: "Du kan ikke skrive flere tegn",
Me: "Jeg",
MeAlt: "Mig",
MemberOfRollInPeriods: "Medlem af rul i perioder:",
Menu: "Menu",
MenuExpandLess: "Færre",
MenuExpandMore: "Flere",
MenuItemTitleWork: "Arbejde",
Message: "Besked",
MessageCannotBeBlank: "Beskeden kan ikke være tom",
MessageCouldNotBeSent: "Beskeden kunne ikke sendes",
MessageFollowUpSetToOff: "Fjern opfølgningsflaget",
MessageFollowUpSetToOn: "Sæt opfølgningsflaget",
MessageGlobalSetToOff: "Beskeden er offentlig",
MessageGlobalSetToOn: "Markér som offentlig",
MessageInternalSetToOff: "Beskeden er intern",
MessageInternalSetToOn: "Markér som intern",
MessageIsPublic: "Beskeden er offentlig.",
MessageIsUnread: "Beskeden er ulæst.",
MessagePeriodOverlaps: "Notens periode ligger udenfor den viste periode",
MessagePersonalSetToOff: "Beskeden er personlig",
MessagePersonalSetToOn: "Markér som personlig",
MessageRecipientsCannotBeBlank: "Du skal angive en modtager for at kunne sende beskeden.",
MessageSent: "Beskeden er sendt",
Messages: "Beskeder",
MessagesEmptyStateTitle: "Ingen beskeder",
MessagesFilterColleague: "Kollega",
MessagesFilterDay: "Dag",
MessagesFilterInfo: "Info",
Minute: "Minut",
Minutes: "Minutter",
MissingClockOut: "Manglende udstempling",
Mobile: "Mobil",
MobilePhone: "Mobiltelefon",
ModifiedDuties: "Tilpassede tjenester",
ModifiedDuty: "Tilpasset tjeneste",
MomentLoadingData: "Øjeblik, vi henter data",
Month: "Måned",
Month_Array: ["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"] as const,
MonthOverview: "Månedsoversigt",
MoveImperative: "Flyt",
MoveLeft: "Flyt til venstre",
MoveOn: "Kom videre",
MoveRight: "Flyt til højre",
MoveToAbsence: "Flyt til fravær",
MultifunctionRules: "Multifunktionsregler",
MyContactInfo: "Mine kontaktoplysninger",
MyPlan: "MinPlan",
MyPlanPreference: "Præference",
MyPlanWish: "Ønske",
Name: "Navn",
NameAlreadyUsed: "Navnet er allerede brugt",
NameInVagtplan: "Navn i VagtPlan",
NameRequired: "Indtast venligst navn",
NaturalNumberRequired: "Tal krævet.",
NavigateAwayFromEditedDayViewWarning: "Fortryd eller gem ændringer før du forlader siden",
NetworkErrorOccured: "Der skete en netværksfejl",
New: "Ny",
NewAutoplanJob: "Ny autoplanlægningsjob",
NewColleagueMessage: "Ny kollega besked",
NewEllipsis: "Ny...",
NewFunction: "Ny funktion",
NewMessage: "Ny besked",
NewPasswordIsEmpty: "Ny adgangskode må ikke være tom",
NewPhysicianPlanName: "Ny funktionsplansnavn",
NewRegistration: "Ny registrering",
NewRosterItemTitle: "Ny",
NewSubcolumn: "Opret ny underkolonne",
NewTemplate: "Ny grundplan",
NewVersionAvailable: "Ny version tilgængelig",
News: "Nyheder",
NewsExchange: "Nye byt",
Next: "Næste",
NextRolloutDate: "Næste udrulningsdato",
No: "Nej",
NoAccess: "Ingen adgang.",
NoAccessToTeamPlan: "Du mangler de nødvendige rettigheder for at få adgang til TeamPlan.",
NoCameraFound: "Intet kamera fundet på enheden.",
NoCandidates: "Ingen oplagte kandidater",
NoCandidatesLong: "Der er desværre ingen kandidater at vise i den sorterede tilkaldeliste.",
NoChanges: "Ingen ændringer",
NoChangesHaveBeenMade: "Der er ikke ændret nogen vagter for denne personalegruppe.",
NoColumnsStarred: "Ingen kolonner med stjerner",
NoConfiguration: "Planen har ingen opsætning for fordeling af funktioner. Klik på tandhjulet i øverste højre hjørne for at konfigurere.",
NoDaysSelected: "Ingen ugedage valgt",
NoDownloadLinkAvailable: "Ingen downloadlink tilgængelig",
NoEndDate: "Ingen slutdato",
NoEvents: "Ingen aftaler",
NoNetwork: "Din app har brug for internetforbindelse for at virke",
NoNetworkButton: "Prøv igen",
NoNetworkCheckInternet: "Tjekke om du er på internettet?",
NoNetworkContactIT: "Hvis du får denne meddelelse selvom din internetforbindelse fungerer, så kontakt IT-support på din arbejdsplads for at få hjælp.",
NoNetworkCouldYouTry: "Kunne du prøve at:",
NoNetworkSwitch: "Skifte til et andet netværk?",
NoNetworkTitle: "Din app har brug for internetforbindelse for at virke",
NoOfWeeks: "Antal uger",
NoOffersInSearch: "Der er ingen personalegrupper der matcher din søgning.",
NoPassword: "Ingen adgangskode ?",
NoPersonelGroupFollowedTextMobile: "Swipe til venstre på en gruppe og vælg",
NoPersonelGroupFollowedTextWeb: "Hold musen hen over en gruppe og tryk på de tre prikker, for at følge.",
NoPersonelGroupFollowedTitle: "Du følger ingen grupper",
NoPlannedShiftAtTheMoment: "Ingen planlagt vagt lige nu",
NoPlannedShiftsForClockIn: "Du har i øjeblikket ingen planlagte vagter at stemple ind på.",
NoPlannedWorkCurrently: "Intet planlagt arbejde lige nu",
NoPlans: "Ingen planer.",
NoRegistrationOnDay: "Du har ingen planlagte begivenheder eller registreringer på denne dag",
NoReusableTemplates: "Alle eksisterende grundplaner er allerede tilføjet",
NoSearchResults: "Ingen søgeresultater",
NoShiftMatch: "Der er ingen vagter\nder matcher din søgning.",
NoShifts: "Ingen vagter",
NoStartDate: "Ingen startdato",
NoSwapOptions: "Der findes ingen bytte muligheder.",
NoTasksToWishInThisPeriod: "Ingen opgaver at ønske i denne periode",
NoTemplates: "Der er ikke defineret nogen grundplaner",
NoThanks: "Nej tak",
NoUnresolvedIssues: "Ingen udeståender",
NonPlanned: "Ikke planlagte",
None: "Ingen",
NoneSelectedSaveWarning: "Vær venlig at vælge en type før du gemmer",
NonemptyTextRequired: "Tekst er krævet.",
Norm: "Norm",
NormalSize: "Almindelig størrelse",
NotAssignable: "Kan ikke tildeles",
NotOnInternalNet: "Ikke tilsluttet virksomhedens netværk",
NotOnInternalNetDescription: "Stempeluret virker kun med virksomhedens interne netværk. Sørg for, at du er tilsluttet det rette Wi-Fi.",
NotSet: "Ikke sat",
NotSpecified: "Ikke angivet",
Note: "Note",
NoteImperative: "Bemærk",
Notes: "Noter",
NothingPlanned: "Intet planlagt",
NothingStarred: "Ingen kolonner/dage/personer med stjerner",
NotificationsOff: "Slå notifikationer fra",
NotificationsOn: "Slå notifikationer til",
NumRolls: "Antal rul",
NumWeeks: "Antal uger",
NumberOfContactColumns: "Antal kolonner til kontaktoplysninger",
NumberOfNoteColumns: "Antal kolonner til plan noter",
OddWeek: "ulige uge",
Of: "af",
Offer: "Udbyd",
OfferDefiniteArticle: "udbuddet",
OfferShift: "Udbyd vagt",
OfferTo: "Udbyd til",
OfferWillBeCancelled: "Udbud afbrydes",
OfferWillBeCancelledPleaseNote: "Vær opmærksom på, at denne vagt er udbudt på vagtbørsen. Hvis vagten slettes afbrydes udbuddet.",
OfferedThroughTempAgency: "Udbudt via vikarservice",
Offers: "Tilbud",
Ok: "OK",
OldRegistrations: "Tidligere registreringer",
OnTime: "Rettidigt",
OnlyShowStarred: "Vis kun kolonner/dage/personer med stjerner",
OpenCalendar: "Åbn kalender",
OpenPreferencePattern: "Åbn præferencemønster",
Opening: "Åbner",
OpeningPlan: "Åbner planen",
OpeningTemplates: "Åbner grundplaner",
OptionallyEditStartDate: "Ret evt. grundplanens startdato",
Or: "eller",
Order: "Bestilling",
Origin: "Startsted",
Original: "Oprindelig",
OriginalBelongingTo: "Oprindelig tilhørende",
OriginalDay: "Oprindelig dag",
Other: "Anden",
OtherAbsences: "Andet Fravær",
OtherEmployees: "Øvrige medarbejdere",
OtherFunction: "Anden funktion",
OtherGroups: "Øvrige grupper",
OtherSettings: "Andre indstillinger",
OtherWork: "Andet Arbejde",
OutOfViewport: "udenfor den åbnede periode",
OutsideEmploymentPeriod: "Udenfor ansættelsesperiode",
Overview: "Overblik",
OwnVehicle: "Eget køretøj",
Page: "Side",
PagingLoadNext: "Indlæs næste",
PagingLoadPrevious: "Indlæs forrige",
Password: "Adgangskode",
PasteImperative: "Sæt ind",
PatternCellAbsenceDescription: "enkeltstående fraværspræference i præferencemønsteret",
PatternCellWorkDescription: "enkeltstående arbejdspræference i præferencemønsteret",
PayerDepartment: "Betalerafdeling",
Pending: "Udestående",
People: "Mennesker",
Period: "Periode",
PeriodNextDay: "Næste dag",
PeriodPreviousDay: "Dagen før",
PeriodSameDay: "Samme dag",
PeriodWholeDay: "Hele dagen",
Periods: "Perioder",
Person: "Person",
PersonGroups: "Personalegrupper",
PersonGroupsNotLoaded: "Personalegrupper hvis data ikke er hentet er markeret med ikonet: ",
PersonIsApproved: "Der er godkendt til løn på dagen.",
PersonIsRealized: "Der er overført til løn på dagen.",
PersonIsWishing: "Ønskeperiode.",
PersonUnemployed: "Personen er ikke ansat.",
PersonUnemployedInThisPeriod: "Du er ikke tilknyttet en ansættelse i denne periode",
Personal: "Personlig",
PersonalCalendar: "Personlig Kalender",
PersonelGroupInfoBody1: "Bruger du en gruppe ofte, kan det være en god ide at følge den. Så henter app’en automatisk data for dig og du vil modtage notifikationer fra gruppen.",
PersonelGroupInfoBody2NonTouch: "Hold musen henover en gruppe og tryk på de tre prikker for at følge, stoppe med at følge eller slå notifikationer til og fra.",
PersonelGroupInfoBody2Touch: "Swipe mod venstre på en gruppe, for at følge eller slå notifikationer til/fra.",
PersonelGroupInfoBodyTouchSymbolExplanation: "Symbolforklaring:",
PersonelGroupInfoBodyTouchSymbolExplanationFetchData: "Hent data for en gruppe uden at åbne den",
PersonelGroupInfoBodyTouchSymbolExplanationUnreadChat: "Ulæste chat og interne beskeder",
PersonelGroupInfoBodyTouchSymbolExplanationUnresolved: "Udeståender",
PersonelGroupInfoTitle: "Hent og følg personalegrupper",
Persons: "Personer",
Phone: "Mobil",
Phone2: "Telefon 2",
PhoneInvalid: "Telefonnummer er ugyldigt",
PincodesDifferent: "Koder er ikke ens. Prøv igen.",
Place: "Sted",
Plan: "Plan",
Plan_Array: ["Ukendt","Planlagt","Oprindelig","Afventer godkendelse","Rettet af planlægger"] as const,
PlanButtonToday: "I dag",
PlanDayTitle: "Dag",
PlanId_Array: ["Ukendt","Planlagt","Publiceret","Ønsket","Registreret","Original"] as const,
PlanInfo: "Planoplysninger",
PlanListTitle: "Liste",
PlanMessages: "Beskeder i planen",
PlanMonthTitle: "Måned",
PlanPhasesSummary: "Til forskellige faser i planen skal du gøre forskellige ting for at skabe den optimale plan for dig. Disse faser er markeret i planvisningerne med en planstatus. De enkelte faser er forklaret nedenfor.",
PlanStatus: "Plan status",
PlanStatus_Array: ["Ukendt","Lukket","Realiseret","Godkendt","Driftsperiode (tilretning)","Brugergodkendt","Tidsregistrering","Driftsperiode","Planperiode","Ønskeperiode","Fremtid","Personlig Kalender"] as const,
PlanWeekListTitle: "Ugeplan",
PlanWeekTitle: "Uge",
Planned: "Plan",
PlannedEnd: "Planlagt afsluttet",
PlannedWork: "Planlagt arbejde",
Planner: "Planlægger",
PlannerRejectRemark: "Besked ved afvisning",
PlannerRemark: "Note fra planlægger",
PlanningPeriod: "Planlægningsperiode",
PleaseNoteTheFollowingDuties: "Vær opmærksom på følgende tjenester:",
PollingFailExchange: "MinPlan kan ikke opdatere vagtbørsen i øjeblikket :(",
PollingFailLoadShifts: "TeamPlan kan ikke opdatere vagter i øjeblikket :(",
PollingFailMessages: "TeamPlan kan ikke hente chat og interne beskeder i øjeblikket :(",
PollingFailUnreadMessageCount: "TeamPlan kan ikke opdatere tælleren for ulæste chatbeskeder i øjeblikket :(",
PollingSuccessExchange: "Yay! MinPlan kan igen opdatere vagtbørsen.",
PollingSuccessLoadShifts: "Yay! TeamPlan kan igen opdatere vagter.",
PollingSuccessMessages: "Yay! TeamPlan kan igen hente chat og interne beskeder.",
PollingSuccessUnreadMessageCount: "Yay! TeamPlan kan igen opdatere tælleren for ulæste chatbeskeder.",
PopIn: "Pop ind",
PopOut: "Pop ud",
PortalName: "MinPlan",
PreferenceCellAbsenceDescription: "fraværspræference",
PreferenceCellWorkDescription: "arbejdspræference",
PreferenceInfoNegative: "Præference: Vil gerne holde fri",
PreferenceInfoPositive: "Præference: Vil gerne arbejde",
PreferencePatternBodyPart1: "Præferencemønsteret er din mulighed for at angive gentagende præferencer for hvornår du gerne vil arbejde og/eller holde fri.\n\nMed få klik kan du fortælle din planlægger at du f.eks. altid gerne vil holde fri tirsdag aften (hvor du går til badminton) eller foretrækker at arbejde i weekender i ulige uger (hvor dine børn er hos deres anden forælder).",
PreferencePatternBodyPart2Today: "Når du angiver nye præferencer i dit præferencemønster - eller laver om i de allerede eksisterende præferencer - gælder ændringerne fra og med i dag.",
PreferencePatternChangesApplies: "Ændringer gælder fra",
PreferencePatternChangesFromThisWeekApplies: "Ændringer til denne uge gælder fra",
PreferencePatternChooseWeeks: "Vælg hver uge eller hver anden uge",
PreferencePatternChooseWeeksTitle: "Vælg hvor ofte præferencerne i dit mønster skal gentage sig.\n\nHusk, at du altid kan slette mønsteret og oprette et nyt.",
PreferencePatternDeleteTitle: "Slet præferencemønster",
PreferencePatternEveryOtherWeek: "Hver anden uge",
PreferencePatternEveryWeek: "Hver uge",
PreferencePatternGetStarted: "Kom i gang",
PreferencePatternIndicatePreference: "Angiv præference",
PreferencePatternIndicatePreferenceText: "Angiv din præference for hvornår du gerne vil arbejde og/eller holde fri",
PreferencePatternInfoDisabled: "Du har slået præferencen (fra dit præferencemønster) fra på denne dato",
PreferencePatternInfoNegative: "Fra dit præferencemønster: Vil gerne holde fri",
PreferencePatternInfoPositive: "Fra dit præferencemønster: Vil gerne arbejde",
PreferencePatternNoPatternDescription: "Angiv et gentaget mønster for hvornår du gerne vil arbejde og/eller holde fri.",
PreferencePatternNoPatternHeading: "Intet mønster - endnu!",
PreferencePatternSubHeader: "Hvornår kan jeg se mine ændringer ude på ønskesiden?",
PreferencePatternTitle: "Hvad er et præferencemønster?",
PreferenceRejected: "Præference tilsidesat af funktion",
PreferenceWithExistingBodyPart1: "Din nye præference er i modstrid med en præference fra dit præferencemønster.",
PreferenceWithExistingBodyPart2: "Hvis du beholder den nye, bliver præferencen fra mønstret fjernet på denne dag.",
PreferenceWithExistingConfirm: "Ja, opret den nye",
PreferenceWithExistingTitle: "Er du sikker på at du vil oprette denne præference?",
PreferencesColumn: "Præferencer fra MinPlan",
PreparingDataForPrint: "Klargører data til print",
PresentDay: "Denne dag",
PresentMonth: "Denne måned",
PresentWeek: "Denne uge",
PreviousChoices: "Tidligere valg:",
PrintDateNotesHeader: "Dato noter",
PrintPlanNotesHeader: "Plan noter",
PrivacyPolicy: "Privatlivspolitik",
Problem: "Beklager, der er et problem.",
ProblemNet: "Beklager, der er et netværksproblem.",
ProblemTechnical: "Beklager, der er et teknisk problem.",
ProblemWithDay: "Din planlægger kigger på det",
ProblemWithHighlightedDay: "Den markerede dag skal behandles manuelt",
ProblemWithHighlightedDays: "De markerede dage skal behandles manuelt",
Processing: "Behandling",
Production: "Ordre",
Productionteam: "Ordrehold",
Profession: "Stillingsbetegnelse",
Program: "Projekt",
ProtocolError: "Protokolfejl",
PublishPlan: "Offentliggør plan",
Publishing: "Offentliggører",
PunchClock: "Stempelur",
PunchingErrorTitle: "Noget gik galt under stemplingen",
Purpose: "Formål",
QRErrorDescription: "Prøv at indtaste tjenestenummer i stedet",
QRNotFound: "QR-kode ikke genkendt",
Read: "Læst",
ReadMessagesAndNotes: "Læste chat- og interne beskeder",
ReadMessagesEmptyStateTitle: "Ingen læste beskeder",
ReadPluralPastTense: "Læste",
RealizedPeriod: "Realiseret periode",
ReasonForDeviationEnd: "Årsag til afvigende sluttid",
ReasonForDeviationStart: "Årsag til afvigende starttid",
Receive: "Modtag",
Receiver: "Modtager",
RecentlyUsedShiftDefs: "Senest anvendt",
Refresh: "Genopfrisk",
RegardingShort: "Vedr.",
Register: "Registrér",
RegisterTask: "Registrér opgave",
RegisterWorkTime: "Registrer arbejdstid",
RegisterWorkTimeHere: "Registrer din arbejdstid her",
RegisteredTask: "Registreret opgave",
RegisteredTasks: "Registrerede opgaver",
RegistrationNumber: "Registreringsnummer",
Registrations: "Registreringer",
Reject: "Afvis",
RejectShiftAssignment: "Bekræft afbrydelse af udbud",
RejectShiftAssignmentContent: "Er du sikker på, at du vil afbryde udbuddet i denne vagt?",
RejectShiftExchange: "Bekræft afvisning af bytte",
RejectShiftExchangeContent: "Er du sikker på, at du vil afvise dette vagtbytte?",
RejectedByPlanner: "Afvist af planlægger",
Relation: "Relation",
RelationAdd: "Tilføj pårørende",
RelationChild: "Barn",
RelationClose: "Nærmest pårørende",
RelationEdit: "Redigér pårørende",
RelationFriend: "Andet",
RelationParent: "Forælder",
RelationPartner: "Partner",
RelationSibling: "Søster/bror",
RelativesContactInfo: "Pårørendes kontaktoplysninger",
Remark: "Bemærkning",
Remove: "Fjern",
RemoveColour: "Fjern farve",
RemoveFromClipboard: "Fjern fra clipboard",
RemoveGroupColouring: "Fjern gruppefarvning",
RemoveImperative: "Fjern",
RemovePersonFromRoll: "Fjern personen fra rul:",
RemoveShift: "Slet vagt",
RemoveStar: "Fjern stjerne",
RemoveStars: "Ryd alle stjerner",
Repetition: "Gentagelse",
Reply: "Svar",
ReportTitle: "Aktiviteter",
Request: "Anmodning",
ResetActionButtonTitle: "Nulstil",
ResetNewPasswordRepeatTitle: "Gentag",
ResetNewPasswordTitle: "Ny adgangskode",
ResetPasswordSectionTitle: "Nulstil adgangskode",
ResetPasswordSuccess: "Den nye adgangskode er sat",
ResetPasswordTitle: "Gammel adgangskode",
Resolution: "Opløsning",
ResourceConstraintName: "Resursekrav",
Resources: "Ressourcer",
ResponseFromServer: "Svar fra server",
Restore: "Gendan",
RestoreDay: "Genskab dag",
RestoreOriginal: "Oprindelig plan",
RestoreOriginalDay: "Gendan oprindelig dag",
RestoreOriginalDayExplanation: "Vil du gendanne den oprindelige dag? Hvis du gendanner den oprindelige dag, vil alle registreringer blive slettet.",
RestoreOriginalPastMidnightNote: "Hvis du har vagter, der strækker sig over midnat, vil dine registreringer på næste dag for disse vagter også blive slettet.",
ReuseFunctionFromAnotherPlan: "Genbrug funktion fra anden plan",
ReusedPassword: "Den nye adgangskode er den samme som en af de tre sidste adgangskoder.",
RightArrow: "Højre pil",
Roll: "Rul",
RollingOut: "Udruller",
RollingOutToClosedColumn: "Du er ved at udrulle grundplan for funktioner, der er helt eller delvist skjulte i udrulningsperioden. Personer herpå vil automatisk blive flyttet til kolonnen 'Ikke planlagte'.",
RolloutTemplates: "Udrul grundplaner",
RolloutTimeoutErrorHtml: "Selvom udrulningen af grundplanen tager længere tid end forventet, er den stadig i gang.<br>Afvent resultatet af udrulningen, før du udruller en grundplan på ny.",
RolloutTimeoutErrorTitle: "Udrulning er stadig i gang",
RosterLineType_Array: ["Ukendt","Arbejde","Fravær","Syg","Droppet","Skjult"] as const,
Rule: "Regl",
RuleBreak: "Regelbrud",
RuleViolation: "Regelbrud",
RuleViolationInfo: "I den sorterede tilkaldeliste er medarbejderne sorterede efter hvor alvorligt et regelbrud der vil opstå, når en given medarbejder får vagten.\n\nRegelbruddets alvorlighed angives med et tal. Jo højere tal, jo mere alvorligt er regelbruddet.\n\n1 betyder at der ingen regelbrud opstår.",
RuleViolationInfoApplicants: "Listen af ansøgere er sorterede efter hvor alvorligt et regelbrud der vil opstå, når en given medarbejder får vagten.\n\nRegelbruddets alvorlighed angives med et tal. Jo højere tal, jo mere alvorligt er regelbruddet.\n\n1 betyder at der ingen regelbrud opstår.",
RuleViolationInfoSortedCallList: "I den sorterede tilkaldeliste er medarbejderne sorterede efter hvor alvorligt et regelbrud der vil opstå, når en given medarbejder får vagten.\n\nRegelbruddets alvorlighed angives med et tal. Jo højere tal, jo mere alvorligt er regelbruddet.\n\n1 betyder at der ingen regelbrud opstår.",
RuleViolationTitle: "Muligt brud på 11-timers reglen",
SalaryId: "Tjenestenummer",
SalaryIdDescription: "Hvis du ikke kan scanne din QR kode, kan du i stedet indtaste dit tjenestenummer.",
SalaryIdNotRecognized: "Tjenestenummer ikke genkendt",
Save: "Gem",
SaveAnyway: "Gem alligevel",
SaveChanges: "Gem ændringer",
SaveChangesToPlanDescription: "Der er lavet ændringer til planen. Vil du gemme ændringerne?",
SaveChangesToPlanTitle: "Gem ændringer til planen?",
SaveDay: "Gem dag",
SaveGroups: "Gem grupper",
Saved: "Gemt",
Saving: "Gemmer...",
SavingConfiguration: "Gemmer konfiguration...",
SavingDemandTemplate: "Gemmer behovsgrundplan",
SavingPlan: "Gemmer planen.",
SavingWorkingHours: "Gemmer arbejdstider...",
Scan: "Scan",
ScanQRCodeToClockInOut: "Scan din QR-kode for at stemple ind eller ud",
ScheduledColleagues: "Planlagte kolleger",
Search: "Søg",
SearchForColleague: "Søg efter kollega",
SearchNoResults: "Der er desværre ingen kollega ved navn",
SecondWeek: "Anden uge",
Security: "Sikkerhed",
SeeDeputyOffer: "Se udbud",
SeeShift: "Se vagt",
SeeSwap: "Se byt",
SeeYouSoon: "Vi ses",
SelectAbsenceBack: "Vælg dato",
SelectAbsenceType: "Vælg fraværstype",
SelectAbsenceTypes: "Vælg fraværstyper",
SelectAll: "Vælg alle",
SelectAtLeastOneFunction: "Vælg mindst én funktion",
SelectAtLeastOneGroup: "Vælg mindst én gruppe",
SelectAtLeastTwoFunctions: "Vælg mindst to funktioner",
SelectCameraDescription: "Vælg hvilket kamera du vil bruge til at scanne QR-koden med",
SelectCandidateExplanation: "Filtrér på hvilke medarbejdere der ikke får vagten tilbudt.",
SelectCategory: "Vælg en kategori:",
SelectColour: "Vælg farve",
SelectColumnType: "Vælg kolonnetype:",
SelectCounter: "Vælg en tæller:",
SelectCountersForTotalCounter: "Vælg tællere der skal tælles med:",
SelectDate: "Vælg dato",
SelectEmployment: "Vælg ansættelse",
SelectFairnessGroups: "Vælg hvilke personalegrupper der skal vises fordeling for.",
SelectFunctionColumn: "Vælg funktionskolonne",
SelectFunctions: "Vælg funktioner der skal tælles med:",
SelectLanguage: "Vælg sprog",
SelectNone: "Ryd alle",
SelectNoneSelected: "Vælg",
SelectPeriod: "Vælg periode",
SelectPeriods: "Vælg perioder",
SelectShiftType: "Vælg vagttype",
SelectStaffGroups: "Vælg grupper",
SelectStartDate: "Vælg startdato",
SelectTheDay: "Vælg dagen",
SelectThePersonGroup: "Vælg personalegruppen",
SelectTheShift: "Vælg vagten",
SelectTotalCounter: "Vælg en total-tæller:",
SelectType: "Vælg type",
SelectViewMode: "Vælg visningstilstand",
SelectWorkingHours: "Vælg arbejdstid",
SelfPlannedTask: "Selvplanlagt opgave",
Send: "Send",
SendMessage: "Send besked",
SendToRollout: "Send til udrulning",
Sending: "Sender...",
SendingMessage: "Sender beskeden...",
Sent: "Sendt",
SentToExchange: "Sendt til vagtbørs.",
SessionExpired: "Sessionen er udløbet. Log på igen",
SetPlanningStart: "Sætter planlægningsstart",
SetRequestStart: "Sætter ønske-start",
SettingsCouldNotBeOpened: "Indstillinger kunne ikke åbnes",
SetupLastEditedBy: "Opsætning sidst rettet af",
ShStatus: "SH status",
Shift: "Vagt",
ShiftCode: "Vagtkode",
ShiftCounterListEmpty: "ShiftCounterList mangler at blive udfyldt",
ShiftCounterUnit_Array: ["NOT_USED","timer","dage","beløb"] as const,
ShiftDefiniteArticle: "vagten",
ShiftHoursHaveBeenModified: "Arbejdstiden er blevet tilpasset",
ShiftLabel: "Opret vagtkolonne (typisk døgnvagt efterfulgt af frihed)",
ShiftStatusAbsent: "Fraværende",
ShiftStatusActionRequired: "Kræver handling",
ShiftStatusDeputyOffered: "Vikarudbudt",
ShiftStatusNoActivities: "Arbejde uden aktiviteter",
ShiftStatusOffered: "Udbudt - endnu ingen ansøgere",
ShiftStatusPlanned: "Planlagt arbejde",
ShiftStatusReplaced: "Afløst",
ShiftStatusSubstitute: "Afløser",
ShiftType: "Vagt type",
ShiftTypeNotAvailable: "Vagttypen er ikke tilgængelig for denne personalegruppe",
ShiftTypeNotAvailableExplanation: "Hvis du ændrer vagttypen, kan du ikke skifte tilbage, efter du har gemt.",
ShiftsAndAbsence: "Vagter og fravær",
ShiftsExchange: "Vagtbyt",
Show: "Vis",
ShowAllColumnsDays: "Vis alle kolonner/dage/personer",
ShowAutoPlanning: "Vis autoplanlægning",
ShowDates: "Vis datoer",
ShowFaces: "Vis ansigter",
ShowFairness: "Vis fordeling af funktioner",
ShowGroups: "Vis grupper",
ShowHistory: "Vis historik",
ShowInactivePlans: "Vis inaktive planer",
ShowInitials: "Vis initialer",
ShowNumberOfPeople: "Vis antal personer",
ShowPeople: "Vis personer",
ShowRosterTemplates: "Vis grundplaner",
ShowSubsectioning: "Åbn og vis underfunktioner",
ShowTotals: "Vis totaler",
Showing: "Viser",
SignIn: "Tjek ind",
SignOut: "Tjek ud",
SignatureExplanation: "Symbolforklaring",
SingleApplicant: "Der er pt. 1 ansøger",
SingleApplicantFromShiftExchange: "1 ansøger på vagtbørs",
SixthWeek: "6. uge",
Speciality: "Specialer",
SpecifiedTimeIsOverlapping: "Den angivne tid overlapper med en anden registrering",
Specify: "Angiv",
SpecifyAutoPlanJobLabel: "Skriv autoplanlægningsjobslabel",
SpecifyCause: "Angiv årsag",
SpecifyEndTime: "Angiv sluttidspunktet.",
SpecifyRecipient: "Angiv modtager",
SpecifyStartTime: "Angiv starttidspunktet.",
SpecifyTime: "Angiv tid",
Spent: "Afholdt",
StaffingStatus: "Bemandingsstatus",
StarImperative: "Sæt stjerne",
StarShift: "*-vagt",
Start: "Start",
StartBeforeMidnight: "Start før midnat?",
StartDate: "Startdato",
StartOfPlanning: "Start af planlægning",
StartOrEndTimeHasBeenChanged: "Start- og/eller sluttidspunktet for denne vagt er blevet ændret.",
StartTemplateWeek: "Start med grundplansuge",
StartTime: "Starttid",
StartYesterday: "Start i går?",
StartedEarly: "Kom for tidligt",
StartedLate: "Kom for sent",
Status: "Status",
StatusFromShiftMarket: "Status fra vagtbørs",
StdHours: "Normtimer",
Stop: "Stop",
StopExport: "Stop eksport",
StopExportWarning: "Hvis du stopper eksport af arbejdskalender, vil kalenderen forsvinde alle de steder du har delt den.\n\nDet er nødvendigt at du kopierer et nyt link, hvis du vil eksportere igen. Det gamle link vil ikke virke mere.",
StopExportWorkCalendar: "Stop eksport af arbejdskalender",
Stopped: "Stopped",
Sum: "Sum",
SwapDefiniteArticle: "byttet",
SwapGiveAway: "Afgiv vagt",
SwapShift: "Byt vagt",
SwapWith: "Byt med",
Switch: "Skift",
SwitchPlan: "Skift plan",
SwitchToEditView: "Skift til redigeringsvisning",
SwitchToPrintView: "Skift til udskriftsvisning",
Synchronizing1Item: "Overfører 1 registrering.",
SynchronizingPlan: "Synkroniserer planen.",
SynchronizingPlanPlaces: "Synkroniserer behov.",
SynchronizingTemplatePlaces: "Synkroniserer behov (grundplaner).",
SynchronizingTemplates: "Synkroniserer grundplaner.",
SysRemarkUnmergeable: "Dagen er låst, og din registrering vil blive behandlet af din planlægger.\n\nHvis du ønsker at foretage ændringer, kan du låse dagen op ved at fortryde ønsket.\nTryk på: ",
SysRemarkUnmergeablePlural: "Dagene er låst, og dine registreringer vil blive behandlet af din planlægger.\n\nHvis du ønsker at foretage ændringer, kan du låse dagene op ved at fortryde ønskerne.\nTryk på: ",
Sysremark: "Planlægger",
Take: "Tag",
Takeshift: "Tag vagt",
Task: "Opgave",
TaskDefiniteArticle: "opgaven",
TaskRegistration: "Opgaveregistrering",
TaskStatus_Array: ["Planlagt","Påbegyndt","Færdig","Aflyst"] as const,
Tasks: "Opgaver",
Taskteam: "Opgavehold",
Team: "Personalegrupper",
TeamPlan: "TeamPlan",
TechnicalDetails: "Tekniske detaljer",
Templates: "Grundplaner",
ThankYou: "Tak",
TheAppVersionIsOutDated: "App versionen er forældet",
TheColumn: "Kolonnen",
TheDate: "den",
TheErrorMessageWasCopied: "Fejlteksten blev kopieret til udklipsholderen",
ThePlanner: "Planlæggeren",
TheSpecifiedTimeOverlapsWith: "Den angivne tid overlapper med",
TheSpecifiedTimeOverlapsWithTheFollowing: "Den angivne tid overlapper med følgende vagter:",
TheSpecifiedTimesOverlapWith: "De angivne tider overlapper med",
TheSpecifiedTimesOverlapWithTheFollowing: "De angivne tider overlapper med følgende vagter:",
ThisAppliesToFunctions: "Dette gælder følgende funktionskolonner:",
ThisShiftHasBeenModified: "Denne vagt er blevet tilpasset",
TileAlreadyHasAvatar: "Der findes allerede en registrering for den samme person og den samme funktion på dagen.",
Time: "Tid",
TimeOff: "Holde fri",
TimeRegistration: "Tidsregistrering",
TimeRegistrationExplanation: "Registrér hvornår din arbejdsdag er startet og sluttet.",
TimeRegistrations: "Tidsregistreringer",
TimeSpecifiedUponSelection: "Tid angives ved valg",
TimestampsFromPunchClock: "Stemplinger fra stempelur",
TimestampsFromStopwatch: "Stemplinger fra stempelur",
To: "Til",
ToHours: "Til timer",
ToInclusive: "Til og med",
ToMinutes: "Til minutter",
Today: "I dag",
TooManyGroupsAlertBody: "For at undgå at app'en bliver langsom, er der begrænsning på hvor mange medarbejdere den kan hente data på samtidig.\n\nDerfor skal du først frigøre plads ved at fjerne en af de eksisterende grupper, hvis du ønsker at tilføje en ny.\n\nVær opmærksom på at det kan være nødvendigt at fjerne flere små grupper for at gøre plads til en stor.",
TooManyGroupsAlertTitle: "Der er ikke plads til at følge flere grupper",
Total: "Total",
TotalCounterStatusText: "En total-tæller opsummerer udvalgte tællere fra de øvrige kategorier.",
TotalTime: "Samlet tid",
Totals: "Totaler",
TotalsChangedByEmployeeInfoText: "Du har selv lavet ændringer på denne dag, efter planen er blevet frigivet. Du kan se den oprindelige plan ved at trykke på dagen her på siden.",
TotalsChangedByPlannerInfoText: "Din planlægger har lavet ændringer på denne dag, efter planen er blevet frigivet. Du kan se den oprindelige plan ved at trykke på dagen her på siden.",
TotalsTitle: "Timesaldo",
TotalsTitleShort: "Saldi",
TotalsUltimoAbbreviation: "Disp.",
TouchId: "Touch ID",
TransferPlanFrom: "Overfør plan fra",
TransferPlanTo: "Overfør plan til",
TransferingPlan: "Overfører plan",
TryAgain: "Prøv igen",
TryAgainOrLoginAsUsual: "Prøv igen eller log ind som normalt.",
TurnOn: "Slå til",
Type: "Type",
TypeCategory: "kategorien",
TypeCounter: "tælleren",
TypeTotalCounter: "total-tælleren",
UnableToOpenSettingsTryManually: "Vi kunne desværre ikke åbne indstillingerne automatisk. Prøv venligst at åbne telefonens indstillinger manuelt.",
UnderPlanning: "Under planlægning",
Understood: "Forstået",
UnfollowDialogTitle: "Følg ikke længere gruppe",
UnfollowGroup: "Følg ikke længere",
Unknown: "Ukendt",
UnknownError: "ukendt fejl",
UnknownLowercase: "ukendt",
UnlimitedDemand: "Ubegrænset behov",
UnmergeableErrorMessage: "Ønsket er registreret, men afventer planlæggers behandling.",
Unread: "Ulæst",
UnreadMessages: "Ulæste beskeder",
UnreadMessagesAndNotes: "Ulæste chat- og interne beskeder",
UnreadMessagesEmptyStateTitle: "Ingen ulæste beskeder",
UnreadPluralPastTense: "Ulæste",
UnscheduledWork: "Ikke planlagt arbejde",
Unspecified: "Uspecificeret",
Unverified: "Under behandling...",
UpdateNow: "Opdatér nu",
Url: "URL",
UsePreference: "Anvend præference",
UsePreferenceDetails: "Slå fra, hvis du ikke ønsker at præferencemønsteret skal gælde for denne dag.",
Used: "Brugt",
User: "Bruger",
UserInfoLabelEmployed: "Ansat",
UserInfoLabelSallaryId: "Tjenestenr.",
UserInfoLabelTitle: "Titel",
UserInfoTitle: "Om mig",
UserInitials: "Initialer",
UserNameIsRequired: "Brugernavn skal udfyldes",
Vacation: "Ferie",
ValidUntil: "Gyldig indtil",
Validities: "Validiteter",
Verifying1Item: "Behandler 1 registrering.",
Version: "Version",
VersionNotSupported: "Version ikke understøttet",
Via: "Via",
Warning: "Advarsel",
WarningFirstPeriodCreated: "Når du opretter en periode, vil personer der er planlagt udenfor periodens tidsrum, blive flyttet til 'Ikke planlagte'.",
Week: "Uge",
Weekday_Array: ["Mandag","Tirsdag","Onsdag","Torsdag","Fredag","Lørdag","Søndag"] as const,
WeekdayInitials_Array: ["M","T","O","T","F","L","S"] as const,
Weeks: "Uger",
WeeksLowercase: "uger",
What: "Hvad",
WhatPlanPhasesAreThere: "Hvad er planens faser?",
When: "Hvornår",
WhenChangingOrganisationLocalDataIsDeleted: "Når du skifter organisation, vil dine lokale appindstillinger, som eks. kalender synkronisering med andre kalendere, blive slettet.",
WhenDidYouEnd: "Hvornår afsluttede du arbejdet?",
WhenDidYouStart: "Hvornår begyndte du på arbejdet?",
Whenever: "Når som helst",
WhereToFindDepartments: "Du finder personalegrupperne under \"Skift gruppe\" i bunden af skærm.",
WhichVersionIsThis: "Hvilken version er dette?",
Who: "Hvem",
WhoDoYouWantToSwapWith: "Hvem vil du bytte med?",
Whoever: "Hvem som helst",
WillBeDeletedWithTheShift: "Slettes sammen med vagten:",
Wish: "Ønsk",
WishPeriod: "Ønskeperiode",
WishRejected: "Ønske tilsidesat af funktion",
WishStatus: "Ønskestatus",
WishTitle: "Ønsker",
Wishes: "Ønsker",
WishesAndRegistrations: "Ønsker og tidsregistreringer",
WishesDurationExplanation: "Du kan ændre tiden på de ønsker, der er angivet som redigerbare.\n\nNår du opretter ønsker uden prædefineret tid, bliver du bedt om at angive tiderne.\nØnsker med prædefineret tid oprettes med det samme.\n\nHvis du efterfølgende vil justere tiden, kan du blot klikke på det pågældende ønske.",
With: "Med",
WithContacts: "Med kontaktoplysninger",
WithDatePlanNotes: "Med dato noter",
WithPlanNotes: "Med plan noter",
WorkHoursTimeoutErrorHtml: "Selvom ændringen af arbejdstid tager længere tid end forventet, er den stadig i gang.<br>Afvent resultatet, før du eventuelt gentager handlingen.",
WorkHoursTimeoutErrorTitle: "Ændring af arbejdstid er stadig igang",
WorkdayStatusNoRegistrations: "Oprindelig",
WorkdayStatusNonnegative_Array: ["Ubehandlet","Godkendt","Afventer Planlægger","Afvist","Kunne ikke behandles","Ubehandlet","Oprindelig","Medarbejderregistreret","Ubehandlet","Ubehandlet","Rettet af planlægger","Ubehandlet"] as const,
Working: "Arbejde",
WorkingHoursHelp: "Hold ctrl-tasten nede for at markere flere funktioner og grupper.",
Workload: "Arbejdsgrad",
WouldLikeToTakeTimeOff: "Vil gerne holde fri",
WouldLikeToWork: "Vil gerne arbejde",
WouldYouLikeToUseBiometricLoginEnableInSettings: "Vil du fremover logge ind med fingeraftryk og eller ansigtsgenkendelse? Det kræver at du slår det til i telefonens indstillinger.",
WriteComment: "Skriv kommentar",
WriteDateNote: "Skriv dato note",
WriteMessage: "Skriv besked",
WritePlanNote: "Skriv plan note",
Year: "År",
Yes: "Ja",
YesCancelOffer: "Ja, afbryd udbud",
YesConfirmCancel: "Ja, afbryd",
YesConfirmReject: "Ja, afvis",
YesConfirmSwap: "Ja, godkend byt",
YesLeavePage: "Ja, forlad side",
YesLogout: "Ja, log ud",
Yesterday: "I går",
YouAreInPlanningPeriod: "Du er i planlægningsperioden",
YouAreNotClockedIn: "Du er ikke stemplet ind",
YouAreOffline: "Kunne du prøve at:\n● Tjekke om du er på internettet?\n● Skifte til en andet netværk?\n\nHvis du får denne meddelelse selvom din internetforbindelse fungerer, så kontakt IT-support på din arbejdsplads for at få hjælp.",
YouAreRunning: "Du kører Funktionsplanlægning",
YouAreUsing: "Du bruger lige nu",
YouCannotStartAfterEnd: "Du kan ikke starte på arbejdet efter det planlagte sluttidspunkt.",
YouCannotStartThisEarly: "Du kan ikke starte så tidligt.",
YouCannotUseForbiddenCharacters: "Det er desværre ikke tilladt at bruge specialtegn.",
YouHaveFollowingPosibleAnswers: "Du fik følgende mulige svar på din bytteforespørgsel:",
YouHaveRejected: "Du har tidligere afvist:",
YouMustReload: "Du skal genindlæse planen, før du kan fortsætte.",
YouWillBeLoggedOutShortly: "Du bliver logget af om lidt",
YourAppIsHavingProblemsWithTheServer: "Din app har ikke kontakt med serveren",
YourPreferencePattern: "Dit præferencemønster",
YourWeek: "Din uge",
Zoom: "Zoom",
ZoomIn: "Zoom ind",
ZoomOut: "Zoom ud",
absence_plural: "Fravær",
absenceType: "Fraværstype",
accept: "Accepter",
additionalInformation: "Supplerende information",
all: "Alle",
allEmployees: "Alle medarbejdere",
alreadyClockedInOtherEmploymentDescription: "Indstemplingen på din anden ansættelse skal afsluttes, før du kan starte en ny.",
alreadyClockedInOtherEmploymentTitle: "Du er allerede stemplet ind",
alsoShifts: "også vagter",
and: "og",
appInformation: "App Information",
assignShift: "Tildel vagt",
assignShiftCandidateErrorTitle: "TeamPlan kunne desværre ikke tildele vagten",
assignShiftErrorTitle: "TeamPlan kunne ikke tildele vagten",
auditActionAcceptShiftExchange: "Accepter vagtbytte",
auditActionCalendar: "Kalender",
auditActionCancelExchange: "Fortryd vagtbytte",
auditActionChangeTeam: "Skift personalegruppe",
auditActionInit: "init",
auditActionSelectShift: "Vælg vagt",
auditActionToggleAllowNotifications: "Skift tillad Notifikationer",
back: "Tilbage",
callList: "Sorteret tilkaldeliste",
canProcessClockEventErrorTitle: "Hov! Du kan desværre ikke foretage stemplinger i øjeblikket",
cancelOfferOnShiftExchange: "Afbryd udbud på vagtbørs",
cancelOfferOnShiftExchangeErrorTitle: "Hov! Noget gik galt, da TeamPlan skulle afbryde udbuddet",
candidates: "Kandidater",
candidates_short: "Kand..",
caretDown: "Pil ned",
changePasswordErrorTitle: "Hov! Noget gik galt, da MinPlan skulle gemme dit nye kodeord",
check: "Flueben",
chooseAbsenceType: "Vælg fraværstype",
chooseLanguage: "Vælg sprog",
chooseTeam: "Vælg personalegruppe",
clear: "Ryd",
clearEmployeeWorkDayErrorTitle: "Hov! Noget gik galt, da MinPlan skulle genskabe den oprindelige dag",
createPreferencePatternErrorTitle: "Hov! Noget gik galt, da MinPlan skulle oprette dit præferencemønster",
createSharediCalendarErrorTitle: "Hov! Noget gik galt, da MinPlan skulle oprette kalenderlink",
deletePreferencePatternErrorTitle: "Hov! Noget gik galt, da MinPlan skulle slette dit præferencemønster",
deleteSharediCalendarErrorTitle: "Hov! Noget gik galt, da MinPlan skulle stoppe eksport af kalender",
editShiftErrorTitle: "Hov! Noget gik galt, da TeamPlan skulle gemme dine ændringer til vagten",
employeeDefiniteArticle: "medarbejderen",
endAbsenceErrorTitle: "Hov! Noget gik galt, da TeamPlan forsøgte at afslutte fraværet",
enterPassword: "Skriv adgangskode",
enterUserName: "Skriv brugernavn",
errRequestIsNotRequest: "Bytte udgiver-delen er ikke en udgiver del (requesterid referer ikke til et request). Dette må være en programmerings fejl i frontenden.",
exchange: "Byt",
exchangeAcceptErrorTitle: "TeamPlan kunne ikke godkende vagtbytte",
exchangeCandidateFilter: "Kandidatfilter",
exchangeCandidateFilter_callinEsque: "Vagter og beskyttet fravær (flere kand..)",
exchangeCandidateFilter_classic: "Vagter og fravær (færrest kandidater)",
exchangeCandidateFilter_noCallin: "Beskyttet fravær (flest kandidater)",
exchangeRejectErrorTitle: "TeamPlan kunne ikke afvise vagtbytte",
expectedToBeBack: "Forventet tilbage",
failedToDecodeSVG: "Kunne ikke afkode SVG-data",
findSubstitute: "Find afløser",
getAbsenceTypesErrorTitle: "TeamPlan kunne ikke hente listen med fravær",
getAllChatMessagesErrorTitle: "MinPlan kan ikke hente dine beskeder i øjeblikket",
getAllCounterDefinitionsErrorTitle: "Hov! Noget gik galt, da MinPlan skulle hente dine saldi",
getAllTotalRegistrationsErrorTitle: "MinPlan kan desværre ikke vise dine registreringer i øjeblikket",
getEmployeeDataErrorTitle: "MinPlan har problemer med at hente din oplysninger lige nu",
getEmployeesErrorTitle: "Hov! Noget gik galt, da TeamPlan skulle hente medarbejdernes oplysninger",
getExchangeErrorTitle: "TeamPlan kunne ikke hente al information om dette byt/udbud",
getGlobalSettingsErrorTitle: "Hov! Noget gik galt, da MinPlan skulle hente opsætningen",
getGroupRosterErrorTitle: "MinPlan kan desværre ikke vise dine kollegers planer i øjeblikket.",
getHolidaysErrorTitle: "TeamPlan har problemer med at hente helligdage i øjeblikket",
getInfoSharediCalendarErrorTitle: "MinPlan kan ikke hente data om dine kalenderlinks i øjeblikket",
getMessagesErrorTitle: "TeamPlan kan ikke hente chat og interne beskeder i øjeblikket",
getModifiedDutyLinesErrorTitle: "Hov! Noget gik galt, da TeamPlan skulle at hente vagtens tjenester",
getNormBalancesErrorTitle: "MinPlan kan desværre ikke vise din normbalance i øjeblikket",
getPreferencePatternEffectiveFromDateErrorTitle: "MinPlan kan ikke vise korrekt startdato på præferencemønster i øjeblikket",
getPreferencePatternErrorTitle: "MinPlan kan ikke hente dit præferencemønster i øjeblikket",
getPreferenceRosterErrorTitle: "MinPlan kan desværre ikke vise dine valgte præferencer i øjeblikket",
getPreferenceSortsErrorTitle: "MinPlan kan desværre ikke vise præferencer i øjeblikket.",
getRecipientsErrorTitle: "MinPlan kunne desværre ikke hente listen over mulige modtagere",
getRemovedRegistrationInfoErrorTitle: "Hov! Noget gik galt, da TeamPlan skulle hente vagtens aktiviteter",
getRosterErrorTitle: "MinPlan kunne desværre ikke hente din vagtplan i øjeblikket",
getRosterInitialErrorTitle: "MinPlan har problemer med at hente din vagtplan lige nu",
getRosterRefreshErrorTitle: "MinPlan kunne desværre ikke opdatere din vagtplan",
getSettingsErrorTitle: "Hov! Noget gik galt, da TeamPlan skulle hente opsætningen",
getShiftCandidateListErrorTitle: "Hov! Noget gik galt, da TeamPlan skulle hente den sorterede tilkaldeliste",
getShiftDefsErrorTitle: "TeamPlan kunne ikke hente listen med vagttyper",
getSortsErrorTitle: "Hov! Noget gik galt, da MinPlan skulle hente registreringsdefinitioner",
getTeamRosterErrorTitle: "TeamPlan har problemer med at hente personalegruppens arbejdsplan",
getTeamsErrorTitle: "Hov! Noget gik galt, da TeamPlan skulle hente personalegrupper",
getTokenForBiometricAuthErrorTitle: "MinPlan kan desværre ikke logge dig ind med biometri i øjeblikket",
getTotalDefinitionsErrorTitle: "Hov! Noget gik galt, da MinPlan skulle hente dine saldi",
getTotalRegistrationsErrorTitle: "MinPlan kan desværre ikke vise dine registreringer i øjeblikket",
getTotalsErrorTitle: "Hov! Noget gik galt, da MinPlan skulle hente dine saldi",
getUnreadMessagesCountErrorTitle: "Hov! Noget gik galt, da TeamPlan forsøgte at opdatere antallet af ulæste beskeder",
getVersionErrorTitle: "Hov! Noget gik galt, da TeamPlan skulle hente versionsnummer",
handoverShiftErrorTitle: "Hov! Noget gik galt, da MinPlan skulle afgive vagten",
hidePhoneNumber: "Skjul nummer for kollegaer",
killItemErrorTitle: "Hov! Noget gik galt, da MinPlan skulle fjerne ønsket",
killPreferenceErrorTitle: "Hov! Noget gik galt, da MinPlan skulle fjerne præferencen",
languageName: "Dansk",
limitedAccess: "Begrænset adgang",
limitedAccessDescription: "Du kan sende og se dine egne beskeder, men har ikke adgang til at se beskeder fra andre.",
loadMoreDays: "Indlæs flere dage",
loadingLong: " Vi laver lige de sidste beregninger",
loadingMedium: " Vi er snart klar",
loadingReallyLong: " Det tager lidt længere end normalt, men vi er stadig i gang",
loadingShort: " Øjeblik, vi forbereder dine muligheder",
login: "Log ind",
logonBiometricAuthErrorTitle: "Hov! Noget gik galt ved login",
logonOpenIdErrorTitle: "Hov! Noget gik galt ved login",
logonPasswordErrorTitle: "Hov! Noget gik galt ved login",
logonSupporterErrorTitle: "Hov! Noget gik galt ved login",
logonWindowsErrorTitle: "Hov! Noget gik galt ved login",
mail: "Mail",
markAsHandled: "Accepter uden afløser",
markAsHandledErrorTitle: "Hov! Noget gik galt, da TeamPlan forsøgte at acceptere vagten uden afløser",
markMessageAsReadErrorTitle: "MinPlan kunne desværre ikke markere beskeden som læst",
markMessagesAsReadErrorTitle: "TeamPlan kunne desværre ikke markere beskeden som læst",
netError: "Beklager, der er et netværksproblem, status:",
newPlural: "nye",
newSingular: "ny",
noAppInformation: "Ingen App Information fundet",
noDepartmentsSelected: "Ingen personalegruppe valgt",
noDepartmentsToShow: "Ingen personalegrupper at vise",
noEmployeeToShow: "Ingen ansat at vise",
noShiftsToShow: "Ingen vagter med ulæste beskeder",
noSortedCallListToShow: "Ingen kandidater i tilkaldelisten",
notification: "Notifikation",
offerOnShiftExchange: "Udbyd på vagtbørs",
offerOnShiftExchangeErrorTitle: "Hov! Noget gik galt, da TeamPlan skulle udbyde vagten",
onThisDay: "på denne dag",
ongoingAbsence: "Løbende fravær",
password: "Adgangskode",
passwordIsRequired: "Adgangskode skal udfyldes",
pendingIssue: "udestående",
pendingIssues: "udeståender",
phone: "Telefon",
phoneGapCalendarFindEventsError: "Der opstod et problem med læsning af telefonens kalender aftaler",
phoneGapCalendarListsError: "Der opstod et problem med læsning af telefonens kalendere",
phoneGapCalendarNoPermError: "Ingen tilladelse til at læse telefonens kalendere",
phoneGapCalendarNoPluginError: "Kan ikke tilgå telefonens kalendere",
phoneGapCalendarUpdateSelectedError: "Der opstod en fejl ved opdatering af kalender listen",
postColleagueChatMessageErrorTitle: "MinPlan kunne desværre ikke sende din besked",
postDayChatMessageErrorTitle: "MinPlan kunne desværre ikke sende din besked",
postMessagesErrorTitle: "TeamPlan kunne desværre ikke sende din besked",
processClockEventErrorTitle: "Hov! Noget gik galt, da MinPlan skulle registrere din stempling",
processTimeRegEventListErrorTitle: "Hov! Noget gik galt, da MinPlan skulle gemme din tidsregistrering",
putItemErrorTitle: "Hov! Noget gik galt, da MinPlan skulle oprette ønsket",
putPreferenceErrorTitle: "Hov! Noget gik galt, da MinPlan skulle oprette præferencen",
queryAttendanceTolerancesAndReasonsErrorTitle: "MinPlan kan desværre ikke foretage stemplinger i øjeblikket",
queryClockEventsErrorTitle: "MinPlan kan i øjeblikket ikke vise dine tidsregistreringer",
registerAbsence: "Registrer fravær",
registerAbsenceErrorTitle: "Hov! Noget gik galt, da TeamPlan skulle registrere fraværet",
reload: "Genindlæs",
removeShiftErrorTitle: "Hov! Noget gik galt, da TeamPlan forsøgte at slette vagten",
requestShiftExchangeErrorTitle: "Hov! Noget gik galt, da MinPlan skulle oprette byt",
requesterFindSwapsErrorTitle: "Hov! Noget gik galt, da MinPlan skulle finde vagter",
responsibility: "Ansvar",
search: "Søg",
setBoardNoteStatusErrorTitle: "MinPlan kunne desværre ikke markere beskeden som læst",
setExchangeSeenErrorTitle: "MinPlan kunne desværre ikke markere dine tilbud som læst",
setFavoriteStatusErrorTitle: "Hov! Noget gik galt, da TeamPlan skulle følge personalegruppen",
setNotificationStatusErrorTitle: "Dine notifikationsindstillinger kunne desværre ikke gemmes",
setSimpleMessageRecipientReadWhenErrorTitle: "MinPlan kunne desværre ikke markere beskeden som læst",
settings: "Indstillinger",
shift: "vagt",
shift_plural: "Vagter",
somethingWentWrong: "Noget gik galt",
suggestShiftSwapErrorTitle: "Hov! Noget gik galt, da MinPlan skulle oprette byt",
swapRequestErrorMessage: "Din bytteforespørsel kunne desværre ikke oprettes. Systemet svarer:",
swapperFindSwapsErrorTitle: "Hov! Noget gik galt, da MinPlan skulle finde vagter",
syncRosterErrorTitle: "Hov! Noget gik galt, da MinPlan skulle gemme din dag",
takeErrorTitle: "Hov! Noget gik galt, da MinPlan skulle håndtere vagten.",
today: "I dag",
unreadPlural: "ulæste",
unreadSingular: "ulæst",
updatePersonDataErrorTitle: "Hov! Noget gik galt, da MinPlan skulle opdatere dine oplysninger",
updatePersonDataPrivacyErrorTitle: "Hov! Noget gik galt, da MinPlan skulle opdatere skjul nummer",
updatePreferencePatternErrorTitle: "Hov! Noget gik galt, da MinPlan skulle opdatere dit præferencemønster",},
En: {ActivateBiometricLogin_1: (arg0: number | string) => `Enable ${arg0.toString()}` as const,
AddComment_1: (arg0: number | string) => `Add comment: ${arg0.toString()}` as const,
AddForgottenClockingFor_1: (arg0: number | string) => `Add missing clocking for ${arg0.toString()}` as const,
AddToXCalendar_1: (arg0: number | string) => `Add to your ${arg0.toString()} calendar` as const,
AndXOtherShifts_1: (arg0: number | string) => `+ ${arg0.toString()} other shifts.` as const,
BalanceAsOf_1: (arg0: number | string) => `Balance as of ${arg0.toString()}` as const,
BalanceStart_1: (arg0: number | string) => `To see your balances, you must go to the start of your employment ${arg0.toString()}` as const,
BiometricDataNotRecognized_1: (arg0: number | string) => `${arg0.toString()} was not recognized.` as const,
BiometricLoginCouldNotBeActivated_1: (arg0: number | string) => `${arg0.toString()} could not be enabled` as const,
BiometricLoginDisabledGoToSettingsToEnable_1: (arg0: number | string) => `${arg0.toString()} has been turned off in the phone settings. Go into your phone's settings to turn it back on, or log in as usual.` as const,
BiometricLoginExpiredLoginToRenew_1: (arg0: number | string) => `Your ${arg0.toString()} has expired. Log in as usual to renew it.` as const,
BiometricLoginFailedAndWasDeactivated_1: (arg0: number | string) => `${arg0.toString()} failed and has been deactivated.` as const,
BiometricLoginWillBeDisabled_1: (arg0: number | string) => `Please note that ${arg0.toString()} will be disabled and needs to be reactivated.` as const,
CameraConstraintError_1: (arg0: number | string) => `Camera requirements cannot be met (${arg0.toString()}). Try without specific constraints.` as const,
CameraStartError_1: (arg0: number | string) => `Could not start camera: ${arg0.toString()}.` as const,
CannotWishThisType_1: (arg0: number | string) => `Can't wish "${arg0.toString()}" in this period` as const,
ChangedToXHasBeenSaved_1: (arg0: number | string) => `The changes to ${arg0.toString()} have been saved.` as const,
ChatWith_1: (arg0: number | string) => `Chat with ${arg0.toString()}` as const,
CheckInAfter_1: (arg0: number | string) => `You cannot check in until after ${arg0.toString()}` as const,
ChooseBetweenApplicants_1: (arg0: number | string) => `Choose between ${arg0.toString()} applicants` as const,
ClockInTimeEarlierThanLatest_1: (arg0: number | string) => `Your start time overlaps with another clocking that ended at ${arg0.toString()}.` as const,
ClockOutTimeEarlierThanLatest_1: (arg0: number | string) => `Your end time overlaps with the start time, which was ${arg0.toString()}.` as const,
ClosedClickToViewOtherDays_1: (arg0: number | string) => `${arg0.toString()} is closed due to planning. Click to view other data` as const,
ColleageStart_1: (arg0: number | string) => `To see your colleagues, you must go to the start of your employment ${arg0.toString()}` as const,
ColleagueNothingPlanned_1: (arg0: number | string) => `${arg0.toString()} has nothing planned for this week.` as const,
ColorRoll_1: (arg0: number | string) => `Color roll ${arg0.toString()}.` as const,
ConfirmCancel_1: (arg0: number | string) => `Do you want to cancel ${arg0.toString()}?` as const,
ConfirmOfferOnShiftExchangeAllAvailable_1: (arg0: number | string) => `Are you sure you want to offer the shift to all available staff in the ${arg0.toString()} selected personel groups?` as const,
ConfirmOfferOnShiftExchangeCandidateFilter_1: (arg0: number | string) => `Are you sure you want to offer the shift in the ${arg0.toString()} selected personel groups?` as const,
ConfirmReject_1: (arg0: number | string) => `Do you want to reject ${arg0.toString()}?` as const,
ConfirmTake_1: (arg0: number | string) => `Do you want to take ${arg0.toString()}?` as const,
CouldNotRecognizeYourBiometricData_1: (arg0: number | string) => `Unfortunately, we could not recognize your ${arg0.toString()}.` as const,
DeviatingPayerNotificationBody_1: (arg0: number | string) => `Please note that this shift is registered at "${arg0.toString()}".` as const,
DeviatingWorkplacePleaseNote_1: (arg0: number | string) => `Please note that this shift is registered at "${arg0.toString()}".` as const,
DoYouWantToLoginWithBiometricInTheFuture_1: (arg0: number | string) => `Would you like to log in using ${arg0.toString()} in the future?` as const,
DownloadingTemplateTotalsFor_1: (arg0: number | string) => `Downloading template norms for ${arg0.toString()}...` as const,
EnableBiometricLogin_1: (arg0: number | string) => `Turn on ${arg0.toString()}` as const,
EnablingBiometricFailedTryAgain_1: (arg0: number | string) => `Enabling ${arg0.toString()} has failed too many times. You can try enabling it again later.` as const,
ErrorCouldNotActivateBiometric_1: (arg0: number | string) => `An error occurred and unfortunately we could not enable ${arg0.toString()}.` as const,
ErrorDoubleColumnOfUniqueKind_1: (arg0: number | string) => `Cannot have 2 columns of type '${arg0.toString()}.` as const,
ErrorNoBrowserSupport_1: (arg0: number | string) => `Browser does not support ${arg0.toString()}.` as const,
ExchangeAccepted_1: (arg0: number | string) => `You have accepted ${arg0.toString()}` as const,
ExchangeApproved_1: (arg0: number | string) => `You have approved ${arg0.toString()}` as const,
ExchangeCancelled_1: (arg0: number | string) => `You have cancelled ${arg0.toString()}` as const,
ExchangeCancelledAlt_1: (arg0: number | string) => `You have cancelled ${arg0.toString()}` as const,
ExchangeCreated_1: (arg0: number | string) => `You have created ${arg0.toString()}` as const,
ExchangeGiveAway_1: (arg0: number | string) => `You have given away ${arg0.toString()}` as const,
ExchangeHandoverErrorToast_1: (arg0: number | string) => `Your give away on ${arg0.toString()} failed.` as const,
ExchangeOffer_1: (arg0: number | string) => `You have offered ${arg0.toString()}` as const,
ExchangeRejected_1: (arg0: number | string) => `You have rejected ${arg0.toString()}` as const,
ExchangeSwapErrorToast_1: (arg0: number | string) => `Your swap on ${arg0.toString()} failed.` as const,
ExchangeSwapSuccessToast_1: (arg0: number | string) => `Your swap on ${arg0.toString()} is not created.` as const,
ExchangeTaken_1: (arg0: number | string) => `You have taken ${arg0.toString()}` as const,
ExchangeWhoeverErrorToast_1: (arg0: number | string) => `Your swap with 'anyone' is not possible on ${arg0.toString()}.` as const,
GamsErrorDuplicatePerson_1: (arg0: number | string) => `${arg0.toString()} appears more than once` as const,
GroupFunctionMismatch_1: (arg0: number | string) => `Person's group (${arg0.toString()}) is not assigned to the function.` as const,
HandoverApproveRejectText_1: (arg0: number | string) => `Choose the applicant who should get ${arg0.toString()}'s shift.` as const,
HandoverOfDefiniteArticle_1: (arg0: number | string) => `the giveaway of ${arg0.toString()}` as const,
IsNowCreated_1: (arg0: number | string) => `${arg0.toString()} is now created.` as const,
LoginAsUsualAndEnableItAgain_1: (arg0: number | string) => `Log in as usual and try turning it back on in the ${arg0.toString()} menu.` as const,
LoginWith_1: (arg0: number | string) => `Log in using ${arg0.toString()}` as const,
MemberOfGroup_1: (arg0: number | string) => `Member of group ${arg0.toString()}` as const,
MessageModal_1: (arg0: number | string) => `As a starting point, TeamPlan retrieves unread messages for the next ${arg0.toString()} days. This includes both chat and internal messages.

If, on the 'Overview' page, you have entered shifts that are outside this period, the unread messages of this period will also be displayed here.` as const,
MessageModalRead_1: (arg0: number | string) => `As a starting point, TeamPlan retrieves read messages for the next ${arg0.toString()} days. This includes both chat and internal messages.

If, on the 'Overview' page, you have entered shifts that are outside this period, the read messages of this period will also be displayed here.` as const,
MessageModalUnread_1: (arg0: number | string) => `As a starting point, TeamPlan retrieves unread messages for the next ${arg0.toString()} days. This includes both chat and internal messages.

If, on the 'Overview' page, you have entered shifts that are outside this period, the unread messages of this period will also be displayed here.` as const,
MessageOutsideEmploymentPeriod_1: (arg0: number | string) => `You can write a new message when your employment starts on ${arg0.toString()}` as const,
MessagesEmptyStateDescription_1: (arg0: number | string) => `No messages have been received or sent in the staff group that relate to the next ${arg0.toString()} days.` as const,
MissingSwapGroup_1: (arg0: number | string) => `${arg0.toString()} has no swap group` as const,
NothingPlannedBefore_1: (arg0: number | string) => `Nothing is planned before your employment starts on ${arg0.toString()}` as const,
NumApplicantsFromShiftExchange_1: (arg0: number | string) => `${arg0.toString()} applicants on shift exchange` as const,
OfferShiftTo_1: (arg0: number | string) => `Offer shift to ${arg0.toString()}` as const,
OfferShiftToGroups_1: (arg0: number | string) => `Offer shift to ${arg0.toString()} groups` as const,
PeriodsDialogTitle_1: (arg0: number | string) => `Start and end date for ${arg0.toString()}` as const,
PreferencePatternBodyPart2Future_1: (arg0: number | string) => `When you enter new preferences in your preference pattern - or change the already existing preferences - the changes apply from the first day of your wish period as it currently starts ${arg0.toString()}.
It is therefore from this date that the changes can be seen on the wishes page.` as const,
PreferencePatternChangesFromThisDayApplies_1: (arg0: number | string) => `Changes to this week are effective as of ${arg0.toString()}` as const,
PreferencePatternDeleteBody_1: (arg0: number | string) => `Are you sure you want to delete your preference pattern?

This action will remove the pattern preferences on the request page from the start of the current wish period: ${arg0.toString()}` as const,
ProblemServer_1: (arg0: number | string) => `Sorry, there's a server problem (${arg0.toString()}).` as const,
ReceptionOfDefiniteArticle_1: (arg0: number | string) => `the reception of ${arg0.toString()}` as const,
RelationCloseChanged_1: (arg0: number | string) => `${arg0.toString()} is now listed as your close relative. You can only have one close relative.` as const,
SelectPeriodSlowWarn_1: (arg0: number | string) => `You have chosen more than ${arg0.toString()} weeks, it can slow down the system.` as const,
SelectPeriodTooLong_1: (arg0: number | string) => `You can open up to ${arg0.toString()} weeks.` as const,
SelectTheShift_1: (arg0: number | string) => `Select the shift: ${arg0.toString()}` as const,
SetDemandTo_1: (arg0: number | string) => `Set demand to ${arg0.toString()}.` as const,
ShiftTypeNotAvailablePleaseNote_1: (arg0: number | string) => `Please note that changing the shift type from "${arg0.toString()}" cannot be reverted after saving changes.` as const,
SinceTime_1: (arg0: number | string) => `Since ${arg0.toString()}` as const,
StartingFp_1: (arg0: number | string) => `Starting function plan ${arg0.toString()}...` as const,
SynchronizingNItems_1: (arg0: number | string) => `Saving ${arg0.toString()} items.` as const,
TemplatePeriodOutOfViewport_1: (arg0: number | string) => `Template period (${arg0.toString()}) is outside of the open period.` as const,
TemplateValidOnly_1: (arg0: number | string) => `Template valid only ${arg0.toString()}.` as const,
TimeWillApplyWeekParityEven_1: (arg0: number | string) => `The start and end times will apply to every ${arg0.toString()} in even-numbered weeks.` as const,
TimeWillApplyWeekParityNone_1: (arg0: number | string) => `The start and end times will apply to every ${arg0.toString()}.` as const,
TimeWillApplyWeekParityOdd_1: (arg0: number | string) => `The start and end times will apply to every ${arg0.toString()} in odd-numbered weeks.` as const,
ToEnableBiometricLoginEnableItInSettings_1: (arg0: number | string) => `To use ${arg0.toString()} for logging in to MyPlan, you need to turn it on in your phone’s settings.` as const,
UnfollowDialogBody_1: (arg0: number | string) => `Are you sure, that you no longer wish to follow the group "${arg0.toString()}"?` as const,
UpdatingInXSeconds_1: (arg0: number | string) => `Updating in ${arg0.toString()} seconds...` as const,
UpdatingMissingAssignment_1: (arg0: number | string) => `Deleting missing assignment: ${arg0.toString()}` as const,
UseBiometricLogin_1: (arg0: number | string) => `Use ${arg0.toString()}` as const,
VerifyingNItems_1: (arg0: number | string) => `Verifying ${arg0.toString()} items.` as const,
ViewportLacksDate_1: (arg0: number | string) => `Plan's view period lacks date: ${arg0.toString()}` as const,
XInsertsTheLink_1: (arg0: number | string) => `${arg0.toString()} inserts the link into the calendar by itself.` as const,
YesConfirmTake_1: (arg0: number | string) => `Yes, take ${arg0.toString()}` as const,
YouCanEnableItLaterUnderTheMenu_1: (arg0: number | string) => `You can enable it later in the ${arg0.toString()} menu.` as const,
YouCannotClockOut_1: (arg0: number | string) => `You cannot clock out until 1 minute has passed. Please wait until ${arg0.toString()}.` as const,
YouCannotStartBefore_1: (arg0: number | string) => `You cannot start before ${arg0.toString()}.` as const,
YourEmploymentEnded_1: (arg0: number | string) => `Your employment ended ${arg0.toString()}.` as const,
missingRequiredFieldX_1: (arg0: number | string) => `${arg0.toString()} is required` as const,
newPasswordNotEnoughCharacterClasses_1: (arg0: number | string) => `Create a password that contains at least ${arg0.toString()} of 4 types of characters (lowercase letters, uppercase letters, numbers, special characters).` as const,
newPasswordTooShort_1: (arg0: number | string) => `Password must be at least ${arg0.toString()} characters` as const,
BiometricLoginFailedTooManyTimesAtLogin_2: (arg0: number | string, arg1: number | string) => `${arg0.toString()} failed too many times. Log in as usual and try ${arg1.toString()} again later.` as const,
CheckRuleViolationsForNPersonsForPeriod_2: (arg0: number | string, arg1: number | string) => `Check work-rules for ${arg0.toString()} people for ${arg1.toString()}` as const,
ConfirmDeletion_2: (arg0: number | string, arg1: number | string) => `Are you sure you wish to delete the ${arg0.toString()} "${arg1.toString()}"?` as const,
ConfirmEndAbsence_2: (arg0: number | string, arg1: number | string) => `Are you sure you wish to end ${arg0.toString()}'s absence effective ${arg1.toString()}?` as const,
ConfirmRemoveShiftBody_2: (arg0: number | string, arg1: number | string) => `Are you sure that you would like to delete "${arg0.toString()}" ${arg1.toString()}` as const,
ConfirmShiftExchangeContent_2: (arg0: number | string, arg1: number | string) => `Are you sure you want to approve the shift exchange between ${arg0.toString()} and ${arg1.toString()}?` as const,
CopyToXAndKeepY_2: (arg0: number | string, arg1: number | string) => `Copy to '${arg0.toString()}' and keep ${arg1.toString()}` as const,
DescriptionOperationPlace_2: (arg0: number | string, arg1: number | string) => `Saving demand for ${arg0.toString()} on ${arg1.toString()}.` as const,
EnablingBiometricFailedTryAgainUnderMenuItem_2: (arg0: number | string, arg1: number | string) => `Enabling ${arg0.toString()} has failed too many times. You can try enabling it again later in the ${arg1.toString()} menu.` as const,
EndAbsenceMultiPleaseNote_2: (arg0: number | string, arg1: number | string) => `Please note that you have also ended ${arg0.toString()}'s absence: ${arg1.toString()}` as const,
ErrorInternal_2: (arg0: number | string, arg1: number | string) => `Internal error #${arg0.toString()}. ${arg1.toString()}` as const,
FieldLengthExceeded_2: (arg0: number | string, arg1: number | string) => `The field '${arg0.toString()}' can at most contain ${arg1.toString()} characters.` as const,
FieldXIsMaxChars_2: (arg0: number | string, arg1: number | string) => `${arg0.toString()} is too long (maximum is ${arg1.toString()} characters)` as const,
ImportingKOfN_2: (arg0: number | string, arg1: number | string) => `Importing ${arg0.toString()} of ${arg1.toString()}` as const,
IsNowAssigned_2: (arg0: number | string, arg1: number | string) => `${arg0.toString()} is now assigned to ${arg1.toString()}.` as const,
MessagesEmptyStateDescription_2: (arg0: number | string, arg1: number | string) => `You have not received or sent any ${arg0.toString()} or ${arg1.toString()} messages` as const,
MoveFromTo_2: (arg0: number | string, arg1: number | string) => `Move from '${arg0.toString()}' to '${arg1.toString()}'` as const,
NoChangesHaveBeenMade_2: (arg0: number | string, arg1: number | string) => `No shifts have been changed for the period
${arg0.toString()} - ${arg1.toString()}` as const,
NothingPlannedForGroup_2: (arg0: number | string, arg1: number | string) => `There are no scheduled shifts for the period
${arg0.toString()} - ${arg1.toString()}` as const,
NothingToTakeActionOn_2: (arg0: number | string, arg1: number | string) => `There are no unresolved issues for the period
${arg0.toString()} - ${arg1.toString()}` as const,
OverwritingExistingAssignment_2: (arg0: number | string, arg1: number | string) => `Overwriting existing assignment: ${arg0.toString()} with: ${arg1.toString()}.` as const,
PartialGroupMembership_2: (arg0: number | string, arg1: number | string) => `${arg0.toString()} is not a member of ${arg1.toString()} in the entire period` as const,
PersonAlreadyAssigned_2: (arg0: number | string, arg1: number | string) => `${arg0.toString()} is already assigned to ${arg1.toString()}` as const,
PersonIsLockedOn_2: (arg0: number | string, arg1: number | string) => `${arg0.toString()} is locked on ${arg1.toString()}` as const,
PreferencePatternDate_2: (arg0: number | string, arg1: number | string) => `${arg0.toString()} ${arg1.toString()}` as const,
ProcessingDataIOfN_2: (arg0: number | string, arg1: number | string) => `Processing data (${arg0.toString()}/${arg1.toString()}).` as const,
ReadByXOnY_2: (arg0: number | string, arg1: number | string) => `Read by ${arg0.toString()} on ${arg1.toString()}.` as const,
ReadMessagesEmptyStateDescription_2: (arg0: number | string, arg1: number | string) => `There are no read messages concerning the period ${arg0.toString()} - ${arg1.toString()}` as const,
RegisteredAbsent_2: (arg0: number | string, arg1: number | string) => `Please note that you have also registered ${arg0.toString()} as absent: ${arg1.toString()}` as const,
RollLabel_2: (arg0: number | string, arg1: number | string) => `Roll ${arg0.toString()} of ${arg1.toString()}.` as const,
RuleViolationsForNPersonsForPeriod_2: (arg0: number | string, arg1: number | string) => `Violations of work-rules for ${arg0.toString()} people for ${arg1.toString()}` as const,
SelectPhysicianPlanFor_2: (arg0: number | string, arg1: number | string) => `Select function plan for department ${arg0.toString()}, user ${arg1.toString()}:` as const,
SinceDateAndTime_2: (arg0: number | string, arg1: number | string) => `Since ${arg0.toString()} at ${arg1.toString()}` as const,
SwapApproveRejectText_2: (arg0: number | string, arg1: number | string) => `${arg0.toString()} and ${arg1.toString()} would like to swap shifts.` as const,
TileCaption_2: (arg0: number | string, arg1: number | string) => `The function ${arg0.toString()} on ${arg1.toString()}` as const,
TileCaptionClosed_2: (arg0: number | string, arg1: number | string) => `The function ${arg0.toString()} on ${arg1.toString()} is closed` as const,
TileCaptionInvalid_2: (arg0: number | string, arg1: number | string) => `The function ${arg0.toString()} on ${arg1.toString()} is invalid` as const,
TileColumnClosed_2: (arg0: number | string, arg1: number | string) => `The function ${arg0.toString()} on ${arg1.toString()} is outside the start and end dates of the column` as const,
TransferPlanFromTo_2: (arg0: number | string, arg1: number | string) => `Transfer plan from ${arg0.toString()} to ${arg1.toString()}` as const,
TryAgainOrEnableUnderMenuItem_2: (arg0: number | string, arg1: number | string) => `Try again or turn on ${arg0.toString()} in the ${arg1.toString()} menu` as const,
TryToEnableBiometricUnderMenuItem_2: (arg0: number | string, arg1: number | string) => `Try enabling ${arg0.toString()} under the menu item ${arg1.toString()}.` as const,
UnreadMessagesEmptyStateDescription_2: (arg0: number | string, arg1: number | string) => `There are no unread messages concerning the period ${arg0.toString()} - ${arg1.toString()}` as const,
ConfirmRemoveShiftBody_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `Are you sure that you would like to delete ${arg0.toString()}'s shift "${arg1.toString()}" ${arg2.toString()}` as const,
DescriptionOperationAvatarDelete_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `Delete ${arg0.toString()} from ${arg1.toString()} on ${arg2.toString()}.` as const,
DescriptionOperationAvatarRemark_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `Saving note for ${arg0.toString()}, ${arg1.toString()} on ${arg2.toString()}.` as const,
DescriptionOperationKangarooCopyCreate_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `Add roll ${arg0.toString()} to ${arg1.toString()} on ${arg2.toString()}.` as const,
DescriptionOperationKangarooCopyDelete_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `Delete roll ${arg0.toString()} from ${arg1.toString()} on ${arg2.toString()}.` as const,
MessagesEmptyStateDescription_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `You have not received or sent any ${arg0.toString()}, ${arg1.toString()} or ${arg2.toString()} messages` as const,
PersonAlreadyInSomeTemplate_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `This person is assigned to the template plan ${arg0.toString()}, roll ${arg1.toString()}, in the period ${arg2.toString()}.` as const,
RangeViolation_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `${arg0.toString()} must be between ${arg1.toString()} and ${arg2.toString()}.` as const,
RemoveShiftToast_3: (arg0: number | string, arg1: number | string, arg2: number | string) => `${arg0.toString()}'s shift "${arg1.toString()}" ${arg2.toString()} is now deleted.` as const,
AboutMeButtonTitleCancel: "Cancel",
AboutMeButtonTitleSave: "Save",
AboutMeClearFields: "Clear fields",
Absence: "Absence",
AbsenceTooltip: "Create absence column",
AbsenceTypeRestOfDayWillBe: "Absence type for rest of day will be",
AbsentColleagues: "Absent colleagues",
Accept: "Accept",
Accepted: "Accepted",
AccessDenied: "Access denied. Check permissions in browser/Settings.",
Accrued: "Accrued",
ActionsAreRegisteredBody: "Note that all your actions are executed in the system and saved under your name.",
ActionsAreRegisteredTitle: "You are currently acting on behalf on an employee",
Activate: "Enable",
Activities: "Activities",
ActivitiesMightBeDeleted: "Activities might be deleted",
ActivitiesMightBeDeletedPleaseNote: "Please note that the following activities might be deleted if they are no longer covered by a shift:",
ActivitiesWillBeDeleted: "Activities will be deleted",
ActivitiesWillBeDeletedPleaseNote: "Please note that the following activities will be deleted:",
Activity: "Activity",
Add: "Add",
AddCategory: "+ Add category",
AddCounter: "+ Add counter",
AddEndDate: "Add end date",
AddForgottenPunching: "Add forgotten punching",
AddFromGroup: "Add from group",
AddInfo: "Add Information",
AddMissingTime: "Add Missed Time Entry",
AddNewPeriod: "Add new start and end date",
AddNewTimeRegistration: "Add new time registration",
AddNote: "Internal messages",
AddPeriod: "Add period",
AddRule: "Add rule",
AddTemplate: "+ Add template",
AddTotalCounter: "+ Add total counter",
Adding: "Adding",
Address: "Address",
AdjustDemandDown: "Less demand",
AdjustDemandUp: "More demand",
Alert: "Advarsel",
All: "All",
AllowAccess: "Allow access",
AllowNotifications: "Allow notifications",
And1OtherShift: "+ 1 other shift.",
AppSettings: "App settings",
Applicants: "Applicants",
Approve: "Approve",
ApproveRejectHandover: "Approve/Reject hand over",
ApproveRejectSwap: "Approve/Reject shift swap",
ApproveToToday: "Approve until and including today",
ApprovedByPlanner: "Approved by planner",
ApprovedPeriod: "Approved for salary",
AreYouSureYouWantToChangeOrganisation: "Are you sure you want to change your organization?",
AssignFromGroup: "Assign from group",
AttachSpecialWorkingHoursRemunerations: "Select working hours",
AttendanceEmptyDayText: "You have no possible shift check-ins today",
AttendanceLeaveEarly: "Select a reason for clocking out earlier than your scheduled work.",
AttendanceLeaveLate: "Select a reason for clocking out later than your scheduled work.",
AttendanceStartEarly: "Select a reason for clocking in earlier than your scheduled work.",
AttendanceStartLate: "Select a reason for clocking in later than your scheduled work.",
AttendanceUnplanned: "Select a reason for clocking in outside your scheduled work hours.",
AutoPlanJobAdding: "Adding auto plan job...",
AutoPlanJobStatusValue: "Starting...|Computing...|Ready",
AvailableFictivePerson: "Available fictive person",
AwaitingAnswer: "Awaiting answer",
AwaitingAnswerFromOthers: "Awaiting answer from others",
AwaitingAnswerFromYou: "Awaiting answer from you",
AwaitingApproveHandover: "Awaiting approval of hand over",
AwaitingApproveSwap: "Awaiting approval of shift swap",
AwaitingPlanner: "Awaiting the planner",
AwaitingYou: "Awaiting you",
AwaitsRuleCheck: "Awaits rule check",
Back: "Back",
Balance: "Balance",
Banked: "Banked",
BiometricData: "Biometric data",
BiometricLogin: "Biometric login",
BirthDate: "Birthdate",
BirthdateInvalid: "Birthdate is invalid.",
BlissState: "Bliss state",
ButtonLogout: "Logout",
CalcBalance: "Calc. Bal.",
Calendar: "Calendar",
CalendarLinkCopied: "The calendar link was copied to the clipboard",
CalendarLinkNotWorking: "Previously copied calendar link no longer works. Copy a new link if you want to export again.",
CameraAccessInstructions: "To scan your QR code, you need to give the app permission to access the camera in Settings.",
CameraAccessMissingText: "To scan your QR code, the app needs permission to use the camera. Please enable camera access in Settings.",
CameraAccessMissingTitle: "ClockPoint needs camera access",
CameraBusyText: "Close other apps and try again.",
CameraBusyTitle: "The camera could not be started",
CameraNotWorkingText: "You can register your working hours by entering your salary id.",
CameraNotWorkingTitle: "Camera couldn't be started",
Cancel: "Cancel",
CancelAlt: "Cancel",
CancelCopyImperative: "Cancel copying",
CancelCutImperative: "Cancel cutting",
CancelDeputy: "Cancel take request",
CancelHandover: "Cancel giveaway",
CancelOffer: "Cancel offer",
CancelRegistration: "Cancel registration",
CancelRegistrations: "Cancel registrations",
CancelRequest: "Cancel requests",
CancelTakeShift: "Cancel take shift",
Cancelled: "Cancelled",
CannotBeAnswered: "Cannot be answered",
CannotDelete: "Cannot delete.",
CannotPasteHeaderKind: "You can only paste into functions and absence.",
CannotPasteHeaderMultifunction: "You can only paste in columns that have one function",
CannotScanQRCode: "Can't scan your QR code?",
CantAnswer: "Can not be answered",
CareDays: "Care days",
Category: "Category",
Cause: "Cause",
CauseGrainedPlanning: "Coarse-grained planning",
ChangeCamera: "Switch camera",
ChangeLanguage: "Change Language",
ChangeOldPassword: "Change password",
ChangeOrganization: "Change organization",
ChangePasswordForApp: "Change password for this app",
ChangePasswordLabelActivationCode: "Activation code",
ChangePasswordLabelNew: "Choose new code",
ChangePasswordLabelRepeat: "Repeat new code",
ChangePasswordTitle: "New code",
ChangePersonelGroup: "Change person group",
ChangeTeam: "Change team",
Changes: "Changes",
Chat: "Chat",
ChatAndInternalMessages: "Chat and internal messages",
ChatEmptyDayMessages: "No text messages on this day",
ChatSendMessage: "Send",
ChatWithEmployee: "Chat with employee",
CheckChangeGroup: "Are you part of multiple colleague groups, try changing the group and search again.",
CheckSpellingForName: "Check to see if you have spelled the name correctly.",
Choose: "Choose",
ChooseAbsenceForRestOfDay: "Choose absence type for the rest of the day",
ChooseAnOption: "Choose one of the options below:",
ChooseApplicant: "Choose applicant",
ChooseApplicants: "Choose applicants",
ChooseContactFields: "Choose visible contact details",
ChooseGroups: "Choose the personnel groups to whom you want to offer the shift.",
ChooseMessageOnTheLeft: "You can choose a message from the list on the left.",
ChooseMessagePeriod: "Choose visibility period for the note",
ChooseMessageToRead: "Choose the message you wish to read",
ChooseMultipleTemplates: "Choose templates to roll out",
ChoosePersonGroup: "Choose person group",
ChoosePredefined: "Choose a predefined shift",
ChooseReasonUnplanned: "Choose a reason why you have punched without a planned shift.",
ChooseRecipients: "Choose recipients",
ChooseRolloutPeriod: "Choose roll-out period",
ChooseRosterTemplatePeriod: "Choose the period for the plan template for the person",
ChooseSwapShift: "Choose one of receiver's shifts.",
ChooseTake: "Choose the shift you wish to receive in exchange for",
ChooseType: "Choose type",
ChooseUnitAndUser: "Select unit and user:",
ChooseViewAndDate: "Choose view and date",
ChooseYourShift: "Choose one of your shifts.",
Chosen: "Chosen",
ClickHereToUpdate: "Click here to update",
ClickWishExplanation: "The time for this wish/preference has been edited.",
ClockIn: "Clock in",
ClockInAndOutDeviationInfo: "If there's a notable deviation from the plan, you must also specify a reason.",
ClockInError: "An error happened during clock in.",
ClockInItem: "Clock In",
ClockOut: "Clock out",
ClockOutError: "An error happened during clock out.",
ClockOutItem: "Clock Out",
ClockOutNotPossible: "Clock out not possible right now",
ClockPoint: "ClockPoint",
ClockedTime: "Clocked time",
ClockingPeriodOverlaps: "Your entered working hours overlap with another clocking.",
ClockingTimeEarlierThanAllowed: "The provided time is too early relative to the planned start.",
ClockingTimeEarlierThanLatest: "The provided time is earlier than your latest timestamp.",
ClockingTimeInFuture: "Entering a time in the future is not allowed.",
ClockingTimeInPastApp: "Your phone or tablet's clock is set to a time that lies before your latest clock-in or clock-out. Check your settings and try again.",
ClockingTimeInPastBrowser: "Your computer's clock is set to a time that lies before your latest clock-in or clock-out. Check your settings and try again.",
ClockingTimeOverlaps: "The timestamp overlaps with a previous timestamp.",
Close: "Close",
CloseCalendar: "Close calendar",
CloseMenu: "Close menu",
ClosedForRegistration: "Closed for registration",
ColorDay: "Color day",
ColourGroups: "Color groups",
ColourImperative: "Color",
ColourPeopleInGroup: "Color people in the group",
ColumnName: "Column name",
Comment: "Comment",
CompensatoryTimeOff: "Compensatory time off",
ComputeTotals: "Compute time balance",
ComputingTotals: "Computing time balance...",
ConfigurePeriodForWorkHours: "Configure period for work hours...",
ConfigureTotalCategory: "Configuration of total category",
Confirm: "Confirm",
ConfirmBeforeCloseTasks: "You have made changes. Are you sure you wish to cancel?",
ConfirmCancelOffer: "Do you want to cancel the swap?",
ConfirmCancellationOfOffer: "Confirm cancellation of offer",
ConfirmCancellationOfOfferContent: "Are you sure you want to cancel the offer of this shift for all personnel?",
ConfirmClockInWithoutShift: "Are you sure you wish to clock in without a selected shift?",
ConfirmClockOutWithoutShift: "Are you sure you wish to clock out without a selected shift?",
ConfirmColumnOpen: "When all periods are deleted, the column will always be open",
ConfirmDeletePreference: "Do you want to delete your preference?",
ConfirmDeleteRelative: "Do you want to remove your relative?",
ConfirmDeleteWish: "Do you want to delete your wish?",
ConfirmKeepChanges: "Are you sure you want to keep the changes?",
ConfirmLeavePage: "Are you sure you want to leave the page?",
ConfirmLeavePageContent: "If you leave the page now, then the shift that you were creating will be deleted.",
ConfirmLeavePageContentCreated: "If you leave the page now, then the shift that you were creating will be deleted.",
ConfirmLeavePageContentEdited: "If you leave the page now without saving, all changes will be lost.",
ConfirmLogout: "Are you sure you want to log out?",
ConfirmMarkAsHandled: "Confirm mark as handled",
ConfirmMarkAsHandledContent: "Are you sure you want to mark this as handled without finding a replacement?",
ConfirmMessageRead: "I have read the message",
ConfirmMoveToUnplanned: "All registrations for persons in the deleted periods will be moved to unplanned",
ConfirmOfferExchangeCandidatesHelperText: "Filter which employees are not offered the shift.",
ConfirmOfferOnShiftExchange: "Confirm offer on shift exchange",
ConfirmOfferOnShiftExchangeAllAvailable: "Are you sure you want to offer the shift to all available staff in the selected personel group?",
ConfirmOfferOnShiftExchangeCandidateFilter: "Are you sure you want to offer the shift in the selected personel group?",
ConfirmOfferOnShiftExchangeContent: "Are you sure you want to offer this shift on the shift exchange for all available personnel?",
ConfirmRemoveShiftBodyHandover: "The offer on the shift exchange is also canceled as a result.",
ConfirmRemoveShiftTitle: "Delete shift",
ConfirmSaveChanges: "Are you sure you want to save the changes?",
ConfirmShiftAssignment: "Confirm shift assignment",
ConfirmShiftAssignmentContent: "Are you sure you want to assign this shift to",
ConfirmShiftExchange: "Confirm approval of exchange",
ConfirmSwap: "Approve the swap",
ConfirmSwapConfirm: "Do you want to approve the swap?",
ConnectToInternalNet: "Reconnect to the company's internal network to stop the time clock.",
Contact: "Contact",
ContactInfo: "Contact info",
ContactUsTitle: "Contact us",
Contains: "Contains",
ContinueRollout: "Continue rollout?",
Copy: "Copy",
CopyCalendarLink: "Copy calendar link",
CopyCalendarLinkDescription: "This link can be shared with your close ones or inserted into other calendars, such as Outlook.",
CopyCalendarText: "Copy the link into your personal calendar to keep your work calendar in sync.",
CopyDetails: "Copy details",
CopyErrorTextAndContactSupport: "Help to solve the issue. Copy the details below and send them to IT support at your workplace",
CopyImperative: "Copy",
CouldNotAddFollowUpFlag: "Could not set the follow-up flag.",
CouldNotDeleteMessage: "Could not delete the message.",
CouldNotLogIn: "Could not log in. Check username and password.",
CouldNotMarkAsRead: "Could not mark as read.",
CouldNotMarkAsUnread: "Could not mark as unread.",
CouldNotRemoveFollowUpFlag: "Could not remove the follow-up flag.",
CouldNotSavePlan: "Could not save plan.",
CouldNotSendMessage: "Could not send the message.",
CouldNotSetInternalToOn: "Could not mark as internal.",
CouldNotSetPersonalToOn: "Could not mark as personal.",
CouldNotSetPublicToOn: "Could not mark as public.",
CouldNotUpdateTemplates: "Could not update plan templates.",
CountedAsOf: "Counted as of",
Counter: "Counter",
CounterSetup: "Configuration of categories and counters",
Create: "Create",
CreateFunctionColumn: "Create function column",
CreateNew: "Create new",
CreateNewRosterTemplate: "+ Create new plan template.",
CreateNewShift: "Create new shift",
CreatePreference: "Create preference",
CreateRosterTemplatePeriod: "Create plan template period",
CreateSwap: "Create swap",
CreateWish: "Create wish",
CreateWorkingHoursHeadline: "Create working hours for functions and groups",
Creating: "Creating",
CreatingDemandTemplate: "Creating demand template",
CreatingRosterTemplatePeriod: "Creating plan template period",
Crit: "Crit.",
CurrentBalance: "Current balance",
CustomFaqText: "If you are experiencing please contact you local planner for help and guidance.",
CustomerNameLabel: "company",
CustomerNameLabel_genetive: "the company's",
CutImperative: "Cut",
DailyShiftMarket: "Daily shift market",
Date: "Date",
DateFormatInvalid: "Date is invalid. Format: DD-MM-YYYY",
DateMissing: "Date missing",
Day: "Day",
DayLockedForWishes: "The day is locked for wishes.",
DayMessage: "Day message",
DayViewChatTitlePrefix: "Messages",
DayViewDisable: "Quit day view (hide hours)",
DayViewEnable: "Day view (show hours)",
DecimalSeparator: ".",
Decision_Array: ["Awaits Planner","Planned","Rejected","Could not process","Personal Calendar"] as const,
Default: "Default",
DefaultCoverButtonText: "OK",
DefinePattern: "Create pattern",
Delete: "Delete",
DeleteAll: "Delete all",
DeleteDay: "Delete the day",
DeleteImperative: "Delete",
DeletePattern: "Delete pattern",
DeletePreference: "Delete preference",
DeletePreferencePattern: "Delete preference pattern",
DeleteRegistration: "Delete registration",
DeleteRelative: "Delete relative",
DeleteRollBrick: "Delete roll brick",
DeleteRosterTemplate: "Delete plan template",
DeleteRosterTemplateDescription: "The plan template will be deleted. The weeks that have already been rolled out will not be deleted.",
DeleteThis: "Delete this",
DeleteWish: "Delete wish",
Deleted: "Deleted",
DeletedDueToShiftTypeChange: "Will be deleted due to change of shift type:",
Deleting: "Deleting",
DeletingMissingAssignment: "Deleting missing assignment",
DeletingPersonRollMembershipPeriod: "Deleting person's roll membership period",
Demand: "Demand",
DemandTemplate: "demand template",
Department: "Department",
DepartmentCantWish: "This department cannot wish",
DeputyStatus_Array: ["Unknown","Ongoing","Assigned","Canceled"] as const,
Description: "Description",
DescriptionRestoreOriginal: "Remove your registrations and go back to the original day",
Designation: "Designation",
Destination: "Destination",
Details: "Details",
DeviatingDutylinesWillBeAffectedExplanation: "Your change in shift hours will affect the following duties:",
DeviatingDutylinesWillBeDeleted: "Deviating duties will be deleted",
DeviatingDutylinesWillBeDeletedExplanation: "Will be deleted due to change of shift type:",
DeviatingPayerNotificationTitle: "Deviating workplace",
DeviatingShiftInfo: "Deviating info",
DeviatingWorkplace: "Deviating workplace",
DidNotGetTemplateTotals: "Could not get template totals.",
DidNotGetTotals: "Could not get totals.",
DidYouForgetToClockIn: "Did you forget to clock in?",
DidYouForgetToClockOut: "Did you forget to clock out?",
DismissMessage: "Dismiss message",
DismissNotification: "Dismiss notification",
Distance: "Distance",
DistributionOfFunctions: "Distribution of functions",
DoNotSave: "Do not save",
DoOffer: "Offer",
DoOpen: "Open",
DoReload: "Reload",
DoYouWishToCancel: "Do you want to cancel?",
DoYouWishToSaveAnyway: "Do you wish to save anyway?",
Done: "Done",
DownloadTheLatestVersionToUseAgain: "Download the latest version to use the App",
DownloadingData: "Downloading...",
DownloadingDemand: "Downloading demands...",
DownloadingFunctionData: "Downloading function data...",
DownloadingFunctions: "Downloading functions...",
DownloadingGroupMemberships: "Downloading group memberships...",
DownloadingGroupRoster: "Downloading...",
DownloadingGroups: "Downloading groups...",
DownloadingHistory: "Downloading history...",
DownloadingHolidays: "Downloading holidays...",
DownloadingMultifunctions: "Downloading multifunctions...",
DownloadingPersonInfo: "Downloading person info...",
DownloadingPersonRoster: "Downloading...",
DownloadingPhysicianPlan: "Downloading physician plan...",
DownloadingPlans: "Downloading plans...",
DownloadingPreferences: "Downloading preferences...",
DownloadingRosterTemplates: "Downloading plan templates",
DownloadingRuleViolations: "Downloading violations of work-rules...",
DownloadingShiftTypes: "Downloading shift types...",
DownloadingShifts: "Downloading shifts...",
DownloadingTotals: "Downloading totals...",
DownloadingUnits: "Downloading units...",
DownloadingWorkingHours: "Downloading working hours...",
DropForbiddenReasonGroupMember: "A person can only be added to template roll.",
DropForbiddenReasonHeaderNonplanned: "Cannot move to 'Non-planned' column.",
DropForbiddenReasonHeaderOther: "Cannot move to a column of 'other' type.",
DropForbiddenReasonHeaderPreference: "Cannot move to a preference column.",
DropForbiddenReasonIntoOrigin: "Cannot move to origin.",
DropForbiddenReasonMultipleFunctionIds: "Cannot move to a column containing multiple functions.",
DropForbiddenReasonOnlyGroupMember: "Only group members can be placed here.",
DropForbiddenReasonOther: "Forbidden.",
DropForbiddenReasonOtherDay: "Cannot move to another day.",
DropForbiddenReasonOutsideTemplateValidity: "Day outside of template validity.",
DropForbiddenReasonPersonAlreadyHere: "Person already present.",
DropForbiddenReasonRollAlreadyHere: "Roll already present.",
DropForbiddenReasonTileClosed: "The tile is closed.",
DueToPlanDecided: "This is due to the wish being approved by the planner.",
DueToPlanRejected: "This is due to the wish being rejected by the planner.",
Duties: "Duties",
Duty: "Duty",
Edit: "Edit",
EditAndFindSubstitute: "Edit the shift and find substitute",
EditColumn: "Edit column",
EditColumnName: "Edit column name",
EditContactInfo: "Edit contact info",
EditDay: "Edit day",
EditPeriod: "Edit",
EditPlanName: "Edit plan name",
EditPreference: "Edit preference",
EditShift: "Edit shift",
EditTask: "Edit Task",
EditTemplate: "Edit template",
EditWish: "Edit wish",
Editable: "Editable",
EditedWishExplanation: "Time for wish has been edited",
Email: "Email",
EmailInvalid: "Please enter a valid email",
Employed: "Employed",
Employee: "Employee",
EmployeeNotFound: "Employee not found. The employee may have been deleted by another user.",
Employment: "Employment",
Empremark: "Remark from you",
Enable: "Enable",
End: "End",
EndAbsence: "End absence",
EndBeforeMidnight: "End before midnight?",
EndDate: "End date",
EndImperative: "End",
EndTime: "End time",
EnterColumnName: "Enter column name",
EnterColumnNameForFunction: "Enter column name for function",
EnterPlanName: "Enter plan name",
EnterSalaryId: "Enter salary id",
Error: "Error",
ErrorCannotUploadInBrowser: "File upload does not work in this browser",
ErrorCode: "Error code",
ErrorCouldNotRollout: "Could not roll out",
ErrorHasBeenReported: "The error has been reported.",
ErrorInvalidColumn: "Invalid column. The column will be deleted.",
ErrorList: "Error list",
ErrorMoveToUnplannedFailed: "Could not move registrations to unplanned",
ErrorOutOfSync: "Data mismatch between StaffPlan and FunctionPlan.",
ErrorRelativeExistsAlready: "Relative already registered",
EvenWeek: "even week",
Exchange: "Swap",
ExchangeAlreadyAnswered: "You already proposed the following in exchange:",
ExchangeAlreadyAnsweredButRejected: "You already proposed the following in exchange but it was rejected:",
ExchangeBeingProcessed: "Exchange being processed",
ExchangeEmptyListMessage: "You don't have any exchange requests or offers",
ExchangeEmptyListMessageDone: "You don't have any completed exchange requests or offers",
ExchangeEmptyListMessageInbox: "You don't have any exchange requests or offers",
ExchangeEmptyListMessageOngoing: "You are not waiting for exchange requests or offers",
ExchangeEmptyListMessageTitle: "No requests",
ExchangeHandoverErrorBody: "Something went wrong, and your shift handover could not be created.",
ExchangeHandoverErrorTitle: "Give away failed",
ExchangeLongDescription: "This page shows exchange in progress and exchange offers. If you would like to exchange your own shifts, find the shift in calendar and use its 'Exchange' or 'Give away' button.",
ExchangeNoShifts: "No shifts available",
ExchangeOfferYourShift: "Offer your shift",
ExchangeRelatedToShift: "Related exchange",
ExchangeStillActiveBody: "MyPlan is currently processing your swap request. It's taking longer than expected.",
ExchangeStillActiveTitle: "Swap is still in progress",
ExchangeSuggested: "You have proposed the swap",
ExchangeSwapErrorBody: "Something went wrong, and your swap request could not be created.",
ExchangeSwapErrorTitle: "Swap failed",
ExchangeTabEnded: "Ended",
ExchangeTabInbox: "Awaits you",
ExchangeTabNew: "New",
ExchangeTabOngoing: "Awaits answer",
ExchangeTitle: "Shift market",
ExchangeWhoeverErrorBody: "Your swap with 'anyone' could not be completed due to a lack of candidates.",
ExchangeWhoeverErrorTitle: "Swap not possible",
ExistingFunction: "Existing function",
ExistingTemplate: "Existing template",
ExportCalendarTitle: "Export of work calendar",
ExportForAutoPlanning: "Export for autoplanning.",
ExportWorkCalendar: "Here you can turn export of your work calendar on or off, so that it can be shared with your personal calendar or those closest to you.",
Eye: "Eye",
Face: "Face",
FaceId: "Face ID",
FacialRecognitionOrFingerprint: "face recognition or fingerprint",
FaqAboutMeBody: "In this menu employees are able to see specific information about themselves and enter/edit their email and phone number (if allowed in the installation)\n<br/>\nThe employee can also enable or disable biometric login, Face ID, or Touch ID (if allowed in the installation).",
FaqAboutMeTitle: "About me",
FaqAdditionalHelpTitle: "Need additional help?",
FaqAdjustment: "The planner adjusts the plan according to your registrations, so that salaries can be processed.",
FaqApproved: "The plan is ready and salary processing can begin.",
FaqBalanceBody: "Account balance information can be seen in this menu, such as time off in lieu, holiday, overtime, etc. Balances are shown for the selected period. Balances for other periods can be displayed by using the arrow keys.\n<br/>\nThe balances displayed depend on the system configuration.",
FaqBalanceTitle: "Balance",
FaqChatBody: "In this menu employees are able to create, read or answer chat messages to and from coworkers and the planner. If there are any unread chats, a red dot will appear in the menu.\n<br/>\nThe buttons at the top of the menu provide options for filtering chat messages by pressing the type (Personal, Group etc) on/off.",
FaqChatTitle: "Chat",
FaqCheckIn: "When the work is done, you must register time of your work and absence. This is done based on a copy of the plan called Registrations.",
FaqContactBody: "For further help and guidance - contact your planner/system administrator for StaffPlan.",
FaqContactTitle: "Contact",
FaqCoworkerPlanBody: "In this menu employees are able to see their coworkers daily or weekly plan (if allowed in the configuration).\n<br/>\nThe employee is able to see schedules for those coworkers which they are in a swap group with. The available information depends on the configuration.\n<br/>\nA green marking on a coworker indicates that the employee is at work while a blue color indicates absence.\n<br/>\nBy clicking on a coworkers initials or registration, their schedule for the selected week will be opened. By clicking on a specific day in the weekly plan, the daily plan will be visible with detailed information on duties, tasks and absences for the selected coworker for that day.",
FaqCoworkerPlanTitle: "Coworker plan",
FaqDailyChatBody: "In the Daily plan employees are able to write a message (chat) to the planner regarding a specific duty or task.",
FaqDailyChatTitle: "Chat",
FaqDailyDutiesBody: "Clicking on a duty or absence will expand the item and show additional details.",
FaqDailyDutiesTitle: "Duties/Absences",
FaqDailyPlanBody: "The daily plan will appear when a specific day is selected from the weekly or monthly view.\n<br/>\nIf MyPlan is being used on a device with a larger screen (computer monitor, tablet, etc.), the daily plan will often be displayed at the same time as the weekly or monthly plan.\n<br/>\nIn the daily plan, the employee can find detailed information about shifts, absences, and any tasks. The employee also has the option to send a message (chat) to the planner regarding the current day's shift and tasks.\n<br/>\nDuring the Time Reporting phase, the employee can log their working hours, while during the Operational phase, it is possible to request shift swaps as well as offer and take shifts.",
FaqDailyPlanTitle: "Daily plan",
FaqDailyRegistrationsBody: "If an employee needs to register a change to a planned shift or task, this is done through the \"Work\" menu. (Required that the option to edit is enabled in the installation).\n<br/>\nAn employee is allowed to register changes in the period with planstatus Time reporting.\n<br/>\nThe following options are available:\nEdit day - for editing a duty or task already planned on the day. Changes can be made to both the type and times.\n<br/>\n+New - for adding a new duty, task or absence. A new registration is NOT allowed to overlap any currently scheduled items (duty, task or absence).\n<br/>\nTime registration - If the department uses Time Registration, the employee can enter when their workday started and ended on the Work page, as long as they are within the time registration period.\nWhen they save their time registration, it will appear on the Work page.\nTime registrations cannot be edited or deleted.\n<br/>\nClear day - for registering a completely different registration. For example, if an emmployee is working on a duty completely different from what they were originally planned, they must first select Clear Day and then +New to enter the correct registration.\n<br/>\nRevert day - for undoing change registration. The original planned registration by the planner will be restored.\n<br/>\nNote that an absence can be registered in the following ways: \na) with times such as 0900-1400 Sick, which is used if an employee has been partially absent on a duty, or\nb) as 00-24 Sick, which is used if the employee have been absent for an entire day/duty. The absence counts only sick hours corresponding to the originally scheduled duty.\n<br/>\nEmployees also have the opportunity to write a NOTE to the planner related to a change.",
FaqDailyRegistrationsTitle: "Registrations",
FaqDailySwapBody: "Employees have the opportunity to swap or give away one of their duties and any associated tasks to other employess in their swapgroup, through MyPlan.\n<br/>\nA swap is always performed on a whole duty or task. Swaps are possible on future duties and within the operation planstatus period.\nBy default a swap can be activated on a task starting no earlier than 00.00 tomorrow (midnight tonight). However the change must be created before 1200 today. After 1200, only shifts starting at the day after tomorrow can be activated.\n<br/>\nFor all types of swaps MyPlan automatically ensures that only employees who are qulified to perform the duty or task, are free and available and that no working time rules are broken (if enabled in the installation), will get the task offered. If no employees meet the criteria the system will generate a message stating that there are no swap options and therefore a swap is not possible.\nAdditionally, both employees (the giver and the receiver) are required to accept the swap before getting the approval from the planner (planner approval can be optionally deactivated so that duties are approved automatically when the swaps are accepted by both employees). The current status of a swap is displayed in \"Shift market\".\n<br/>\nThere are up to three types of swaps, depending on the current installation. A short description of these types is available below:",
FaqDailySwapDirectBody: "For a direct swap the employee selects one of their own duties, then selects a coworker from their swap group and chooses a preferred duty to be included in the requested swap.",
FaqDailySwapDirectTitle: "Direct swap",
FaqDailySwapGiveBody: "When an employee register a duty as a give away the duty is published to the other employees in the same swap group, who can then request to get the duty without having to offer anything in return. The planner then choose an employee to take over the selected task/duty. The planner may also choose to reject the originally request for give away.",
FaqDailySwapGiveTitle: "Give away",
FaqDailySwapOpenBody: "For an open swap the employee publishes a specific duty for other coworks, in the same swap group, to take. The employee will then receive offers from coworkers with suggestions for other duties to be included in the swap. After a suggested offer has been selected, the swap is automatically sent to the planner for final approval. Other offers are then rejected.",
FaqDailySwapOpenTitle: "Open swap",
FaqDailySwapTitle: "Swap/Give away",
FaqDailyTasksBody: "After a task has been assigned, clicking on it will expand the item and show additional details. Depending on the configuration, the employee can also see which of their coworkers are working on the similar tasks or within the same production, as the specific task is planned on.",
FaqDailyTasksTitle: "Tasks",
FaqDutySwapBody: "Employees have the opportunity to swap or give away one of their duties and any associated tasks to other employess in their group through MyPlan.\n<br/>\nA swap is always performed on a whole duty or task. Swaps are possible on future duties and within the operation planstatus period.\nBy default a swap can be activated on a task starting no earlier than 00.00 tomorrow (midnight tonight). However the change must be created before 1200 today. After 1200, only shifts starting at the day after tomorrow can be activated.\n<br/>\nFor all types of swaps MyPlan automatically ensures that only employees who are qulified to perform the duty or task, are free and available and that no working time rules are broken (if enabled in the installation), get the task offered. If no employees meet the criteria the system will generate a message stating that there are no swap options and therefore a swap is not possible.\nAdditionally, both employees (the giver and the receiver) are required to accept the swap before getting the approval from the planner (planner approval can be optionally deactivated so that duties are approved automatically when the swaps are accepted by both employees). The current status of a swap is displayed in \"Shift market\".\n<br/>\nThere are up to three types of swaps, depending on the current installation. A short description of these types is available below:",
FaqDutySwapTitle: "Duty swap",
FaqGuideBody: "MyPlan is an employee portal in StaffPlan where employees are able to see and register information on duties and tasks, follow and keep up with account balances, requests, work patterns and holidays, send messages to the planner and other employees, swap/give away or bid on available duties and tasks.\n<br/>\nPlease note: some features might be deactivated in the specific installtion.\n<br/>\nA short description of the features in MyPlan follows in the sections below.",
FaqGuideTitle: "Quick guide",
FaqHelpBody: "Quick guide describing the various menus and functions in the system.",
FaqHelpTitle: "Help",
FaqLinkText: "Go to the help page.",
FaqLogOutBody: "This logs the user out of MyPlan when they are finished using the system.",
FaqLogOutTitle: "Log out",
FaqLoginBody: "The employee can log in in three ways, depending on what is selected for the installation:\n1. Username and password\n2. Biometric login/Face ID/Touch ID\n3. OpenID\n<br/>\n1. Username and password:\nThe employee receives a username and a password from their planner. The password can be changed in the About me menu.\n<br/>\n2. Biometric login/Face ID/Touch ID:\nIf biometric login is enabled on the employee's phone, they will be prompted to use it the first time they log into the MyPlan app. Afterwards, login will always occur automatically with biometric login, Face ID, or Touch ID, depending on the phone, when opening the app.\nIt can also be enabled or disabled later in the About me menu.\n<br/>\n3. OpenID:\n When the employee logs in, they are redirected to an external login page. After verifying the username and password, the employee returns to the MyPlan app logged in.",
FaqLoginTitle: "Login",
FaqMonthlyPlanBody: "The monthly plan shows the allocated duties and tasks for the selected month. Employees can scroll through the months or select a specific month in the menu.\n<br/>\nWhen an employee is allocated a specific duty or task, that day will be marked with a green circle. An absence is marked with a blue circle.\n<br/>\nBy clicking a specific day, the \"Daily plan\" opens, where employees can see detailed information about the duty, absence or task, write a message (chat) to the planner, or swap or give away a duty or task.",
FaqMonthlyPlanTitle: "Monthly plan",
FaqOperation: "The final plan is published, and the specific tasks are being planned. You can swap your shifts with others or register wishes for work at other times.",
FaqOverviewBody: "Information about the employee duties, tasks and absences.",
FaqOverviewTitle: "Roster overview",
FaqPhaseApprovedBody: "The planner has processed all reported registrations and are waiting to be transferred to payroll.",
FaqPhaseApprovedTitle: "Approved for payroll",
FaqPhaseConsolidationBody: "The planner compares the employee-reported registrations with the planned duties and absences, and then approves or rejects the reported registrations.",
FaqPhaseConsolidationTitle: "Consolidation",
FaqPhaseOperationBody: "The roster has been published. Employees are able to swap, decline and receive duties and tasks.",
FaqPhaseOperationTitle: "Operation",
FaqPhaseRealisedBody: "Reported times has been transferred to payroll.",
FaqPhaseRealisedTitle: "Realised",
FaqPhaseRequestBody: "Employees are able to submit requests for duties, tasks or absences.",
FaqPhaseRequestTitle: "Request",
FaqPhaseSchedulingBody: "The planner is in the process of planning. Visibility of scheduled duties, tasks or absences for the employee during the period depends on the current configuration of the system.",
FaqPhaseSchedulingTitle: "Scheduling",
FaqPhaseTimeReportBody: "Time reporting is available for the period. Users are able to register work hours and absences.",
FaqPhaseTimeReportTitle: "Time reporting",
FaqPhasesBody: "A roster changes status over a period of time as it undergoes different phases. In MyPlan these phases are reflected through planstatus periods. Each planstatus period has its own name.\n<br/>\nBased on the current planstatus period, MyPlan will automatically allow or restrict various operations. For example, employees are only able to submit requests to a roster in the planstatus period \"Request\", whereas swaps are only possible in the planstatus period ”Operation”.\n<br/>\nBelow are the different planstatus periods and their meaning. The current planstatus period for a plan is indicated by color marking. The color code overview can be found by clicking on the information symbol at the top right side of the application.",
FaqPhasesTitle: "StaffPlan phases",
FaqPlanning: "The planner creates working plans according to demands and your and your colleagues' wishes. In this phase your plan is hidden, but you can still se your wishes.",
FaqPreferencesBody: "Preferences are used to inform the planner about when the employeewould like to work or have time off.\n<br/>\nTo set a preference, click on the day for the preference, which will display a striped dot. If the employee wants to delete a preference, click on the dot again, and the entry will be removed.\n<br/>\nFor preferences without a time, the employee will be asked to specify the time. If clicking the preference dot again, the time can be edited. It is also possible to delete the preference here.\n<br/>\nIt is possible to set multiple preferences on the same day, except for a negative and a positive preference of the same type.\n<br/><br/>\nPreference pattern:\n<br/>\nEmployees can create a preference pattern to easily indicate recurring wishes. Click on the pattern icon at the top left of the Wish page. In this way the employee avoids entering individual preferences, such as every other weekend when they have their children.\n<br/>\nWhen creating a preference pattern, the employee needs to choose whether the preferences should repeat every week or every two weeks. After creation, the employee can set the preferences to be repeated. It is possible to both edit and delete preferences in the preference pattern, as well as delete the entire pattern. However, be aware of when the changes will take effect. This is indicated on the preference pattern.\n<br/>\nOn the Wish page, a preference from the preference pattern will be shown with the pattern icon (it looks like a flower) during the wish period. When the planner moves the wish period forward in time, these will be converted to striped dots.\n<br/>\nPreferences from the preference pattern can be deactivated on individual days. When a preference is deactivated, the pattern icon turns grey and is no longer shown to the planner in StaffPlan. Click the icon again to reactivate the preference.\n<br/>\nThe employee can see all the entered preferences for a day on the corresponding Work page.",
FaqPreferencesTitle: "Preferences",
FaqProductionBody: "Any allocated task can be unfolded to show expanded details. Depending of the setup of the installation it will show \"Task Team\" and/or \"Production Team\".\n<br/>\n\"Task Team\" will show coworkers working on the selected task.\n\"Production Team\" will show coworkers assigned to tasks on the same production as the selected task.",
FaqProductionTitle: "Production/Tasks",
FaqPunchClockBody: "If the department uses Punch Clock, this is the first page the employee sees when they open MyPlan. Here, they register when they start and end their workday.\n<br/>\nWhen they clock in, an animation and a confirmation with the start time are displayed. When they clock out, the confirmation is updated with the end time and total hours worked.\n<br/>\nOn the Work page, the registrations of the day are always visible.\n<br/>\nDepending on the department’s setup of MyPlan, it is also possible to:\n• Specify reasons for early/late clockings and unplanned work.\n• Add a time entry afterward if they forgot to clock during working hours.\n• Clock outside of scheduled working hours.\n<br/>\nTime entries cannot be edited or deleted.",
FaqPunchClockTitle: "Punch clock",
FaqRealized: "The salaries have been processed.",
FaqRegApprovedBody: "The changes are approved by a planner and now form the salary basis.",
FaqRegApprovedTitle: "Approved",
FaqRegPendingBody: "Consolidation could not automatically merge the changes into the roster, and the planner has not yet viewed it. The roster still shown original. The registered changes will appear in a subheading, and an Undo button will be available.",
FaqRegPendingTitle: "Waiting to be processed",
FaqRegPreApprovedBody: "The changes are automatically pre-approved by consolidation, but the planner has not yet viewed them. The original will be visible in a subheading, and a Restore button will be available",
FaqRegPreApprovedTitle: "Pre-approved",
FaqRegRejectedBody: "The changes have been rejected by the planner. A subheading with the rejected changes will appear.",
FaqRegRejectedTitle: "Rejected",
FaqRegStatusBody: "The status of a registered changes can be one of the following:",
FaqRegStatusTitle: "Status on registrations",
FaqRegUnchangedBody: "The registration is unchanged in accordance with the duty, task or absence given by the planner.",
FaqRegUnchangedTitle: "Unchanged",
FaqRegUnprocessedBody: "The employee has registered a change, but it have not yet been processed by the planner. The original will be visible in a subheading, and a Restore button will be available.",
FaqRegUnprocessedTitle: "Unprocessed",
FaqRequest: "Here you can wish when you want to be on and off work. The plan can contain e.g. vacation accepted by the planner.",
FaqShiftMarketBody: "In this menu employees are able to view the status of pending swaps and offers from coworkers and planners. If there are any unread updates, a red dot will appear in the menu.\n<br/>\nDetailed information is available by unfolding a specific swap or offer. Employees can then accept, reject or undo their current offers.",
FaqShiftMarketTitle: "Shift market",
FaqSwapDirectBody: "For a direct swap the employee selects one of their own duties, then selects a coworker from their swap group and chooses a preferred duty to be included in the requested swap.",
FaqSwapDirectTitle: "Direct swap",
FaqSwapGiveBody: "When an employee register a duty as a give away the duty is published to the other employees in the same swap group, who can then request to get the duty without having to offer anything in return. The planner then choose an employee to take over the selected task/duty. The planner may also choose to reject the originally request for give away.",
FaqSwapGiveTitle: "Give away",
FaqSwapOpenBody: "For an open swap the employee publishes a specific duty for other coworks, in the same swap group, to take. The employee will then receive offers from coworkers with suggestions for other duties to be included in the swap. After a suggested offer has been selected, the swap is automatically sent to the planner for final approval. Other offers are then rejected.",
FaqSwapOpenTitle: "Open swap",
FaqTitle: "Help",
FaqUserApproved: "In this phase you accept your time registrations, so that the planner can continue with salaries.",
FaqWeekPlanBody: "The week plan shows the duties, tasks and absences allocated for the selected week. Employees can scroll through the weeks or select a specific week from the menu.\n<br/>\nThe week plan is the default page shown when logging in to MyPlan.\n<br/>\nWhen an employee is allocated a specific duty or task, that day will be marked with a green circle. An absence is marked with a blue circle.\n<br/>\nFor all registrations the start and end time will be shown, as well as the duty or task name. In case of several duties or tasks on the same day, the text \"Work\" will appear together with the overall start/end time for the workday.\n<br/>\nBy clicking a specific day, the \"Daily plan\" opens, where employees can see detailed information about the duty, absence or task, write a message (chat) to the planner, or swap or give away a duty or task.",
FaqWeekPlanTitle: "Week plan",
FaqWishListBody: "The employee uses wishes to inform the planner about specific shifts, absences, tasks, etc. that they would like to have.\n<br/>\nThe wishes can be seen in the balances, such as the employee's standard hours, vacation balance, and time-off balance. This way, one can see how much is left and ensure that the balance is not exceeded.\n<br/>\nTo request something, such as an absence, click on the day for the absence, which will display a colored dot. If the employee wants to delete a wish, click on the dot again, and the entry will be removed (if this is allowed).\n<br/>\nSome types of wishes have self-selected times. When requesting one of these, the employee will be asked to specify the time. If the employee clicks on the wish dot again later, the time can be edited. It is also possible to delete the wish here.\n<br/>\nIf a wish is approved, the wish dot will have a black border.\n<br/>\nIn case a wish is rejected, a red cross will be displayed instead of the wish dot. If the planner has provided a reason for the rejection, it will be shown on the Work page. A shortcut to this is to click on the relevant date on the Wish page.\n<br/>\nIn some configurations, an indication of needs are displayed for tasks. Thus, one can see how many of a given type of task are offered and how many have requested this task. For example, 1/4 means that four tasks are offered, and only one employee has requested this task so far.\n<br/>\nSome types of wishes (e.g., absences) can only be requested during the wish period defined by the planner. These must also be approved by the planner before the wish is accepted.\n<br/>\nEmployees allowed to work double shifts must enter their first wish on the Wish page. Then they must go to the Work page for the same day and create the second wish there.",
FaqWishListTitle: "Wishes",
FaqWishesBody: "In this menu, the employee can register their wishes regarding shifts, absences, tasks, etc. It is also possible to indicate general preferences for when they would like to work and when they would like to have time off. This information helps the planner take the employee's needs and wishes into account when creating the roster in StaffPlan.\n<br/>\nThe types of wishes and preferences that can be registered depend on the chosen system configuration.\n<br/>\nThe difference between wishes and preferences:\n<br/>\nWishes are specific requests for shifts, absences, tasks, etc. They have a higher priority than preferences and are directly included in the roster.\n<br/>\nPreferences are general indications of when the employee would like to work or have time off. The planner takes these into account, but it is not necessary to accommodate all preferences. Employees can create a preference pattern in which recurring wishes can be easily indicated.",
FaqWishesTitle: "Wishes",
FetchData: "Fetch data without opening",
FetchingRegistrations: "Fetching registrations",
FetchingRolloutDate: "Fetching roll-out date",
FetchingTotals: "Fetching Totals",
FictiveEmployees: "Fictive employees",
FictivePerson: "Fictive person",
FillFunctionExplanation: "Below you can select amongst employee who are available and are assigned to the function. The standard hours balance determines the order: Those with the highest deficit on the standard hours are listed left-most.",
FillFunctionExplanationNoEmployees: "There are no available employees assigned to the function",
FillHighlightedFieldToSave: "Please fill the highlighted input field to save",
FillHighlightedFieldsToSave: "Please fill the highlighted input fields to save",
FilterMessages: "Filter messages",
FilterOutEmployeesWith: "Filter out employees with...",
FindEmployee: "Find employee",
FindShiftToSwap: "Find shift to swap",
FindShifts: "Find shifts",
Fingerprint: "Fingerprint",
FirstWeek: "First week",
FollowGroup: "Follow group",
ForSecurityReasonsTheMostSecureBiometricMustBeEnabled: "For security reasons, your phone's most secure biometric method must be enabled to log into MyPlan. On most phones, this is fingerprint authentication.",
ForgotToClockIn: "Forgot to clock in?",
ForgotToClockOut: "Forgot to clock out?",
FormerAssignee: "Former Assignee",
Forward: "Forward",
From: "From",
FromHours: "From hours",
FromMinutes: "From minutes",
FromOriginalShift: "From original shift",
FromThisPhysicianPlan: "from this physician plan",
FullMonthOverview: "Full month overview",
Function: "Function",
FunctionColumn: "Function column",
FunctionDefiniteArticle: "the function",
FunctionIsHiddenWarning: "This counter contains a function which is not shown in the plan",
FunctionLabel: "Create new function column",
FunctionPlan: "FunctionPlan",
FunctionPlanDateNote: "Date note",
FunctionPlanNote: "Plan note",
GamsErrorColumnHasMultipleFunctionIds: "Cannot import to a column that has multiple functions",
GamsErrorColumnHasSubHeaders: "Cannot import to a column that has sub columns",
GamsErrorCouldNotFindDate: "Could not find date",
GamsErrorCouldNotFindFunction: "Could not find function",
GamsErrorCouldNotFindPerson: "Could not find person",
GamsErrorEmptyFunctionName: "Empty function name",
GamsErrorInvalidDateIndex: "Invalid date index",
GamsErrorNothingToImport: "Nothing to import",
GamsErrorPersonNotAvailableOnDate: "not available on date",
GamsImportAvatarBusy: "Waiting for all avatars to be transferred on the server. Please wait.",
GamsImportDialogTitle: "GAMS import",
GamsInstructionsPaste: "Paste (Ctrl-v) data copied from a GAMS spreadsheet",
GamsInstructionsUpload: "or pick a GAMS file:",
Gender: "Sex/gender",
GenderFemale: "Female",
GenderMale: "Male",
GenderOther: "Non-binary/other",
GetCallInErrorTitle: "TeamPlan is currently having trouble finding potential replacements",
GiveAway: "Give away",
GoBack: "Go back",
GoTo: "Go to",
GoToEmployee: "Go to employee ID",
GoToEmploymentStart: "Go to employment start",
GoToEndDay: "Go to end day",
GoToLogin: "Press the button to go to login",
GoToNextDay: "Go to next day",
GoToNextMonth: "Go to next month",
GoToNextWeek: "Go to next week",
GoToOffer: "Go to offer",
GoToPreviousDay: "Go to previous day",
GoToPreviousMonth: "Go to previous month",
GoToPreviousWeek: "Go to previous week",
GoToStartDay: "Go to start day",
GoToSwap: "Go to swap",
GoToToday: "Go to today",
GoToWishPeriod: "Go to wish period",
GoodAfternoon: "Good afternoon",
GoodBeforenoon: "Good morning",
GoodEvening: "Good evening",
GoodMorning: "Good morning",
GoogleCalendarDescription: "The calendar link is copied to your clipboard, so you can paste it into your Google Calendar.",
GotPassword: "Got password ?",
Group: "Group",
GroupPlanTitle: "Colleagues",
GroupingColumn: "Grouping column",
GroupingColumnTooltip: "Serves as headline for sub columns",
Groups: "Groups",
GroupsFollowed: "Groups you follow",
GroupsForEntirePlan: "Groups for the entire plan",
H: "h",
HandoverDefiniteArticle: "the giveaway",
HaveAGreatDay: "Have a great day",
Hello: "Hello",
HhMmSeparator: ":",
Hidden: "Hidden",
HiddenDueToPlanning: "Hidden due to planning",
Hide: "Hide",
HideAbsenceColumn: "Hide absence column",
HideAutoPlanning: "Hide autoplanning",
HideColumnDescriptionWork: "The people who have been planned for are not deleted but are shown in the column 'Other work'. You can show the column again by creating it from an 'existing function'.",
HideDates: "Hide dates",
HideFairness: "Hide distribution of functions",
HideFunctionColumn: "Hide function column",
HideGroups: "Hide groups",
HideImperative: "Hide",
HideRosterTemplates: "Hide plan templates",
HideStaffingStatus: "Hide staffing status",
HideSubsectioning: "Hide subsectioning",
HideWhenPrinting: "Hide when printing",
History: "History",
Holiday: "Holiday",
Hour: "Hour",
Hours: "Hours",
HowMany: "How many unread are being loaded?",
HowManyRead: "How many read have been loaded?",
HowManyUnread: "How many unread have been loaded?",
HttpStatus: "HTTP status",
IfItDeviatesSignificantly: "If it deviates significantly from the scheduled work, you must also provide a reason.",
IfYouStartThePunchClockNow: "If you start the punch clock now, you are clocking in outside of your scheduled shift.",
Import: "Import",
ImportError: "Could not import data",
ImportFromAutoPlanning: "Import suggestion from autoplanning.",
ImportPersonalCalendarBody: "Select a personal calendar to be synchronized to MyPlan work calendar:",
ImportPersonalCalendars: "Import your Personal Calendars",
ImportantMessage: "Important message",
Imported: "Imported",
Importing: "Importing",
IncludedWeekdays: "Weekdays included in counters:",
Info: "Information",
Initials: "Initials",
InputWorkTimeOn: "Enter your working hours for",
InputWorkTimeOnMultiple: "Enter your total working hours for",
Inquiry: "Inquiry",
InsertMultipleTimes: "Insert multiple times on the same day",
Institution: "Institution",
InstitutionAndSalaryIdInvalid: "Add '/' between institution and salary id",
InstitutionAndSalaryIdRequired: "Institution and salary id must be filled",
InstitutionSlashSalaryId: "Institution/salary id",
InternalError: "An unexpected error occured. The error has been reported to our operations department.",
InternalMessage: "Internal message",
InternalMessages: "Internal messages",
InvalidDate: "Invalid date",
InvalidDemand: "Invalid demand.",
ItemType_Array: ["Undefined","Work","Absence","Other","Role","Preference","Task","OnCall","Personal Calender"] as const,
ItemTypeWish_Array: ["Undefined","Request for work","Request for absence","Other","Role","Request for Availability","Task","Personal Calender"] as const,
JumpToNext: "Jump to next",
Keep: "Keep",
KeepChanges: "Keep changes",
KeepExchange: "Keep exchange",
KeepOffer: "Keep offer",
KilometresShort: "km",
Kind_Array: ["Absence","Activity","Availability","Demand","Deputy","Presence","Shift","Swap","Request","Plan status","Task","Swappable","Function","Allowance","Transportation","I would like time off","I would like to work"] as const,
LabelNegativePreference: "Want time off",
LabelPositivePreference: "Want to work",
Language: "Language",
LanguageLabel: "English",
LeaveClockPoint: "Leave ClockPoint",
LeaveEarly: "Leave early",
LeftArrow: "Left arrow",
LeftEarly: "Left early",
LeftLate: "Left late",
LegendCalendarEvent: "Personal calendar",
LegendPlannedAbsence: "Planned absence",
LegendPlannedAvailability: "Planned availability",
LegendPlannedOnCall: "Planned on call",
LegendPlannedOther: "Planned other",
LegendPlannedRole: "Planned role",
LegendPlannedTask: "Planned task",
LegendPlannedWork: "Planned work",
LegendRejectedAbsence: "Rejected absence request",
LegendRejectedAvailable: "Rejected request for availability",
LegendRejectedOnCall: "Rejected on call request",
LegendRejectedOther: "Rejected other request",
LegendRejectedRole: "Rejected role request",
LegendRejectedTask: "Rejected task request",
LegendRejectedWork: "Rejected work request",
LegendUndecidedAbsence: "Absence request (awaiting scheduler)",
LegendUndecidedAvailable: "Availability request (awaiting scheduler)",
LegendUndecidedOnCall: "On call request (awaiting scheduler)",
LegendUndecidedOther: "Other request (awaiting scheduler)",
LegendUndecidedRole: "Role request (awaiting scheduler)",
LegendUndecidedTask: "Task request (awaiting scheduler)",
LegendUndecidedWork: "Work request (awaiting scheduler)",
LegendUnmergeableAbsence: "Unable to process absence request",
LegendUnmergeableAvailable: "Unable to process availability request",
LegendUnmergeableOnCall: "Unable to process on call request",
LegendUnmergeableOther: "Unable to process other request",
LegendUnmergeableRole: "Unable to process role request",
LegendUnmergeableTask: "Unable to process task request",
LegendUnmergeableWork: "Unable to process work request",
List: "List",
LoadEmployeeDataError: "An error occurred while loading employee data.",
Loading: "Loading",
LoadingColors: "Loading colors...",
LoadingColumns: "Loading columns...",
LoadingContacts: "Loading contacts...",
LoadingData: "Wait a moment, we are retrieving your data",
LoadingDays: "Loading days...",
LoadingGroups: "Loading groups...",
LoadingShifts: "Loading shifts",
Location: "Location",
Lock: "Lock",
LockPlan: "Lock period",
LockPlanHelpText: "The chosen date becomes the first in the request period",
LockPlanUntil: "Lock period until",
Locking: "Locking",
LogInWithYourStaffPlanUser: "Log ind med din VagtPlan-bruger.",
LogOut: "Log out",
LoggedOn: "Logged on",
LoggingIn: "Logging in...",
LoggingInAsSupportInfo: "You are logging in as support.",
LoggingOff: "Logging off",
Login: "Log in",
LoginButtonSendNewCode: "Send new code",
LoginButtonTitleRequestCode: "Request Code",
LoginButtonTitleSetPassword: "Set Password",
LoginButtonTitleSignin: "Sign In",
LoginCodeRequired: "Code field must be filled",
LoginLabelPassword: "Password",
LoginLabelUsername: "Username",
LoginLoadingData: "Just a moment,\nyour app is loading data",
LoginPasswordExpired: "Your password has expired. Please create a new password.",
LoginPasswordNoBlackSpacesAtStartOrEnd: "Your username cannot start or end with spaces",
LoginPasswordRequired: "Password field must be filled",
LoginRepeatPasswordHint: "Both passwords must be the same",
LoginRepeatPasswordMismatch: "The password entered does not match the new password",
LoginTitle: "Login",
LoginTitleWelcome: "Welcome to",
LoginUsernamePasswordError: "Unable to log in. Check username and password",
LoginUsernameRequired: "Username field must be filled",
Logoff: "Log off",
LogoffConfirmation: "Are you sure you want to log out of FunctionPlan?",
LogonADFSPortal: "Log on",
LogonAgain: "Please log in again",
Logout: "Logout",
M: "m",
MakeOffer: "Propose swap",
ManyPersonGroupsContent: "You have access to more than 10 person groups, and therefore the app loads data for a person group when it is opened.",
ManyPersonGroupsTitle: "Many person groups",
Margin: "Margin",
MarkAsRead: "Mark as read",
MarkAsUnread: "Mark as unread",
MaxLengthError: "You cannot type any more characters",
Me: "Me",
MeAlt: "Me",
MemberOfRollInPeriods: "Member of roll in periods:",
Menu: "Menu",
MenuExpandLess: "Less",
MenuExpandMore: "More",
MenuItemTitleWork: "Work",
Message: "Message",
MessageCannotBeBlank: "The message cannot be blank",
MessageCouldNotBeSent: "The message could not be send",
MessageFollowUpSetToOff: "Remove the follow-up flag",
MessageFollowUpSetToOn: "Mark for follow-up",
MessageGlobalSetToOff: "Message is public",
MessageGlobalSetToOn: "Mark as public",
MessageInternalSetToOff: "Message is internal",
MessageInternalSetToOn: "Mark as internal",
MessageIsPublic: "The message is public.",
MessageIsUnread: "The message is unread.",
MessagePeriodOverlaps: "The chosen period is outside the shown period",
MessagePersonalSetToOff: "Message is personal",
MessagePersonalSetToOn: "Mark as personal",
MessageRecipientsCannotBeBlank: "You must provide at least one recipient in order to send the message.",
MessageSent: "Message sent",
Messages: "Messages",
MessagesEmptyStateTitle: "No messages",
MessagesFilterColleague: "Colleague",
MessagesFilterDay: "Day",
MessagesFilterInfo: "Info",
Minute: "Minute",
Minutes: "Minutes",
MissingClockOut: "Missing clock out",
Mobile: "Mobile",
MobilePhone: "Mobile phone",
ModifiedDuties: "Modified duties",
ModifiedDuty: "Modified duty",
MomentLoadingData: "Just a moment, we're loading data",
Month: "Month",
Month_Array: ["January","February","March","April","May","June","July","August","September","October","November","December"] as const,
MonthOverview: "Month overview",
MoveImperative: "Move",
MoveLeft: "Move left",
MoveOn: "Move on",
MoveRight: "Move right",
MoveToAbsence: "Move to absence",
MultifunctionRules: "Multifunction rules",
MyContactInfo: "My contact info",
MyPlan: "MyPlan",
MyPlanPreference: "Preference",
MyPlanWish: "Wish",
Name: "Name",
NameAlreadyUsed: "Name already used",
NameInVagtplan: "Name in StaffPlan",
NameRequired: "Please enter name",
NaturalNumberRequired: "Number is required.",
NavigateAwayFromEditedDayViewWarning: "Cancel or save changes before you leave the page",
NetworkErrorOccured: "A network error occured",
New: "New",
NewAutoplanJob: "New autoplan job",
NewColleagueMessage: "New colleague message",
NewEllipsis: "New...",
NewFunction: "New function",
NewMessage: "New message",
NewPasswordIsEmpty: "New password cannot be empty",
NewPhysicianPlanName: "New physician plan name",
NewRegistration: "New registration",
NewRosterItemTitle: "New",
NewSubcolumn: "Create newsubcolumn",
NewTemplate: "New template",
NewVersionAvailable: "New version available",
News: "News",
NewsExchange: "Exchange news",
Next: "Next",
NextRolloutDate: "Next roll-out date",
No: "No",
NoAccess: "No access.",
NoAccessToTeamPlan: "You lack the necessary rights to access TeamPlan.",
NoCameraFound: "No camera found on device.",
NoCandidates: "No ideal candidates",
NoCandidatesLong: "Unfortunately, there are no ideal candidates to show in the sorted call list.",
NoChanges: "No changes",
NoChangesHaveBeenMade: "No shifts have been changed for this person group.",
NoColumnsStarred: "No starred columns",
NoConfiguration: "This plan has no configuration for distribution of functions. Please click the gear in the top right corner to configure.",
NoDaysSelected: "No weekdays selected",
NoDownloadLinkAvailable: "No download link available",
NoEndDate: "No end date",
NoEvents: "No events",
NoNetwork: "Your app needs an internet connection to work",
NoNetworkButton: "Try again",
NoNetworkCheckInternet: "Check that you are connected to the internet?",
NoNetworkContactIT: "If you receive this message even though your internet connection is Ok, please contact your workplace IT support for help.",
NoNetworkCouldYouTry: "Could you try:",
NoNetworkSwitch: "Switching to a different network?",
NoNetworkTitle: "Your app needs internet connection to function",
NoOfWeeks: "Number of weeks",
NoOffersInSearch: "There is no groups that match your search.",
NoPassword: "No password ?",
NoPersonelGroupFollowedTextMobile: "Swipe left on a group and choose",
NoPersonelGroupFollowedTextWeb: "Hover over a group and press the three dots to follow.",
NoPersonelGroupFollowedTitle: "You are not following any groups",
NoPlannedShiftAtTheMoment: "No planned shift at the moment",
NoPlannedShiftsForClockIn: "At the moment, you have no scheduled shifts to clock in to.",
NoPlannedWorkCurrently: "No planned work, currently",
NoPlans: "No plans.",
NoRegistrationOnDay: "You have no planned events or registrations on this day",
NoReusableTemplates: "All existing templates are already included",
NoSearchResults: "No search results",
NoShiftMatch: "There are no shifts\nthat matches your search.",
NoShifts: "No shifts",
NoStartDate: "No start date",
NoSwapOptions: "There are no exchange options.",
NoTasksToWishInThisPeriod: "No tasks to wish in this period",
NoTemplates: "No templates defined",
NoThanks: "No thanks",
NoUnresolvedIssues: "No unresolved issues",
NonPlanned: "Non-planned",
None: "None",
NoneSelectedSaveWarning: "Please select a type before you save",
NonemptyTextRequired: "Some text is required.",
Norm: "Norm",
NormalSize: "Normal size",
NotAssignable: "Not assignable",
NotOnInternalNet: "Not Connected to the company's Network",
NotOnInternalNetDescription: "The punch clock can only be used on the company's internal network. Make sure you are connected to the correct Wi-Fi.",
NotSet: "Not set",
NotSpecified: "Not specified",
Note: "Note",
NoteImperative: "Note",
Notes: "Notes",
NothingPlanned: "Nothing planned",
NothingStarred: "No starred columns/days/people",
NotificationsOff: "Disable notifications",
NotificationsOn: "Enable notifications",
NumRolls: "Number of rolls",
NumWeeks: "Number of weeks",
NumberOfContactColumns: "Number of columns for contacts",
NumberOfNoteColumns: "Number of columns for plan notes",
OddWeek: "odd week",
Of: "of",
Offer: "Offer",
OfferDefiniteArticle: "the offer",
OfferShift: "Offer shift",
OfferTo: "Offer to",
OfferWillBeCancelled: "Offer will be cancelled",
OfferWillBeCancelledPleaseNote: "Please note that the shift is being offered on shift exchange. If the shift is deleted, the offer is cancelled.",
OfferedThroughTempAgency: "Offered through temp agency",
Offers: "Offers",
Ok: "OK",
OldRegistrations: "Previous registrations",
OnTime: "On time",
OnlyShowStarred: "Show only starred columns/days/people",
OpenCalendar: "Open calendar",
OpenPreferencePattern: "Åbn præferencemønster",
Opening: "Opening",
OpeningPlan: "Opening plan",
OpeningTemplates: "Opening plan templates",
OptionallyEditStartDate: "Optionally edit the plan template's start date",
Or: "or",
Order: "Order",
Origin: "Origin",
Original: "Original",
OriginalBelongingTo: "Original belonging to",
OriginalDay: "Revert day",
Other: "Other",
OtherAbsences: "Other absences",
OtherEmployees: "Other employees",
OtherFunction: "Other function",
OtherGroups: "Other groups",
OtherSettings: "Other settings",
OtherWork: "Other Work",
OutOfViewport: "out of the open period",
OutsideEmploymentPeriod: "Outside employment period",
Overview: "Overview",
OwnVehicle: "Own vehicle",
Page: "Page",
PagingLoadNext: "Load next",
PagingLoadPrevious: "Load previous",
Password: "Password",
PasteImperative: "Paste",
PatternCellAbsenceDescription: "single absence preference in the preference pattern",
PatternCellWorkDescription: "single work preference in the preference pattern",
PayerDepartment: "Payer department",
Pending: "Unresolved",
People: "People",
Period: "Period",
PeriodNextDay: "Next day",
PeriodPreviousDay: "Previous day",
PeriodSameDay: "Same day",
PeriodWholeDay: "Whole day",
Periods: "Periods",
Person: "Person",
PersonGroups: "Person groups",
PersonGroupsNotLoaded: "Person groups whose data are not loaded are marked with the icon: ",
PersonIsApproved: "Accepted for salary on day.",
PersonIsRealized: "Transfered for salary on day.",
PersonIsWishing: "Wish period.",
PersonUnemployed: "Person is not employed.",
PersonUnemployedInThisPeriod: "You are not affiliated with an employement in this period",
Personal: "Personal",
PersonalCalendar: "Personal Calendar",
PersonelGroupInfoBody1: "Are you using a group often, it can be a good idea to follow it. Then the app will automatically fetch data and you will receive notifications.",
PersonelGroupInfoBody2NonTouch: "Hover the mouse above a group and click the 3 dots to follow, unfollow or enable/disable notifications",
PersonelGroupInfoBody2Touch: "Swipe left on a group, to follow or enable/disable notifications.",
PersonelGroupInfoBodyTouchSymbolExplanation: "Symbol explanation:",
PersonelGroupInfoBodyTouchSymbolExplanationFetchData: "Fetch data for a group without opening it",
PersonelGroupInfoBodyTouchSymbolExplanationUnreadChat: "Unread chat and internal messages",
PersonelGroupInfoBodyTouchSymbolExplanationUnresolved: "Unresolved",
PersonelGroupInfoTitle: "Fetch and follow person groups",
Persons: "Persons",
Phone: "Cell phone",
Phone2: "Phone 2",
PhoneInvalid: "Phone number is invalid",
PincodesDifferent: "Codes are different. Try again.",
Place: "Place",
Plan: "Plan",
Plan_Array: ["Unknown","Planned","Original","Awaits approval","Edited by planner"] as const,
PlanButtonToday: "Today",
PlanDayTitle: "Day",
PlanId_Array: ["Unknown","Planned","Published","Wished","Registered","Baseline"] as const,
PlanInfo: "Plan info",
PlanListTitle: "List",
PlanMessages: "Messages in the plan",
PlanMonthTitle: "Month",
PlanPhasesSummary: "You should work with your plan in different ways in various plan phases. Plan phases are marked in the plan views with their status. The individual phases are explained below.",
PlanStatus: "Plan Status",
PlanStatus_Array: ["Unknown","Closed","Realized","Approved","Adjustment","User approved","Check in","Operation period","Planning period","Request period","Future","Personal Calendar"] as const,
PlanWeekListTitle: "Week plan",
PlanWeekTitle: "Week",
Planned: "Planned",
PlannedEnd: "Planned end",
PlannedWork: "Planned work",
Planner: "Planner",
PlannerRejectRemark: "Rejection remark",
PlannerRemark: "Note from planner",
PlanningPeriod: "Planning period",
PleaseNoteTheFollowingDuties: "Please note the following duties:",
PollingFailExchange: "MyPlan cannot update the shift market at the moment :(",
PollingFailLoadShifts: "TeamPlan cannot update shifts at the moment :(",
PollingFailMessages: "TeamPlan cannot retrieve chat and internal messages at the moment :(",
PollingFailUnreadMessageCount: "TeamPlan cannot update the unread chat counter at the moment :(",
PollingSuccessExchange: "Yay! MyPlan is able to update the shift market again.",
PollingSuccessLoadShifts: "Yay! TeamPlan is able to update shifts again.",
PollingSuccessMessages: "Yay! TeamPlan is able to retrieve chat and internal messages again.",
PollingSuccessUnreadMessageCount: "Yay! TeamPlan can update the unread chat counter again.",
PopIn: "Pop in",
PopOut: "Pop out",
PortalName: "MyPlan",
PreferenceCellAbsenceDescription: "absence preference",
PreferenceCellWorkDescription: "work preference",
PreferenceInfoNegative: "Preference: Would like to take time off",
PreferenceInfoPositive: "Preference: Would like to work",
PreferencePatternBodyPart1: "The preference pattern allows you to specify recurring preferences for when you would like to work and/or take time off.\n\nWith a few clicks, you can tell your planner that, for example, you always want to take Tuesday evening off (when you go to badminton) or prefer to work weekends in odd-numbered weeks (where your children are with their other parent).",
PreferencePatternBodyPart2Today: "When you enter new preferences in your preference pattern - or change the already existing preferences - the changes are effective starting today.",
PreferencePatternChangesApplies: "Changes to this day are effective as of",
PreferencePatternChangesFromThisWeekApplies: "Changes to this week apply from",
PreferencePatternChooseWeeks: "Choose every week or every other week",
PreferencePatternChooseWeeksTitle: "Choose how often the preferences in your pattern should repeat.\n\nRemember that you can always delete the pattern and create a new one.",
PreferencePatternDeleteTitle: "Delete preference pattern",
PreferencePatternEveryOtherWeek: "Every other week",
PreferencePatternEveryWeek: "Each week",
PreferencePatternGetStarted: "Get started",
PreferencePatternIndicatePreference: "Indicate preference",
PreferencePatternIndicatePreferenceText: "Enter your preference for when you would like to work and/or take time off",
PreferencePatternInfoDisabled: "You have disabled the preference (from your preference pattern) on this date.",
PreferencePatternInfoNegative: "From your preference pattern: Woud like to take time off",
PreferencePatternInfoPositive: "From your preference pattern: Would like to work",
PreferencePatternNoPatternDescription: "Specify a recurring pattern for when you would like to work and/or take time off.",
PreferencePatternNoPatternHeading: "No pattern - yet!",
PreferencePatternSubHeader: "When can I see my changes on the wishes page?",
PreferencePatternTitle: "What is a preference pattern?",
PreferenceRejected: "Preference rejected by function",
PreferenceWithExistingBodyPart1: "Your new preference conflicts with a preference from your preference pattern.",
PreferenceWithExistingBodyPart2: "If you keep the new one, the preference from the pattern will be removed on this day.",
PreferenceWithExistingConfirm: "Yes, create the new one",
PreferenceWithExistingTitle: "Are you sure you want to create this preference?",
PreferencesColumn: "Preferences from MyPlan",
PreparingDataForPrint: "Preparing data for print",
PresentDay: "Present day",
PresentMonth: "Present month",
PresentWeek: "Present week",
PreviousChoices: "Previous choices:",
PrintDateNotesHeader: "Date notes",
PrintPlanNotesHeader: "Plan notes",
PrivacyPolicy: "Privacy Policy",
Problem: "Sorry, there's a problem.",
ProblemNet: "Sorry, there's a network problem.",
ProblemTechnical: "Sorry, we have a technical problem.",
ProblemWithDay: "Your planner is processing your request.",
ProblemWithHighlightedDay: "The highlighted day require manual processing",
ProblemWithHighlightedDays: "The highlighted days require manual processing",
Processing: "Processing",
Production: "Order",
Productionteam: "Order team",
Profession: "Profession",
Program: "Project",
ProtocolError: "Protocol error",
PublishPlan: "Publish plan",
Publishing: "Publishing",
PunchClock: "Punch clock",
PunchingErrorTitle: "Something went wrong during clocking",
Purpose: "Purpose",
QRErrorDescription: "Try entering salary id instead",
QRNotFound: "QR-code not recognized",
Read: "Read",
ReadMessagesAndNotes: "Read chat and internal messages",
ReadMessagesEmptyStateTitle: "No read messages",
ReadPluralPastTense: "Read",
RealizedPeriod: "Realized period",
ReasonForDeviationEnd: "Reason for deviating clock-out",
ReasonForDeviationStart: "Reason for deviating clock-in",
Receive: "Receive",
Receiver: "Receiver",
RecentlyUsedShiftDefs: "Recently used",
Refresh: "Refresh",
RegardingShort: "On",
Register: "Register",
RegisterTask: "Register task",
RegisterWorkTime: "Register work time",
RegisterWorkTimeHere: "Register your work time here",
RegisteredTask: "Registered task",
RegisteredTasks: "Registered tasks",
RegistrationNumber: "Registration number",
Registrations: "Registrations",
Reject: "Reject",
RejectShiftAssignment: "Confirm cancellation of offer",
RejectShiftAssignmentContent: "Are you sure you want to cancel the offer on this shift?",
RejectShiftExchange: "Confirm rejection of exchange",
RejectShiftExchangeContent: "Are you sure you want to reject this shift exchange?",
RejectedByPlanner: "Rejected by planner",
Relation: "Relation",
RelationAdd: "Add relative",
RelationChild: "Child",
RelationClose: "Closest relative",
RelationEdit: "Edit relative",
RelationFriend: "Other",
RelationParent: "Parent",
RelationPartner: "Partner",
RelationSibling: "Sibling",
RelativesContactInfo: "Relatives' contact info",
Remark: "Remark",
Remove: "Remove",
RemoveColour: "Remove color",
RemoveFromClipboard: "Remove from clipboard",
RemoveGroupColouring: "Remove group coloring",
RemoveImperative: "Remove",
RemovePersonFromRoll: "Remove person from roll:",
RemoveShift: "Delete shift",
RemoveStar: "Remove star",
RemoveStars: "Remove all stars",
Repetition: "Repetition",
Reply: "Reply",
ReportTitle: "Activities",
Request: "Request",
ResetActionButtonTitle: "Reset",
ResetNewPasswordRepeatTitle: "Repeat",
ResetNewPasswordTitle: "New Password",
ResetPasswordSectionTitle: "Reset Password",
ResetPasswordSuccess: "New password has been set",
ResetPasswordTitle: "Old Password",
Resolution: "Resolution",
ResourceConstraintName: "Resource constraint",
Resources: "Resources",
ResponseFromServer: "Response from server",
Restore: "Restore",
RestoreDay: "Restore day",
RestoreOriginal: "Revert plan",
RestoreOriginalDay: "Restore original day",
RestoreOriginalDayExplanation: "Do you want to restore the original day? If you restore the original day all registrations will be deleted.",
RestoreOriginalPastMidnightNote: "If you have shifts that extend past midnight, your registrations for the following day for those shifts will be deleted as well.",
ReuseFunctionFromAnotherPlan: "Reuse function from another plan",
ReusedPassword: "The new password is the same as one of the last three passwords.",
RightArrow: "Right arrow",
Roll: "Roll",
RollingOut: "Rolling out",
RollingOutToClosedColumn: "You are rolling out a template for hidden functions. Persons in these functions will be moved to 'Ikke Planlagt' automatically.",
RolloutTemplates: "Roll out templates",
RolloutTimeoutErrorHtml: "Rollout of the template is taking longer than expected, but it is still ongoing.<br>Please wait for the current rollout to complete before starting a new one.",
RolloutTimeoutErrorTitle: "Rollout is still in progress",
RosterLineType_Array: ["Undefined","Work","Absence","Sick","Dropped","Hidden"] as const,
Rule: "Rule",
RuleBreak: "Rule violation",
RuleViolation: "Rule violation",
RuleViolationInfo: "In the sorted call list employees are sorted by the severity of the rule violation occuring when a given employee is assigned the shift.\n\nThe severity of the rule violation is indicated by a number. The higher the number, the higher the severity.\n\n1 means that no rule violation will occur.",
RuleViolationInfoApplicants: "The list of applicants, employees are sorted by the severity of the rule violation occuring when a given employee is assigned the shift.\n\nThe severity of the rule violation is indicated by a number. The higher the number, the higher the severity.\n\n1 means that no rule violation will occur.",
RuleViolationInfoSortedCallList: "In the sorted call list employees are sorted by the severity of the rule violation occuring when a given employee is assigned the shift.\n\nThe severity of the rule violation is indicated by a number. The higher the number, the higher the severity.\n\n1 means that no rule violation will occur.",
RuleViolationTitle: "Possible violation of the 11-hour rule",
SalaryId: "Salary id",
SalaryIdDescription: "If you can't scan your QR code, you can enter your salary id instead.",
SalaryIdNotRecognized: "Salary id id not recognized",
Save: "Save",
SaveAnyway: "Save anyway",
SaveChanges: "Save changes",
SaveChangesToPlanDescription: "Changes have been made to the plan. Do you want to save these?",
SaveChangesToPlanTitle: "Save changes to plan?",
SaveDay: "Save day",
SaveGroups: "Save groups",
Saved: "Saved",
Saving: "Saving...",
SavingConfiguration: "Saving configuration...",
SavingDemandTemplate: "Saving demand template",
SavingPlan: "Saving plan.",
SavingWorkingHours: "Saving working hours...",
Scan: "Scan",
ScanQRCodeToClockInOut: "Scan your QR code to clock in or out",
ScheduledColleagues: "Scheduled colleagues",
Search: "Search",
SearchForColleague: "Search for colleague",
SearchNoResults: "Unfortunately, there is no colleague named",
SecondWeek: "Second week",
Security: "Security",
SeeDeputyOffer: "See offer",
SeeShift: "See shift",
SeeSwap: "See swap",
SeeYouSoon: "See you soon",
SelectAbsenceBack: "Select date",
SelectAbsenceType: "Select absence type",
SelectAbsenceTypes: "Select absence types",
SelectAll: "Select all",
SelectAtLeastOneFunction: "Select at least one function",
SelectAtLeastOneGroup: "Select at least one group",
SelectAtLeastTwoFunctions: "Select at least two functions",
SelectCameraDescription: "Select which camera you want to use to scan the QR code",
SelectCandidateExplanation: "Filter to exclude employees from being offered the shift.",
SelectCategory: "Select a category:",
SelectColour: "Select color",
SelectColumnType: "Select column type:",
SelectCounter: "Select a counter:",
SelectCountersForTotalCounter: "Select counters to include in total counter:",
SelectDate: "Select date",
SelectEmployment: "Choose employment",
SelectFairnessGroups: "Please choose which person groups to show the distribution for.",
SelectFunctionColumn: "Select function column",
SelectFunctions: "Select functions to include in counter:",
SelectLanguage: "Select language",
SelectNone: "Select none",
SelectNoneSelected: "Select",
SelectPeriod: "Select period",
SelectPeriods: "Select periods",
SelectShiftType: "Select shift type",
SelectStaffGroups: "Select groups",
SelectStartDate: "Select start date",
SelectTheDay: "Select the day",
SelectThePersonGroup: "Select the person group",
SelectTheShift: "Select the shift",
SelectTotalCounter: "Select a total counter:",
SelectType: "Select type",
SelectViewMode: "Select view mode",
SelectWorkingHours: "Select working hours",
SelfPlannedTask: "Self-planned task",
Send: "Send",
SendMessage: "Send message",
SendToRollout: "Send to roll-out",
Sending: "Sending...",
SendingMessage: "Sending message...",
Sent: "Sent",
SentToExchange: "Sent for exchange.",
SessionExpired: "The session has terminated. Please log on again",
SetPlanningStart: "Setting planning start",
SetRequestStart: "Setting request start",
SettingsCouldNotBeOpened: "Settings could not be opened",
SetupLastEditedBy: "Setup last modified by",
ShStatus: "SH status",
Shift: "Shift",
ShiftCode: "Shiftcode",
ShiftCounterListEmpty: "ShiftCounterList needs to be filled out",
ShiftCounterUnit_Array: ["NOT_USED","hours","days","amount"] as const,
ShiftDefiniteArticle: "the shift",
ShiftHoursHaveBeenModified: "Shift hours have been modified",
ShiftLabel: "Create shift column (typically a full-day shift followed by self-scheduled time)",
ShiftStatusAbsent: "Absent",
ShiftStatusActionRequired: "Action required",
ShiftStatusDeputyOffered: "Substitute offered",
ShiftStatusNoActivities: "Planned work w/o activities",
ShiftStatusOffered: "Offered - no applicants yet",
ShiftStatusPlanned: "Planned work",
ShiftStatusReplaced: "Replaced",
ShiftStatusSubstitute: "Substitute",
ShiftType: "Shift type",
ShiftTypeNotAvailable: "The shift type is not available for this person group",
ShiftTypeNotAvailableExplanation: "Changing the shift type cannot be reverted after saving changes.",
ShiftsAndAbsence: "Shifts and absence",
ShiftsExchange: "Shift exchange",
Show: "Show",
ShowAllColumnsDays: "Show all columns/days/persons",
ShowAutoPlanning: "Show autoplanning",
ShowDates: "Show dates",
ShowFaces: "Show faces",
ShowFairness: "Show distribution of functions",
ShowGroups: "Show groups",
ShowHistory: "Show history",
ShowInactivePlans: "Show inactive plans",
ShowInitials: "Show initials",
ShowNumberOfPeople: "Show number of people",
ShowPeople: "Show people",
ShowRosterTemplates: "Show plan templates",
ShowSubsectioning: "Open and show subcolumns",
ShowTotals: "Show totals",
Showing: "Showing",
SignIn: "Sign in",
SignOut: "Sign out",
SignatureExplanation: "Symbol explanation",
SingleApplicant: "There is currently 1 applicant",
SingleApplicantFromShiftExchange: "1 applicant on shift exchange",
SixthWeek: "6th week",
Speciality: "Speciality",
SpecifiedTimeIsOverlapping: "The time entered overlaps with another registration",
Specify: "Specify",
SpecifyAutoPlanJobLabel: "Specify autoplan job label",
SpecifyCause: "Specify cause",
SpecifyEndTime: "Enter the end time.",
SpecifyRecipient: "Specify recipient",
SpecifyStartTime: "Enter the start time.",
SpecifyTime: "Specify time",
Spent: "Spent",
StaffingStatus: "Staffing status",
StarImperative: "Star",
StarShift: "* shift",
Start: "Start",
StartBeforeMidnight: "Start before midnight?",
StartDate: "Start date",
StartOfPlanning: "Start of planning",
StartOrEndTimeHasBeenChanged: "The start and/or end time for this shift has been changed.",
StartTemplateWeek: "Start with template week",
StartTime: "Start time",
StartYesterday: "Start yesterday?",
StartedEarly: "Started early",
StartedLate: "Started late",
Status: "Status",
StatusFromShiftMarket: "Status from shift market",
StdHours: "Standard hours",
Stop: "Stop",
StopExport: "Stop export",
StopExportWarning: "If you stop exporting the work calendar, the calendar will disappear in all the places you have shared it.\n\nYou will have to copy a new link if you want to export again. The old link will no longer work.",
StopExportWorkCalendar: "Stop export of work calendar",
Stopped: "Stopped",
Sum: "Sum",
SwapDefiniteArticle: "the swap",
SwapGiveAway: "Give away shift",
SwapShift: "Swap shift",
SwapWith: "Swap with",
Switch: "Switch",
SwitchPlan: "Switch plan",
SwitchToEditView: "Switch to edit view",
SwitchToPrintView: "Switch to print view",
Synchronizing1Item: "Saving 1 item.",
SynchronizingPlan: "Synchronizing the plan.",
SynchronizingPlanPlaces: "Synchronizing demand.",
SynchronizingTemplatePlaces: "Synchronizing template demand.",
SynchronizingTemplates: "Synchronizing template plans.",
SysRemarkUnmergeable: "The day is locked, and your registration will be processed by your planner.\n\nIf you want to make changes, you can unlock the day by undoing your request.\nPress: ",
SysRemarkUnmergeablePlural: "The days are locked, and your registrations will be processed by your planner.\n\nIf you want to make changes, you can unlock the days by undoing your requests.\nPress: ",
Sysremark: "Planner",
Take: "Take",
Takeshift: "Take shift",
Task: "Task",
TaskDefiniteArticle: "the task",
TaskRegistration: "Task registration",
TaskStatus_Array: ["Planned","Started","Completed","Cancelled"] as const,
Tasks: "Tasks",
Taskteam: "Task team",
Team: "Person groups",
TeamPlan: "TeamPlan",
TechnicalDetails: "Technical details",
Templates: "Templates",
ThankYou: "Thank you",
TheAppVersionIsOutDated: "The App version is outdated",
TheColumn: "The column",
TheDate: "the",
TheErrorMessageWasCopied: "The error message was copied to the clipboard",
ThePlanner: "The planner",
TheSpecifiedTimeOverlapsWith: "The specified time overlaps with",
TheSpecifiedTimeOverlapsWithTheFollowing: "The specified time overlaps with the following shifts:",
TheSpecifiedTimesOverlapWith: "The specified times overlap with",
TheSpecifiedTimesOverlapWithTheFollowing: "The specified times overlap with the following shifts:",
ThisAppliesToFunctions: "This applies to the following functions:",
ThisShiftHasBeenModified: "This shift has been modified",
TileAlreadyHasAvatar: "There is already a registration for the same person and the same function on the day.",
Time: "Time",
TimeOff: "Time off",
TimeRegistration: "Time registration",
TimeRegistrationExplanation: "Register your work day start and end.",
TimeRegistrations: "Time registrations",
TimeSpecifiedUponSelection: "Time specified upon selection",
TimestampsFromPunchClock: "Timestamps from punch clock",
TimestampsFromStopwatch: "Timestamps from stopwatch",
To: "To",
ToHours: "To hours",
ToInclusive: "To (inclusive)",
ToMinutes: "To minutes",
Today: "Today",
TooManyGroupsAlertBody: "For optimal performance, there is a limit on the number of employees the app can fetch data from simultaneously.\n\nTherefore, you need to free up space by removing one of the existing groups if you want to add a new one.\n\nPlease note that it might be necessary to remove several small groups to make room for a larger one.",
TooManyGroupsAlertTitle: "No more room to follow any more groups",
Total: "Total",
TotalCounterStatusText: "A total counter sums selected counters from the other categories.",
TotalTime: "Total time",
Totals: "Totals",
TotalsChangedByEmployeeInfoText: "You have made changes on this day yourself, after the plan has been released. You can see the original plan by clicking on the day on this page.",
TotalsChangedByPlannerInfoText: "Your scheduler has made changes to this day after the schedule has been released. You can see the original plan by clicking on the day on this page.",
TotalsTitle: "Time balance",
TotalsTitleShort: "Balance",
TotalsUltimoAbbreviation: "Bal.",
TouchId: "Touch ID",
TransferPlanFrom: "Transfer plan from",
TransferPlanTo: "Transfer plan to",
TransferingPlan: "Transfering plan",
TryAgain: "Try again",
TryAgainOrLoginAsUsual: "Try again or log in as usual.",
TurnOn: "Turn on",
Type: "Type",
TypeCategory: "category",
TypeCounter: "counter",
TypeTotalCounter: "total counter",
UnableToOpenSettingsTryManually: "Unfortunately, we could not open the settings automatically. Please try opening the phone's settings manually.",
UnderPlanning: "Under planning",
Understood: "Understood",
UnfollowDialogTitle: "Unfollow group",
UnfollowGroup: "Unfollow group",
Unknown: "Unknown",
UnknownError: "unknown error",
UnknownLowercase: "unknown",
UnlimitedDemand: "Unlimited demand",
UnmergeableErrorMessage: "The wish is registered, but awaits handling by the planner.",
Unread: "Unread",
UnreadMessages: "Unread messages",
UnreadMessagesAndNotes: "Unread chat and internal messages",
UnreadMessagesEmptyStateTitle: "No unread messages",
UnreadPluralPastTense: "Unread",
UnscheduledWork: "Unscheduled Work",
Unspecified: "Unspecified",
Unverified: "Under processing...",
UpdateNow: "Update now",
Url: "URL",
UsePreference: "Use preference",
UsePreferenceDetails: "Turn off if you do not want the preference pattern to apply for this day.",
Used: "Used",
User: "User",
UserInfoLabelEmployed: "Employed",
UserInfoLabelSallaryId: "Salary id",
UserInfoLabelTitle: "Title",
UserInfoTitle: "About me",
UserInitials: "Initials",
UserNameIsRequired: "Username is required",
Vacation: "Vacation",
ValidUntil: "Valid until",
Validities: "Validities",
Verifying1Item: "Verifying 1 item.",
Version: "Version",
VersionNotSupported: "Version not supported",
Via: "Via",
Warning: "Warning",
WarningFirstPeriodCreated: "When you add a period, all persons planned outside the period will be moved to unplanned.",
Week: "Week",
Weekday_Array: ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"] as const,
WeekdayInitials_Array: ["M","T","W","T","F","S","S"] as const,
Weeks: "Weeks",
WeeksLowercase: "weeks",
What: "What",
WhatPlanPhasesAreThere: "What plan phases are there?",
When: "When",
WhenChangingOrganisationLocalDataIsDeleted: "When changing organisation your local app settings, such as calendar synchronization with other calendars, will be deleted.",
WhenDidYouEnd: "When did you end working?",
WhenDidYouStart: "When did you start working?",
Whenever: "Whenever",
WhereToFindDepartments: "You will find the person groups under \"Change team\" at the bottom of the screen.",
WhichVersionIsThis: "Which version is this?",
Who: "Who",
WhoDoYouWantToSwapWith: "Who do you want to swap with?",
Whoever: "Anyone",
WillBeDeletedWithTheShift: "Will be deleted with the shift:",
Wish: "Wish",
WishPeriod: "Wish period",
WishRejected: "Wish rejected by function",
WishStatus: "Wish status",
WishTitle: "Wishes",
Wishes: "Wishes",
WishesAndRegistrations: "Wishes and time registrations",
WishesDurationExplanation: "You can change the time for wishes marked as editable.\n\nWhen you create wishes without a predefined time, you will be asked to enter the times.\nWishes with a predefined time are created immediately.\n\nIf you want to adjust the time afterwards, you can just click on the wish in question.",
With: "With",
WithContacts: "With contacts",
WithDatePlanNotes: "With date notes",
WithPlanNotes: "With plan notes",
WorkHoursTimeoutErrorHtml: "Changing work hours is taking longer than expected, but it is still in progress.<br>Please wait for the result before repeating the action.",
WorkHoursTimeoutErrorTitle: "The change in work hours is still in progress",
WorkdayStatusNoRegistrations: "Original",
WorkdayStatusNonnegative_Array: ["Unprocessed","Approved","Awaits Planner","Rejected","Could not process","UnprocessedUnregistered","Unregistered","EmpRegistered","Invalid","UnprocessedNewRegistered","Edited by planner","Unprocessed"] as const,
Working: "Working",
WorkingHoursHelp: "Hold down ctrl to mark multiple functions and groups.",
Workload: "Workload",
WouldLikeToTakeTimeOff: "Would like to take time off",
WouldLikeToWork: "Would like to work",
WouldYouLikeToUseBiometricLoginEnableInSettings: "Would you like to log in using face recognition or fingerprint in the future? You need to turn it on in your phone’s settings.",
WriteComment: "Write a comment",
WriteDateNote: "Write date note",
WriteMessage: "Write a message",
WritePlanNote: "Write plan note",
Year: "Year",
Yes: "Yes",
YesCancelOffer: "Yes, cancel offer",
YesConfirmCancel: "Yes, cancel",
YesConfirmReject: "Yes, reject",
YesConfirmSwap: "Yes, approve swap",
YesLeavePage: "Yes, leave page",
YesLogout: "Yes, log out",
Yesterday: "Yesterday",
YouAreInPlanningPeriod: "You are in the planning period",
YouAreNotClockedIn: "You are not clocked in",
YouAreOffline: "Could you try to:\n● Check if you are on the Internet?\n● Switch to a different network?\n\nIf you get this message even though your Internet connection is working, contact IT support at your workplace for help.",
YouAreRunning: "You are running Physician Plan",
YouAreUsing: "You are using",
YouCannotStartAfterEnd: "You cannot start work after your scheduled end time.",
YouCannotStartThisEarly: "You cannot start work this early.",
YouCannotUseForbiddenCharacters: "Regrettably, it is not possible to use special characters.",
YouHaveFollowingPosibleAnswers: "You have the following possible answers:",
YouHaveRejected: "You have already rejected:",
YouMustReload: "You must reload the plan before continuing.",
YouWillBeLoggedOutShortly: "You will be logged out shortly",
YourAppIsHavingProblemsWithTheServer: "Your app has no contact with the server",
YourPreferencePattern: "Your preference pattern",
YourWeek: "Your week",
Zoom: "Zoom",
ZoomIn: "Zoom in",
ZoomOut: "Zoom out",
absence_plural: "Absence",
absenceType: "Absence type",
accept: "Accept",
additionalInformation: "Additional information",
all: "All",
allEmployees: "All employees",
alreadyClockedInOtherEmploymentDescription: "Please end your current clock-in before starting a new one.",
alreadyClockedInOtherEmploymentTitle: "You are already clocked in",
alsoShifts: "also shifts",
and: "and",
appInformation: "App Information",
assignShift: "Assign shift",
assignShiftCandidateErrorTitle: "Unfortunately, TeamPlan could not assign the shift",
assignShiftErrorTitle: "TeamPlan could not assign the shift",
auditActionAcceptShiftExchange: "Accept shift exchange",
auditActionCalendar: "Calendar",
auditActionCancelExchange: "Cancel shift exchange",
auditActionChangeTeam: "Change person group",
auditActionInit: "init",
auditActionSelectShift: "Select shift",
auditActionToggleAllowNotifications: "Toggle allow notifications",
back: "Back",
callList: "Sorted call list",
canProcessClockEventErrorTitle: "Oops! Unfortunately, you cannot clock in / clock out at the moment",
cancelOfferOnShiftExchange: "Cancel offer on shift exchange",
cancelOfferOnShiftExchangeErrorTitle: "Oops! Something went wrong when TeamPlan was about to cancel the offer",
candidates: "Candidates",
candidates_short: "Cand..",
caretDown: "Down arrow",
changePasswordErrorTitle: "Oops! Something went wrong when MyPlan tried to save your new password",
check: "Check",
chooseAbsenceType: "Choose absence type",
chooseLanguage: "Choose language",
chooseTeam: "Choose person group",
clear: "Clear",
clearEmployeeWorkDayErrorTitle: "Oops! Something went wrong when MyPlan tried to restore the original day",
createPreferencePatternErrorTitle: "Oops! Something went wrong when MyPlan tried to create your preference pattern",
createSharediCalendarErrorTitle: "Oops! Something went wrong when MyPlan tried to create calendar link",
deletePreferencePatternErrorTitle: "Oops! Something went wrong when MyPlan tried to delete your preference pattern",
deleteSharediCalendarErrorTitle: "Oops! Something went wrong when MyPlan tried to stop calendar export",
editShiftErrorTitle: "Oops! Something went wrong when TeamPlan was saving your changes to the shift",
employeeDefiniteArticle: "the employee",
endAbsenceErrorTitle: "Oops! Something went wrong when TeamPlan tried to end the absence",
enterPassword: "Enter password",
enterUserName: "Enter username",
errRequestIsNotRequest: "The exchange requester-part is not a requester part (requesterid does not refer to a request). This must be a programming error in the frontend.",
exchange: "Exchange",
exchangeAcceptErrorTitle: "TeamPlan could not approve the swap",
exchangeCandidateFilter: "Candidate filter",
exchangeCandidateFilter_callinEsque: "Shifts and protected absence (more cand..)",
exchangeCandidateFilter_classic: "Shifts and absence (fewest candidates)",
exchangeCandidateFilter_noCallin: "Protected absence (most candidates)",
exchangeRejectErrorTitle: "TeamPlan could not reject shift change",
expectedToBeBack: "Expected to be back",
failedToDecodeSVG: "Failed to decode SVG data",
findSubstitute: "Find substitute",
getAbsenceTypesErrorTitle: "TeamPlan could not retrieve the absence list",
getAllChatMessagesErrorTitle: "MyPlan cannot retrieve your messages at the moment",
getAllCounterDefinitionsErrorTitle: "Oops! Something went wrong when MyPlan tried to retrieve your balances",
getAllTotalRegistrationsErrorTitle: "MyPlan unfortunately cannot show your registrations at the moment",
getEmployeeDataErrorTitle: "MyPlan is having trouble retrieving your information right now",
getEmployeesErrorTitle: "Oops! Something went wrong when TeamPlan was retrieving employee information",
getExchangeErrorTitle: "TeamPlan could not retrieve all information about this exchange/offer",
getGlobalSettingsErrorTitle: "Oops! Something went wrong when MyPlan tried to retrieve the settings",
getGroupRosterErrorTitle: "MyPlan unfortunately cannot show your colleagues' schedules at the moment",
getHolidaysErrorTitle: "TeamPlan is currently having trouble retrieving holidays",
getInfoSharediCalendarErrorTitle: "MyPlan cannot retrieve data about your calendar links at the moment",
getMessagesErrorTitle: "TeamPlan cannot retrieve chat and internal messages at this time",
getModifiedDutyLinesErrorTitle: "Oops! Something went wrong when TeamPlan was retrieving the duties of the shift",
getNormBalancesErrorTitle: "MyPlan unfortunately cannot show your norm balance at the moment",
getPreferencePatternEffectiveFromDateErrorTitle: "MyPlan cannot show correct start date on preference pattern at the moment",
getPreferencePatternErrorTitle: "MyPlan cannot retrieve your preference pattern at the moment",
getPreferenceRosterErrorTitle: "MyPlan unfortunately cannot show your selected preferences at the moment",
getPreferenceSortsErrorTitle: "MyPlan unfortunately cannot show preferences at the moment",
getRecipientsErrorTitle: "MyPlan unfortunately could not retrieve the list of possible recipients",
getRemovedRegistrationInfoErrorTitle: "Oops! Something went wrong when TeamPlan tried to retrieve the activities of the shift",
getRosterErrorTitle: "MyPlan unfortunately could not retrieve your schedule at the moment",
getRosterInitialErrorTitle: "MyPlan is having trouble retrieving your schedule right now",
getRosterRefreshErrorTitle: "MyPlan unfortunately could not update your schedule",
getSettingsErrorTitle: "Oops! Something went wrong when TeamPlan was retrieving the setup",
getShiftCandidateListErrorTitle: "Oops! Something went wrong when TeamPlan was trying to retrieve the sorted call list",
getShiftDefsErrorTitle: "TeamPlan could not retrieve the list of shift types",
getSortsErrorTitle: "Oops! Something went wrong when MyPlan tried to fetch registration definitions",
getTeamRosterErrorTitle: "TeamPlan is having problems retrieving the person group's work plan",
getTeamsErrorTitle: "Oops! Something went wrong when TeamPlan was trying to retrieve person groups",
getTokenForBiometricAuthErrorTitle: "Unfortunately, MyPlan cannot log you in with biometrics at the moment",
getTotalDefinitionsErrorTitle: "Oops! Something went wrong when MyPlan tried to retrieve your balances",
getTotalRegistrationsErrorTitle: "MyPlan unfortunately cannot show your registrations at the moment",
getTotalsErrorTitle: "Oops! Something went wrong when MyPlan tried to retrieve your balances",
getUnreadMessagesCountErrorTitle: "Oops! Something went wrong when TeamPlan tried to update the number of unread messages",
getVersionErrorTitle: "Oops! Something went wrong when TeamPlan was trying to retrieve the version number",
handoverShiftErrorTitle: "Oops! Something went wrong when MyPlan tried to hand over the shift",
hidePhoneNumber: "Hide number from colleagues",
killItemErrorTitle: "Oops! Something went wrong when MyPlan tried to remove the request",
killPreferenceErrorTitle: "Oops! Something went wrong when MyPlan tried to remove the preference",
languageName: "English",
limitedAccess: "Limited access",
limitedAccessDescription: "You can send and view your own messages, but do not have access to view messages from others.",
loadMoreDays: "Load more days",
loadingLong: " We are just doing the final calculations",
loadingMedium: " We will be ready shortly",
loadingReallyLong: " This is taking a little longer than usual, but we are still working on it",
loadingShort: " Just a moment, we are preparing your options",
login: "Log in",
logonBiometricAuthErrorTitle: "Oops! Something went wrong during login",
logonOpenIdErrorTitle: "Oops! Something went wrong during login",
logonPasswordErrorTitle: "Oops! Something went wrong during login",
logonSupporterErrorTitle: "Oops! Something went wrong during login",
logonWindowsErrorTitle: "Oops! Something went wrong during login",
mail: "Mail",
markAsHandled: "Mark as handled",
markAsHandledErrorTitle: "Oops! Something went wrong when TeamPlan tried to mark the shift as handled",
markMessageAsReadErrorTitle: "Unfortunately, MyPlan could not mark the message as read",
markMessagesAsReadErrorTitle: "Unfortunately, TeamPlan could not mark the message as read",
netError: "Sorry, there is a problem with the network, status:",
newPlural: "new",
newSingular: "new",
noAppInformation: "No App Information found",
noDepartmentsSelected: "No person groups selected",
noDepartmentsToShow: "No person groups to show",
noEmployeeToShow: "No employee to show",
noShiftsToShow: "No shifts with unread messages to show",
noSortedCallListToShow: "No candidates in the call list",
notification: "Notification",
offerOnShiftExchange: "Offer on shift exchange",
offerOnShiftExchangeErrorTitle: "Oops! Something went wrong when TeamPlan was going to offer the shift",
onThisDay: "on this day",
ongoingAbsence: "Ongoing Absence",
password: "Password",
passwordIsRequired: "Password is required",
pendingIssue: "unresolved issue",
pendingIssues: "unresolved issues",
phone: "Phone",
phoneGapCalendarFindEventsError: "There was a problem reading the phones calendar events",
phoneGapCalendarListsError: "There was a problem reading the phone calendars",
phoneGapCalendarNoPermError: "No permission to access the phone calendars",
phoneGapCalendarNoPluginError: "Cannot access the phone calendars",
phoneGapCalendarUpdateSelectedError: "There was a problem updating the calendar list",
postColleagueChatMessageErrorTitle: "MyPlan unfortunately could not send your message",
postDayChatMessageErrorTitle: "MyPlan unfortunately could not send your message",
postMessagesErrorTitle: "Unfortunately, TeamPlan was unable to send your message",
processClockEventErrorTitle: "Oops! Something went wrong when MyPlan tried to register your clocking",
processTimeRegEventListErrorTitle: "Oops! Something went wrong when MyPlan tried to save your time registration",
putItemErrorTitle: "Oops! Something went wrong when MyPlan tried to create the request",
putPreferenceErrorTitle: "Oops! Something went wrong when MyPlan was trying to create the preference",
queryAttendanceTolerancesAndReasonsErrorTitle: "Unfortunately, MyPlan cannot clock in / clock out at the moment",
queryClockEventsErrorTitle: "MyPlan cannot currently display your time registrations",
registerAbsence: "Register absence",
registerAbsenceErrorTitle: "Oops! Something went wrong when TeamPlan was registering the absence",
reload: "Reload",
removeShiftErrorTitle: "Oops! Something went wrong when TeamPlan tried to delete the shift",
requestShiftExchangeErrorTitle: "Oops! Something went wrong when MyPlan tried to create the exchange",
requesterFindSwapsErrorTitle: "Oops! Something went wrong when MyPlan tried to find shifts",
responsibility: "Responsibility",
search: "Search",
setBoardNoteStatusErrorTitle: "MyPlan unfortunately could not mark the message as read",
setExchangeSeenErrorTitle: "MyPlan unfortunately could not mark your offers as read",
setFavoriteStatusErrorTitle: "Oops! Something went wrong when TeamPlan was supposed to follow the person group",
setNotificationStatusErrorTitle: "Sorry, your notification settings could not be saved",
setSimpleMessageRecipientReadWhenErrorTitle: "MyPlan unfortunately could not mark the message as read",
settings: "Settings",
shift: "shift",
shift_plural: "Shifts",
somethingWentWrong: "Something went wrong",
suggestShiftSwapErrorTitle: "Oops! Something went wrong when MyPlan tried to create the swap",
swapRequestErrorMessage: "Your swap request could not be created. The system responds:",
swapperFindSwapsErrorTitle: "Oops! Something went wrong when MyPlan tried to find shifts",
syncRosterErrorTitle: "Oops! Something went wrong when MyPlan tried to save your day",
takeErrorTitle: "Oops! Something went wrong when MyPlan tried to handle the shift",
today: "Today",
unreadPlural: "unread",
unreadSingular: "unread",
updatePersonDataErrorTitle: "Oops! Something went wrong when MyPlan tried to update your information",
updatePersonDataPrivacyErrorTitle: "Oops! Something went wrong when MyPlan tried to update hide number",
updatePreferencePatternErrorTitle: "Oops! Something went wrong when MyPlan tried to update your preference pattern",},} as const;

export type Language = (typeof langMap)[LanguageCode];